var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDustControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 128.683,
    viewBox: "0 0 120 128.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #533b4c;\n      }\n\n      .cls-3 {\n        fill: #b2a49f;\n      }\n\n      .cls-4 {\n        fill: #8f837e;\n      }\n\n      .cls-5 {\n        fill: #d3c2bd;\n      }\n\n      .cls-6 {\n        fill: #998c87;\n      }\n\n      .cls-7 {\n        opacity: 0.6;\n      }\n\n      .cls-8 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-9 {\n        fill: #8c7d77;\n      }\n\n      .cls-10 {\n        fill: #f4f0e4;\n      }\n\n      .cls-11 {\n        fill: #bea987;\n      }\n\n      .cls-12 {\n        fill: #efe7d2;\n      }\n\n      .cls-13 {\n        fill: #c9b79b;\n      }\n\n      .cls-14 {\n        fill: #eadfc1;\n      }\n\n      .cls-15 {\n        fill: #decfb2;\n      }\n\n      .cls-16 {\n        fill: #f5eddc;\n      }\n\n      .cls-17 {\n        fill: #7cb4f7;\n      }\n\n      .cls-18 {\n        fill: #366496;\n      }\n\n      .cls-19 {\n        fill: #6f9fe6;\n      }\n\n      .cls-20 {\n        fill: #4173aa;\n      }\n\n      .cls-21 {\n        fill: #6490d0;\n      }\n\n      .cls-22 {\n        fill: #4b80bf;\n      }\n\n      .cls-23 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-24 {\n        fill: #814e5b;\n      }\n\n      .cls-25 {\n        fill: #7a4955;\n      }\n\n      .cls-26 {\n        fill: #4e2132;\n      }\n\n      .cls-27 {\n        fill: #3c1623;\n      }\n\n      .cls-28 {\n        fill: #a28489;\n      }\n\n      .cls-29 {\n        fill: #b5979b;\n      }\n\n      .cls-30 {\n        fill: #744753;\n      }\n\n      .cls-31 {\n        opacity: 0.5;\n      }\n\n      .cls-32 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-33 {\n        fill: #500a1e;\n      }\n\n      .cls-34 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-36 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-38 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-40 {\n        fill: #6e3f4b;\n      }\n\n      .cls-41 {\n        fill: #ecdcce;\n      }\n\n      .cls-42 {\n        clip-path: url(#clip-path-10);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-44 {\n        opacity: 0.8;\n      }\n\n      .cls-45 {\n        clip-path: url(#clip-path-12);\n      }\n\n      .cls-46 {\n        fill: #976e6f;\n      }\n\n      .cls-47 {\n        opacity: 0.9;\n      }\n\n      .cls-48 {\n        clip-path: url(#clip-path-13);\n      }\n\n      .cls-49 {\n        fill: #e6d5c6;\n      }\n\n      .cls-50 {\n        opacity: 0.4;\n      }\n\n      .cls-51 {\n        clip-path: url(#clip-path-14);\n      }\n\n      .cls-52 {\n        clip-path: url(#clip-path-15);\n      }\n\n      .cls-53 {\n        clip-path: url(#clip-path-16);\n      }\n\n      .cls-54 {\n        clip-path: url(#clip-path-17);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-56 {\n        clip-path: url(#clip-path-19);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-58 {\n        fill: #552837;\n      }\n\n      .cls-59 {\n        clip-path: url(#clip-path-21);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-61 {\n        clip-path: url(#clip-path-23);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-63 {\n        clip-path: url(#clip-path-24);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-65 {\n        clip-path: url(#clip-path-26);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-67 {\n        fill: #411928;\n      }\n\n      .cls-68 {\n        clip-path: url(#clip-path-28);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-70 {\n        clip-path: url(#clip-path-30);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-72 {\n        clip-path: url(#clip-path-32);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-74 {\n        clip-path: url(#clip-path-33);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-76 {\n        clip-path: url(#clip-path-35);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-78 {\n        clip-path: url(#clip-path-37);\n      }\n\n      .cls-79 {\n        clip-path: url(#clip-path-42);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-81 {\n        clip-path: url(#clip-path-44);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-83 {\n        clip-path: url(#clip-path-46);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-85 {\n        clip-path: url(#clip-path-48);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-87 {\n        clip-path: url(#clip-path-49);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-89 {\n        clip-path: url(#clip-path-51);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-91 {\n        clip-path: url(#clip-path-53);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-93 {\n        clip-path: url(#clip-path-55);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-95 {\n        clip-path: url(#clip-path-57);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-97 {\n        opacity: 0.7;\n      }\n\n      .cls-98 {\n        clip-path: url(#clip-path-59);\n      }\n\n      .cls-99 {\n        clip-path: url(#clip-path-60);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-101 {\n        clip-path: url(#clip-path-62);\n      }\n\n      .cls-102 {\n        clip-path: url(#clip-path-63);\n      }\n\n      .cls-103 {\n        fill: #784b57;\n      }\n\n      .cls-104 {\n        clip-path: url(#clip-path-64);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-106 {\n        opacity: 0.65;\n      }\n\n      .cls-107 {\n        clip-path: url(#clip-path-66);\n      }\n\n      .cls-108 {\n        clip-path: url(#clip-path-67);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-110 {\n        opacity: 0.55;\n      }\n\n      .cls-111 {\n        clip-path: url(#clip-path-69);\n      }\n\n      .cls-112 {\n        clip-path: url(#clip-path-70);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-114 {\n        clip-path: url(#clip-path-73);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-116 {\n        clip-path: url(#clip-path-76);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-118 {\n        clip-path: url(#clip-path-79);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-120 {\n        clip-path: url(#clip-path-82);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-122 {\n        clip-path: url(#clip-path-85);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-124 {\n        clip-path: url(#clip-path-88);\n      }\n\n      .cls-125 {\n        clip-path: url(#clip-path-89);\n      }\n\n      .cls-126 {\n        clip-path: url(#clip-path-90);\n      }\n\n      .cls-127 {\n        clip-path: url(#clip-path-91);\n      }\n\n      .cls-128 {\n        clip-path: url(#clip-path-93);\n      }\n\n      .cls-129 {\n        fill: #ffd857;\n      }\n\n      .cls-130 {\n        clip-path: url(#clip-path-94);\n      }\n\n      .cls-131 {\n        fill: #8ce8e8;\n      }\n\n      .cls-132 {\n        fill: #25b9bf;\n      }\n\n      .cls-133 {\n        opacity: 0.44;\n      }\n\n      .cls-134 {\n        clip-path: url(#clip-path-96);\n      }\n\n      .cls-135 {\n        clip-path: url(#clip-path-97);\n      }\n\n      .cls-136 {\n        fill: #a97f7f;\n      }\n\n      .cls-137 {\n        fill: #f2efe2;\n      }\n\n      .cls-138 {\n        opacity: 0.43;\n      }\n\n      .cls-139 {\n        clip-path: url(#clip-path-98);\n      }\n\n      .cls-140 {\n        fill: #efecdf;\n      }\n\n      .cls-141 {\n        clip-path: url(#clip-path-102);\n      }\n\n      .cls-142 {\n        clip-path: url(#clip-path-106);\n      }\n\n      .cls-143 {\n        clip-path: url(#clip-path-107);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-145 {\n        clip-path: url(#clip-path-108);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-147 {\n        fill: #f4f1e4;\n      }\n\n      .cls-148 {\n        clip-path: url(#clip-path-110);\n      }\n\n      .cls-149 {\n        clip-path: url(#clip-path-111);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-151 {\n        clip-path: url(#clip-path-112);\n      }\n\n      .cls-152 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-153 {\n        clip-path: url(#clip-path-115);\n      }\n\n      .cls-154 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-155 {\n        clip-path: url(#clip-path-116);\n      }\n\n      .cls-156 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-157 {\n        clip-path: url(#clip-path-119);\n      }\n\n      .cls-158 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-159 {\n        clip-path: url(#clip-path-120);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-161 {\n        clip-path: url(#clip-path-122);\n      }\n\n      .cls-162 {\n        clip-path: url(#clip-path-124);\n      }\n\n      .cls-163 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-164 {\n        clip-path: url(#clip-path-125);\n      }\n\n      .cls-165 {\n        clip-path: url(#clip-path-126);\n      }\n\n      .cls-166 {\n        clip-path: url(#clip-path-128);\n      }\n\n      .cls-167 {\n        fill: #6f424e;\n      }\n\n      .cls-168 {\n        clip-path: url(#clip-path-129);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-170 {\n        clip-path: url(#clip-path-130);\n      }\n\n      .cls-171 {\n        clip-path: url(#clip-path-134);\n      }\n\n      .cls-172 {\n        opacity: 0.48;\n      }\n\n      .cls-173 {\n        clip-path: url(#clip-path-135);\n      }\n\n      .cls-174 {\n        fill: #c17a2d;\n      }\n\n      .cls-175 {\n        clip-path: url(#clip-path-136);\n      }\n\n      .cls-176 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-177 {\n        clip-path: url(#clip-path-138);\n      }\n\n      .cls-178 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-179 {\n        clip-path: url(#clip-path-140);\n      }\n\n      .cls-180 {\n        fill: #320b16;\n      }\n\n      .cls-181 {\n        clip-path: url(#clip-path-141);\n      }\n\n      .cls-182 {\n        clip-path: url(#clip-path-142);\n      }\n\n      .cls-183 {\n        clip-path: url(#clip-path-144);\n      }\n\n      .cls-184 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-185 {\n        clip-path: url(#clip-path-146);\n      }\n\n      .cls-186 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-187 {\n        clip-path: url(#clip-path-148);\n      }\n\n      .cls-188 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-189 {\n        clip-path: url(#clip-path-149);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-191 {\n        fill: #73434f;\n      }\n\n      .cls-192 {\n        clip-path: url(#clip-path-151);\n      }\n\n      .cls-193 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-194 {\n        opacity: 0.95;\n      }\n\n      .cls-195 {\n        clip-path: url(#clip-path-153);\n      }\n\n      .cls-196 {\n        clip-path: url(#clip-path-154);\n      }\n\n      .cls-197 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-198 {\n        clip-path: url(#clip-path-156);\n      }\n\n      .cls-199 {\n        clip-path: url(#clip-path-157);\n      }\n\n      .cls-200 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-201 {\n        fill: #633442;\n      }\n\n      .cls-202 {\n        clip-path: url(#clip-path-159);\n      }\n\n      .cls-203 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-204 {\n        clip-path: url(#clip-path-161);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-206 {\n        clip-path: url(#clip-path-163);\n      }\n\n      .cls-207 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-208 {\n        clip-path: url(#clip-path-165);\n      }\n\n      .cls-209 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-210 {\n        clip-path: url(#clip-path-167);\n      }\n\n      .cls-211 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-212 {\n        clip-path: url(#clip-path-169);\n      }\n\n      .cls-213 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-214 {\n        clip-path: url(#clip-path-171);\n      }\n\n      .cls-215 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-216 {\n        clip-path: url(#clip-path-173);\n      }\n\n      .cls-217 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-218 {\n        clip-path: url(#clip-path-174);\n      }\n\n      .cls-219 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-220 {\n        fill: #8a6c73;\n      }\n\n      .cls-221 {\n        clip-path: url(#clip-path-176);\n      }\n\n      .cls-222 {\n        fill: #32000a;\n      }\n\n      .cls-223 {\n        fill: #a08387;\n      }\n\n      .cls-224 {\n        clip-path: url(#clip-path-177);\n      }\n\n      .cls-225 {\n        clip-path: url(#clip-path-181);\n      }\n\n      .cls-226 {\n        fill: #552838;\n      }\n\n      .cls-227 {\n        fill: #5c2f40;\n      }\n\n      .cls-228 {\n        clip-path: url(#clip-path-182);\n      }\n\n      .cls-229 {\n        fill: #8d5c68;\n      }\n\n      .cls-230 {\n        opacity: 0.2;\n      }\n\n      .cls-231 {\n        clip-path: url(#clip-path-183);\n      }\n\n      .cls-232 {\n        clip-path: url(#clip-path-184);\n      }\n\n      .cls-233 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-234 {\n        clip-path: url(#clip-path-186);\n      }\n\n      .cls-235 {\n        fill: #c57c2d;\n      }\n\n      .cls-236 {\n        clip-path: url(#clip-path-187);\n      }\n\n      .cls-237 {\n        clip-path: url(#clip-path-188);\n      }\n\n      .cls-238 {\n        clip-path: url(#clip-path-189);\n      }\n\n      .cls-239 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-240 {\n        opacity: 0.45;\n      }\n\n      .cls-241 {\n        clip-path: url(#clip-path-191);\n      }\n\n      .cls-242 {\n        fill: #861616;\n      }\n\n      .cls-243 {\n        fill: #fad241;\n      }\n\n      .cls-244 {\n        opacity: 0.35;\n      }\n\n      .cls-245 {\n        clip-path: url(#clip-path-192);\n      }\n\n      .cls-246 {\n        fill: #ca8530;\n      }\n\n      .cls-247 {\n        fill: #502131;\n      }\n\n      .cls-248 {\n        fill: #fdd952;\n      }\n\n      .cls-249 {\n        clip-path: url(#clip-path-194);\n      }\n\n      .cls-250 {\n        fill: #e5b33d;\n      }\n\n      .cls-251 {\n        clip-path: url(#clip-path-195);\n      }\n\n      .cls-252 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-253 {\n        clip-path: url(#clip-path-196);\n      }\n\n      .cls-254 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-255 {\n        fill: #ffe166;\n      }\n\n      .cls-256 {\n        clip-path: url(#clip-path-198);\n      }\n\n      .cls-257 {\n        fill: #ffe66f;\n      }\n\n      .cls-258 {\n        fill: #ffe97d;\n      }\n\n      .cls-259 {\n        fill: #e9bb32;\n      }\n\n      .cls-260 {\n        clip-path: url(#clip-path-199);\n      }\n\n      .cls-261 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-262 {\n        clip-path: url(#clip-path-201);\n      }\n\n      .cls-263 {\n        clip-path: url(#clip-path-202);\n      }\n\n      .cls-264 {\n        clip-path: url(#clip-path-203);\n      }\n\n      .cls-265 {\n        clip-path: url(#clip-path-205);\n      }\n\n      .cls-266 {\n        clip-path: url(#clip-path-206);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-268 {\n        fill: #603240;\n      }\n\n      .cls-269 {\n        fill: #461e2d;\n      }\n\n      .cls-270 {\n        fill: #572939;\n      }\n\n      .cls-271 {\n        clip-path: url(#clip-path-208);\n      }\n\n      .cls-272 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-273 {\n        clip-path: url(#clip-path-210);\n      }\n\n      .cls-274 {\n        fill: #58283b;\n      }\n\n      .cls-275 {\n        clip-path: url(#clip-path-211);\n      }\n\n      .cls-276 {\n        clip-path: url(#clip-path-212);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-278 {\n        clip-path: url(#clip-path-214);\n      }\n\n      .cls-279 {\n        clip-path: url(#clip-path-215);\n      }\n\n      .cls-280 {\n        fill: #552737;\n      }\n\n      .cls-281 {\n        clip-path: url(#clip-path-216);\n      }\n\n      .cls-282 {\n        fill: #623342;\n      }\n\n      .cls-283 {\n        clip-path: url(#clip-path-218);\n      }\n\n      .cls-284 {\n        clip-path: url(#clip-path-219);\n      }\n\n      .cls-285 {\n        clip-path: url(#clip-path-221);\n      }\n\n      .cls-286 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-287 {\n        clip-path: url(#clip-path-222);\n      }\n\n      .cls-288 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-289 {\n        clip-path: url(#clip-path-224);\n      }\n\n      .cls-290 {\n        clip-path: url(#clip-path-225);\n      }\n\n      .cls-291 {\n        clip-path: url(#clip-path-226);\n      }\n\n      .cls-292 {\n        clip-path: url(#clip-path-227);\n      }\n\n      .cls-293 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-294 {\n        clip-path: url(#clip-path-228);\n      }\n\n      .cls-295 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-296 {\n        fill: #b76d2c;\n      }\n\n      .cls-297 {\n        fill: #cd8830;\n      }\n\n      .cls-298 {\n        clip-path: url(#clip-path-230);\n      }\n\n      .cls-299 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-300 {\n        fill: #89696c;\n      }\n\n      .cls-301 {\n        fill: #d59838;\n      }\n\n      .cls-302 {\n        fill: #937376;\n      }\n\n      .cls-303 {\n        clip-path: url(#clip-path-232);\n      }\n\n      .cls-304 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-305 {\n        clip-path: url(#clip-path-233);\n      }\n\n      .cls-306 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-307 {\n        fill: #c0772a;\n      }\n\n      .cls-308 {\n        clip-path: url(#clip-path-235);\n      }\n\n      .cls-309 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-310 {\n        opacity: 0.33;\n      }\n\n      .cls-311 {\n        clip-path: url(#clip-path-237);\n      }\n\n      .cls-312 {\n        clip-path: url(#clip-path-238);\n      }\n\n      .cls-313 {\n        clip-path: url(#clip-path-239);\n      }\n\n      .cls-314 {\n        clip-path: url(#clip-path-240);\n      }\n\n      .cls-315 {\n        clip-path: url(#clip-path-241);\n      }\n\n      .cls-316 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-317 {\n        fill: #d0b6b3;\n      }\n\n      .cls-318 {\n        clip-path: url(#clip-path-243);\n      }\n\n      .cls-319 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-320 {\n        fill: #d7c9c2;\n      }\n\n      .cls-321 {\n        opacity: 0.85;\n      }\n\n      .cls-322 {\n        clip-path: url(#clip-path-245);\n      }\n\n      .cls-323 {\n        clip-path: url(#clip-path-246);\n      }\n\n      .cls-324 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-325 {\n        clip-path: url(#clip-path-247);\n      }\n\n      .cls-326 {\n        clip-path: url(#clip-path-248);\n      }\n\n      .cls-327 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-328 {\n        clip-path: url(#clip-path-249);\n      }\n\n      .cls-329 {\n        fill: #ffa831;\n      }\n\n      .cls-330 {\n        clip-path: url(#clip-path-250);\n      }\n\n      .cls-331 {\n        clip-path: url(#clip-path-252);\n      }\n\n      .cls-332 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-333 {\n        clip-path: url(#clip-path-254);\n      }\n\n      .cls-334 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-335 {\n        clip-path: url(#clip-path-257);\n      }\n\n      .cls-336 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-337 {\n        clip-path: url(#clip-path-258);\n      }\n\n      .cls-338 {\n        clip-path: url(#clip-path-259);\n      }\n\n      .cls-339 {\n        fill: url(#linear-gradient-84);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21316",
    "data-name": "Rectangle 21316",
    className: "cls-1",
    width: 17.013,
    height: 16.283
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22326",
    "data-name": "Rectangle 22326",
    className: "cls-1",
    width: 120,
    height: 89.692
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22065",
    "data-name": "Rectangle 22065",
    className: "cls-1",
    width: 7.686,
    height: 4.438
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59719",
    "data-name": "Path 59719",
    className: "cls-1",
    d: "M54.16,274.328l5.715-3.3a8.287,8.287,0,0,1,.115-1.4,5.543,5.543,0,0,0-1.911-.37c-2.324,0-3.919,1.845-3.919,5.071",
    transform: "translate(-54.16 -269.257)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.929,
    y1: 7.034,
    x2: -0.91,
    y2: 7.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59720",
    "data-name": "Path 59720",
    className: "cls-1",
    d: "M70.526,258.673l-5.715,3.3c-2.261,1.305-2.261,5.538,0,9.454s5.927,6.033,8.188,4.727l5.715-3.3c2.261-1.305,2.261-5.538,0-9.454-1.808-3.132-4.515-5.113-6.683-5.113a2.968,2.968,0,0,0-1.5.386",
    transform: "translate(-63.115 -258.287)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.2,
    y1: 2.138,
    x2: -0.194,
    y2: 2.138,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84515e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#6e3f4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59721",
    "data-name": "Path 59721",
    className: "cls-1",
    d: "M85.075,258.673l-4.916,2.838c1.8-1.04,6.023.988,8.312,4.655,2.416,3.871,2.445,8.043-.218,9.58l5.009-2.892c2.261-1.305,2.261-5.538,0-9.454-1.808-3.132-4.515-5.113-6.683-5.113a2.967,2.967,0,0,0-1.5.386",
    transform: "translate(-80.159 -258.287)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.381,
    y1: 2.392,
    x2: -0.374,
    y2: 2.392,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#582a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59724",
    "data-name": "Path 59724",
    className: "cls-1",
    d: "M81.911,304.114c-1.24.716-1.24,3.037,0,5.184s3.25,3.308,4.49,2.592,1.24-3.037,0-5.184c-.992-1.717-2.476-2.8-3.664-2.8a1.629,1.629,0,0,0-.825.212",
    transform: "translate(-80.981 -303.902)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.947,
    y1: 4.207,
    x2: -0.933,
    y2: 4.207,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#a57d82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e6e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22072",
    "data-name": "Rectangle 22072",
    className: "cls-1",
    width: 1.887,
    height: 0.926
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22073",
    "data-name": "Rectangle 22073",
    className: "cls-1",
    width: 2.155,
    height: 5.122
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22074",
    "data-name": "Rectangle 22074",
    className: "cls-1",
    width: 0.162,
    height: 0.584
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22075",
    "data-name": "Rectangle 22075",
    className: "cls-1",
    width: 0.899,
    height: 1.288
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22076",
    "data-name": "Rectangle 22076",
    className: "cls-1",
    width: 5.245,
    height: 7.673
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59731",
    "data-name": "Path 59731",
    className: "cls-1",
    d: "M95.514,331.419l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.311.179.179,0,0,0-.091.023",
    transform: "translate(-95.156 -331.396)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -9.47,
    y1: 28.03,
    x2: -9.369,
    y2: 28.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59733",
    "data-name": "Path 59733",
    className: "cls-1",
    d: "M91.087,316.522l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.31.181.181,0,0,0-.091.023",
    transform: "translate(-90.729 -316.499)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.023,
    y1: 29.51,
    x2: -8.921,
    y2: 29.51,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#643241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59735",
    "data-name": "Path 59735",
    className: "cls-1",
    d: "M106.2,342.7l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.31.181.181,0,0,0-.091.023",
    transform: "translate(-105.844 -342.679)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -10.554,
    y1: 26.912,
    x2: -10.453,
    y2: 26.912,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59737",
    "data-name": "Path 59737",
    className: "cls-1",
    d: "M94.363,315.315l-1.035.6c-.558.322-.558,1.367,0,2.333s1.463,1.489,2.021,1.167l1.035-.6c.558-.322.558-1.367,0-2.333a2.238,2.238,0,0,0-1.649-1.262.733.733,0,0,0-.371.1",
    transform: "translate(-92.909 -315.22)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.148,
    y1: 7.387,
    x2: -2.123,
    y2: 7.387,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59738",
    "data-name": "Path 59738",
    className: "cls-1",
    d: "M100.16,315.315l-.46.265c.558-.322,1.6.119,2.334.986a3.154,3.154,0,0,1,.5.8,3.244,3.244,0,0,0-.356-.89,2.238,2.238,0,0,0-1.649-1.262.733.733,0,0,0-.371.1",
    transform: "translate(-99.7 -315.22)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -5.145,
    y1: 20.243,
    x2: -5.093,
    y2: 20.243,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59740",
    "data-name": "Path 59740",
    className: "cls-1",
    d: "M95.514,306.736l-.255.147c-.137.079-.137.336,0,.574s.36.367.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.311.181.181,0,0,0-.091.023",
    transform: "translate(-95.156 -306.713)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -9.47,
    y1: 30.475,
    x2: -9.369,
    y2: 30.475,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59745",
    "data-name": "Path 59745",
    className: "cls-1",
    d: "M121.062,334.53c-.137.079-.137.337,0,.574a.593.593,0,0,0,.366.306,5.822,5.822,0,0,0-.192-.981Z",
    transform: "translate(-120.959 -334.43)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -18.85,
    y1: 37.058,
    x2: -18.692,
    y2: 37.058,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59747",
    "data-name": "Path 59747",
    className: "cls-1",
    d: "M116.89,343.761l-.255.147c-.137.079-.137.336,0,.574s.36.367.5.287l.255-.147c.137-.079.137-.337,0-.574a.55.55,0,0,0-.406-.311.181.181,0,0,0-.091.023",
    transform: "translate(-116.532 -343.738)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -11.636,
    y1: 26.806,
    x2: -11.534,
    y2: 26.806,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59749",
    "data-name": "Path 59749",
    className: "cls-1",
    d: "M155.561,307.768l-5.715,3.3c-2.261,1.306-2.261,5.538,0,9.454s5.927,6.033,8.188,4.727l5.715-3.3c2.261-1.305,2.261-5.538,0-9.454-1.808-3.132-4.515-5.113-6.683-5.113a2.969,2.969,0,0,0-1.5.386",
    transform: "translate(-148.15 -307.382)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.687,
    y1: 1.86,
    x2: -0.682,
    y2: 1.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59750",
    "data-name": "Path 59750",
    className: "cls-1",
    d: "M170.109,307.768l-4.916,2.838c1.8-1.04,6.023.988,8.312,4.655,2.416,3.871,2.445,8.043-.218,9.58l5.01-2.892c2.261-1.305,2.261-5.538,0-9.454-1.808-3.132-4.515-5.113-6.683-5.113a2.969,2.969,0,0,0-1.5.386",
    transform: "translate(-165.193 -307.382)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.946,
    y1: 2.077,
    x2: -0.939,
    y2: 2.077,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59753",
    "data-name": "Path 59753",
    className: "cls-1",
    d: "M166.946,353.208c-1.24.716-1.24,3.037,0,5.184s3.25,3.308,4.49,2.592,1.24-3.037,0-5.184c-.992-1.717-2.476-2.8-3.665-2.8a1.628,1.628,0,0,0-.825.211",
    transform: "translate(-166.017 -352.997)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -2.145,
    y1: 3.555,
    x2: -2.131,
    y2: 3.555,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22097",
    "data-name": "Rectangle 22097",
    className: "cls-1",
    width: 1.888,
    height: 0.926
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59760",
    "data-name": "Path 59760",
    className: "cls-1",
    d: "M180.549,380.514l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.337,0-.574a.55.55,0,0,0-.406-.311.179.179,0,0,0-.091.023",
    transform: "translate(-180.191 -380.491)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -18.086,
    y1: 23.162,
    x2: -17.985,
    y2: 23.162,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59762",
    "data-name": "Path 59762",
    className: "cls-1",
    d: "M176.121,365.616l-.255.147c-.137.079-.137.337,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.55.55,0,0,0-.406-.311.181.181,0,0,0-.091.023",
    transform: "translate(-175.763 -365.593)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -17.637,
    y1: 24.64,
    x2: -17.536,
    y2: 24.64,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59764",
    "data-name": "Path 59764",
    className: "cls-1",
    d: "M191.236,391.8l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.311.181.181,0,0,0-.091.023",
    transform: "translate(-190.879 -391.773)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -19.168,
    y1: 22.041,
    x2: -19.066,
    y2: 22.041,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59766",
    "data-name": "Path 59766",
    className: "cls-1",
    d: "M179.4,364.409l-1.035.6c-.558.322-.558,1.367,0,2.333s1.463,1.489,2.021,1.167l1.035-.6c.558-.322.558-1.367,0-2.333a2.238,2.238,0,0,0-1.649-1.262.734.734,0,0,0-.371.1",
    transform: "translate(-177.943 -364.314)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -4.268,
    y1: 6.188,
    x2: -4.243,
    y2: 6.188,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59767",
    "data-name": "Path 59767",
    className: "cls-1",
    d: "M185.195,364.409l-.46.265c.558-.322,1.6.119,2.333.986a3.143,3.143,0,0,1,.5.805,3.245,3.245,0,0,0-.356-.89,2.238,2.238,0,0,0-1.649-1.262.734.734,0,0,0-.371.1",
    transform: "translate(-184.735 -364.314)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -9.533,
    y1: 16.902,
    x2: -9.482,
    y2: 16.902,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59769",
    "data-name": "Path 59769",
    className: "cls-1",
    d: "M180.549,355.831l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.311.181.181,0,0,0-.091.023",
    transform: "translate(-180.191 -355.808)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -18.086,
    y1: 25.61,
    x2: -17.984,
    y2: 25.61,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59774",
    "data-name": "Path 59774",
    className: "cls-1",
    d: "M206.1,383.626c-.137.079-.137.336,0,.574a.592.592,0,0,0,.366.306,5.81,5.81,0,0,0-.192-.98Z",
    transform: "translate(-205.994 -383.525)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -32.296,
    y1: 30.536,
    x2: -32.138,
    y2: 30.536,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59776",
    "data-name": "Path 59776",
    className: "cls-1",
    d: "M201.924,392.856l-.255.147c-.137.079-.137.336,0,.574s.36.366.5.287l.255-.147c.137-.079.137-.336,0-.574a.551.551,0,0,0-.406-.31.179.179,0,0,0-.091.023",
    transform: "translate(-201.566 -392.833)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -20.252,
    y1: 21.94,
    x2: -20.151,
    y2: 21.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59779",
    "data-name": "Path 59779",
    className: "cls-1",
    d: "M151.7,275.851l-.8.313-5.715,3.3.8-.313a2.445,2.445,0,0,1,2.088.328l7.1,4.1a4.885,4.885,0,0,1,1.821,2.086l1.929,4a4.491,4.491,0,0,1,.478,1.9v4.194l5.715-3.3v-4.194a4.493,4.493,0,0,0-.478-1.9l-1.929-4a4.886,4.886,0,0,0-1.822-2.086l-7.1-4.1a2.957,2.957,0,0,0-1.452-.442,1.731,1.731,0,0,0-.636.115",
    transform: "translate(-145.188 -275.736)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.646,
    y1: 1.942,
    x2: -0.641,
    y2: 1.942,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#6a3b48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#5e303f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22119",
    "data-name": "Rectangle 22119",
    className: "cls-1",
    width: 18.865,
    height: 17.578
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59781",
    "data-name": "Path 59781",
    className: "cls-1",
    d: "M65.777,229.314l.029-.017-.029.017m5.714-3.3h0L65.806,229.3a1.634,1.634,0,0,1,1.612.169l7.1,4.1a6.45,6.45,0,0,1,2.088,2.084l.8,1.235,5.715-3.3-.8-1.235a6.451,6.451,0,0,0-2.088-2.084l-7.1-4.1a2.091,2.091,0,0,0-1.028-.313,1.177,1.177,0,0,0-.613.161",
    transform: "translate(-65.777 -225.854)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.391,
    y1: 3.306,
    x2: -0.384,
    y2: 3.306,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a3b48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22122",
    "data-name": "Rectangle 22122",
    className: "cls-1",
    width: 16.618,
    height: 10.416
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22123",
    "data-name": "Rectangle 22123",
    className: "cls-1",
    width: 18.094,
    height: 9.434
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59786",
    "data-name": "Path 59786",
    className: "cls-1",
    d: "M277.763,374.236l-4.843,2.8c-.262.151-.262.642,0,1.1s.687.7.949.548l4.843-2.8c.262-.151.262-.642,0-1.1a1.051,1.051,0,0,0-.775-.593.344.344,0,0,0-.174.045",
    transform: "translate(-272.723 -374.191)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -5.022,
    y1: 5.045,
    x2: -5.004,
    y2: 5.045,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22126",
    "data-name": "Rectangle 22126",
    className: "cls-1",
    width: 5.68,
    height: 4.174
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59789",
    "data-name": "Path 59789",
    className: "cls-1",
    d: "M274.385,395.3c-.175.1-.175.427,0,.73s.457.466.632.365.175-.427,0-.73a.7.7,0,0,0-.516-.395.228.228,0,0,0-.116.03",
    transform: "translate(-274.254 -395.274)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -27.259,
    y1: 20.626,
    x2: -27.159,
    y2: 20.626,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22129",
    "data-name": "Rectangle 22129",
    className: "cls-1",
    width: 0.894,
    height: 0.964
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59791",
    "data-name": "Path 59791",
    className: "cls-1",
    d: "M294.109,383.674l-4.843,2.8c-.262.152-.262.642,0,1.1s.687.7.949.548l4.843-2.8c.262-.151.262-.642,0-1.1a1.051,1.051,0,0,0-.775-.593.345.345,0,0,0-.174.045",
    transform: "translate(-289.069 -383.629)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -5.33,
    y1: 4.852,
    x2: -5.311,
    y2: 4.852,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59794",
    "data-name": "Path 59794",
    className: "cls-1",
    d: "M290.732,404.741c-.175.1-.175.427,0,.73s.457.466.632.365.174-.427,0-.73a.7.7,0,0,0-.516-.395.228.228,0,0,0-.116.03",
    transform: "translate(-290.601 -404.711)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -28.896,
    y1: 19.735,
    x2: -28.796,
    y2: 19.735,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59796",
    "data-name": "Path 59796",
    className: "cls-1",
    d: "M310.456,393.111l-4.843,2.8c-.262.151-.262.642,0,1.1s.687.7.949.548l4.843-2.8c.262-.151.262-.642,0-1.1a1.051,1.051,0,0,0-.775-.593.343.343,0,0,0-.174.045",
    transform: "translate(-305.416 -393.066)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -5.637,
    y1: 4.66,
    x2: -5.618,
    y2: 4.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59799",
    "data-name": "Path 59799",
    className: "cls-1",
    d: "M307.079,414.18c-.174.1-.174.427,0,.73s.457.466.632.365.174-.427,0-.73a.7.7,0,0,0-.516-.394.229.229,0,0,0-.116.03",
    transform: "translate(-306.948 -414.15)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -30.536,
    y1: 18.848,
    x2: -30.435,
    y2: 18.848,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59801",
    "data-name": "Path 59801",
    className: "cls-1",
    d: "M326.8,402.549l-4.843,2.8c-.262.151-.262.642,0,1.1s.687.7.949.548l4.843-2.8c.262-.151.262-.642,0-1.1a1.051,1.051,0,0,0-.774-.593.344.344,0,0,0-.174.045",
    transform: "translate(-321.762 -402.504)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -5.944,
    y1: 4.467,
    x2: -5.925,
    y2: 4.467,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59804",
    "data-name": "Path 59804",
    className: "cls-1",
    d: "M323.425,423.617c-.175.1-.175.427,0,.73s.457.466.632.365.175-.428,0-.73a.7.7,0,0,0-.516-.395.228.228,0,0,0-.116.03",
    transform: "translate(-323.294 -423.587)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -32.168,
    y1: 17.955,
    x2: -32.067,
    y2: 17.955,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22148",
    "data-name": "Rectangle 22148",
    className: "cls-1",
    width: 16.938,
    height: 9.779
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59810",
    "data-name": "Path 59810",
    className: "cls-1",
    d: "M86.835,3.491a.848.848,0,0,0-.439.784V9.49h.774V4.276s-.005-.067.008-.073a.093.093,0,0,1,.04.015l.027.015h0l1.6.921.04-.07.04-.069.04-.069L89,4.877l.042-.073.042-.073.042-.073.042-.073.029-.05.029-.05-1.6-.921,0,0a1.059,1.059,0,0,0-.493-.136.715.715,0,0,0-.3.065",
    transform: "translate(-86.396 -3.426)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22151",
    "data-name": "Rectangle 22151",
    className: "cls-1",
    width: 2.833,
    height: 6.064
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59811",
    "data-name": "Path 59811",
    className: "cls-1",
    d: "M55.344,21.672a.848.848,0,0,0-.439.784v5.216h.774V22.457s-.005-.067.008-.073a.093.093,0,0,1,.04.015l.027.015h0l1.6.921.04-.069.04-.069.04-.069.04-.069.042-.073.042-.073.042-.073.042-.073.029-.05.029-.05-1.6-.921,0,0a1.062,1.062,0,0,0-.493-.136.714.714,0,0,0-.3.065",
    transform: "translate(-54.905 -21.607)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59812",
    "data-name": "Path 59812",
    className: "cls-1",
    d: "M27.141,13.448a35.225,35.225,0,0,0-10.7,4.205,56.4,56.4,0,0,0-10.7,8.15,5.173,5.173,0,0,0-1.584,3.454V37.63a1.641,1.641,0,0,0,.679,1.5L54.84,68l1.583-1.583,20.043-22.4,1.583-1.583-50-28.87a1.176,1.176,0,0,0-.6-.153,1.593,1.593,0,0,0-.308.031",
    transform: "translate(-4.157 -13.417)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59813",
    "data-name": "Path 59813",
    className: "cls-1",
    d: "M4.157,110.009v8.373a2.537,2.537,0,0,0,.074.628l33.654,19.43a2.6,2.6,0,0,1-.054-.543v-8.373a4.624,4.624,0,0,1,.55-2.051l-33.7-19.458a4.591,4.591,0,0,0-.521,1.995",
    transform: "translate(-4.157 -108.014)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22156",
    "data-name": "Rectangle 22156",
    className: "cls-1",
    width: 51.095,
    height: 29.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22157",
    "data-name": "Rectangle 22157",
    className: "cls-1",
    width: 51.119,
    height: 29.261
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22158",
    "data-name": "Rectangle 22158",
    className: "cls-1",
    width: 0.696,
    height: 2.489
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22162",
    "data-name": "Rectangle 22162",
    className: "cls-1",
    width: 10.933,
    height: 6.312
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22166",
    "data-name": "Rectangle 22166",
    className: "cls-1",
    width: 9.192,
    height: 5.041
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59846",
    "data-name": "Path 59846",
    className: "cls-1",
    d: "M108.682,56.417c0,1.171,1.644,2.12,3.671,2.12s3.671-.949,3.671-2.12-1.644-2.12-3.671-2.12-3.671.949-3.671,2.12",
    transform: "translate(-108.682 -54.297)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -2.166,
    y1: 19.282,
    x2: -2.146,
    y2: 19.282,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#592b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#592b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4b1e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b1e2f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59847",
    "data-name": "Path 59847",
    className: "cls-1",
    d: "M103.936,44.245v.69c0,1.392,1.955,2.521,4.366,2.521s4.366-1.129,4.366-2.521v-.69c0-1.392-1.955-2.521-4.366-2.521s-4.366,1.129-4.366,2.521",
    transform: "translate(-103.936 -41.724)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -1.742,
    y1: 14.582,
    x2: -1.725,
    y2: 14.582,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.112,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#623442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22170",
    "data-name": "Rectangle 22170",
    className: "cls-1",
    width: 9.192,
    height: 5.042
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59852",
    "data-name": "Path 59852",
    className: "cls-1",
    d: "M192.1,104.58c0,1.171,1.644,2.12,3.671,2.12s3.671-.949,3.671-2.12-1.644-2.12-3.671-2.12-3.671.949-3.671,2.12",
    transform: "translate(-192.102 -102.46)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -3.829,
    y1: 17.619,
    x2: -3.809,
    y2: 17.619,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59853",
    "data-name": "Path 59853",
    className: "cls-1",
    d: "M187.357,92.408v.69c0,1.392,1.955,2.521,4.366,2.521s4.366-1.129,4.366-2.521v-.69c0-1.392-1.955-2.521-4.366-2.521s-4.366,1.129-4.366,2.521",
    transform: "translate(-187.357 -89.887)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -3.14,
    y1: 13.353,
    x2: -3.124,
    y2: 13.353,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59858",
    "data-name": "Path 59858",
    className: "cls-1",
    d: "M275.523,152.743c0,1.171,1.644,2.12,3.671,2.12s3.672-.949,3.672-2.12-1.644-2.12-3.672-2.12-3.671.949-3.671,2.12",
    transform: "translate(-275.523 -150.623)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -5.492,
    y1: 15.957,
    x2: -5.472,
    y2: 15.957,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59859",
    "data-name": "Path 59859",
    className: "cls-1",
    d: "M270.777,140.571v.69c0,1.392,1.955,2.521,4.366,2.521s4.366-1.129,4.366-2.521v-.69c0-1.392-1.955-2.521-4.366-2.521s-4.366,1.129-4.366,2.521",
    transform: "translate(-270.777 -138.05)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -4.539,
    y1: 12.123,
    x2: -4.522,
    y2: 12.123,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59864",
    "data-name": "Path 59864",
    className: "cls-1",
    d: "M358.943,200.9c0,1.171,1.644,2.12,3.672,2.12s3.671-.949,3.671-2.12-1.644-2.12-3.671-2.12-3.672.949-3.672,2.12",
    transform: "translate(-358.943 -198.785)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -7.155,
    y1: 14.294,
    x2: -7.135,
    y2: 14.294,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59865",
    "data-name": "Path 59865",
    className: "cls-1",
    d: "M354.2,188.733v.69c0,1.392,1.955,2.521,4.366,2.521s4.366-1.128,4.366-2.521v-.69c0-1.392-1.955-2.521-4.366-2.521s-4.366,1.129-4.366,2.521",
    transform: "translate(-354.198 -186.212)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -5.937,
    y1: 10.893,
    x2: -5.92,
    y2: 10.893,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22182",
    "data-name": "Rectangle 22182",
    className: "cls-1",
    width: 1.678,
    height: 0.967
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59870",
    "data-name": "Path 59870",
    className: "cls-1",
    d: "M111.38,36.312c0,.123.173.223.387.223s.387-.1.387-.223-.173-.223-.387-.223-.387.1-.387.223",
    transform: "translate(-111.38 -36.089)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -21.075,
    y1: 188.953,
    x2: -20.886,
    y2: 188.953,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bea0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#9c777d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#865c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#764955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f424e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59871",
    "data-name": "Path 59871",
    className: "cls-1",
    d: "M97.669,7.36l-.029.05-.042.073-.042.073-.042.073-.042.073-.04.069-.04.069-.04.069-.04.069,1.6.921h0a.957.957,0,0,1,.345.389.916.916,0,0,1,.118.412v2.043h.774V9.7a1.713,1.713,0,0,0-.2-.762,1.763,1.763,0,0,0-.645-.707l0,0L97.7,7.31l-.029.05",
    transform: "translate(-97.311 -7.31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22187",
    "data-name": "Rectangle 22187",
    className: "cls-1",
    width: 2.833,
    height: 4.436
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22188",
    "data-name": "Rectangle 22188",
    className: "cls-1",
    width: 0.631,
    height: 1.347
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59873",
    "data-name": "Path 59873",
    className: "cls-1",
    d: "M79.889,54.493c0,.123.173.223.387.223s.387-.1.387-.223-.173-.223-.387-.223-.387.1-.387.223",
    transform: "translate(-79.889 -54.27)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -15.113,
    y1: 183.004,
    x2: -14.924,
    y2: 183.004,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59874",
    "data-name": "Path 59874",
    className: "cls-1",
    d: "M66.179,25.541l-.029.05-.042.073-.042.073-.042.073-.042.073-.04.069-.04.069-.04.069-.04.069,1.6.921h0a.958.958,0,0,1,.345.389.916.916,0,0,1,.118.412v2.043h.774V27.882a1.717,1.717,0,0,0-.2-.762,1.766,1.766,0,0,0-.645-.707l0,0-1.6-.921-.029.05",
    transform: "translate(-65.821 -25.491)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22194",
    "data-name": "Rectangle 22194",
    className: "cls-1",
    width: 48.829,
    height: 29.16
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22195",
    "data-name": "Rectangle 22195",
    className: "cls-1",
    width: 49.844,
    height: 28.787
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59892",
    "data-name": "Path 59892",
    className: "cls-1",
    d: "M13.895,199.26c-.283.49-.283,1.02,0,1.184l31.012,17.9c.283.163.742-.1,1.025-.592s.283-1.02,0-1.184l-31.012-17.9a.371.371,0,0,0-.188-.048,1.136,1.136,0,0,0-.837.64",
    transform: "translate(-13.683 -198.62)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -0.044,
    y1: 1.827,
    x2: -0.039,
    y2: 1.827,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdb6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#dbc7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#dbc7bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#af9290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a28483"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59896",
    "data-name": "Path 59896",
    className: "cls-1",
    d: "M656.418,277.666l-1.882,1.086a.953.953,0,0,0-.431.747v5.225a.3.3,0,0,0,.127.28l.555.321,2.488-7.37-.555-.32a.223.223,0,0,0-.111-.028.389.389,0,0,0-.192.059",
    transform: "translate(-654.105 -277.607)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -11.265,
    y1: 7.363,
    x2: -11.248,
    y2: 7.363,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#754654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e4150"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22200",
    "data-name": "Rectangle 22200",
    className: "cls-1",
    width: 0.942,
    height: 0.447
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59899",
    "data-name": "Path 59899",
    className: "cls-1",
    d: "M650.5,268.66a1.057,1.057,0,0,0-.235.1l0,0-1.6.921.029.05.029.05.042.073.042.073.042.073.042.073.04.069.04.069.04.069.04.069,1.6-.921h0a.631.631,0,0,1,.064-.03h0v0a.558.558,0,0,1,.006.071V270.7h.774v-1.226a1.054,1.054,0,0,0-.029-.249.854.854,0,0,0-.124-.289.756.756,0,0,0-.228-.216.764.764,0,0,0-.3-.094l-.064,0a.83.83,0,0,0-.254.038",
    transform: "translate(-648.662 -268.622)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22203",
    "data-name": "Rectangle 22203",
    className: "cls-1",
    width: 2.833,
    height: 2.077
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59901",
    "data-name": "Path 59901",
    className: "cls-1",
    d: "M662.731,275.465c0,.123.173.223.387.223a.513.513,0,0,0,.313-.093,3.152,3.152,0,0,1-.7-1.39Z",
    transform: "translate(-662.731 -274.205)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -138.473,
    y1: 33.411,
    x2: -138.264,
    y2: 33.411,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59903",
    "data-name": "Path 59903",
    className: "cls-1",
    d: "M359.618,440.933c-2.44-.112-4.136,1.756-4.136,5.062l4.366-2.521a6.716,6.716,0,0,1,.6-2.945Z",
    transform: "translate(-355.482 -440.529)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -7.254,
    y1: 3.616,
    x2: -7.233,
    y2: 3.616,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59907",
    "data-name": "Path 59907",
    className: "cls-1",
    d: "M370.5,437.964l-4.366,2.521c-2.261,1.305-2.261,5.538,0,9.454s5.927,6.033,8.188,4.727l4.366-2.521c2.261-1.306,2.261-5.538,0-9.455-1.808-3.132-4.515-5.113-6.683-5.113a2.971,2.971,0,0,0-1.5.386",
    transform: "translate(-364.437 -437.578)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2.056,
    y1: 1.172,
    x2: -2.05,
    y2: 1.172,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59908",
    "data-name": "Path 59908",
    className: "cls-1",
    d: "M385.048,437.964l-3.567,2.06c1.8-1.04,6.023.988,8.312,4.655,2.416,3.871,2.445,8.043-.218,9.58l3.661-2.113c2.261-1.306,2.261-5.538,0-9.455-1.808-3.132-4.515-5.113-6.683-5.113a2.971,2.971,0,0,0-1.5.386",
    transform: "translate(-381.481 -437.578)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -2.569,
    y1: 1.306,
    x2: -2.562,
    y2: 1.306,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59911",
    "data-name": "Path 59911",
    className: "cls-1",
    d: "M383.234,478.085c-1.24.716-1.24,3.037,0,5.184s3.25,3.308,4.489,2.592,1.24-3.037,0-5.184c-.992-1.717-2.475-2.8-3.664-2.8a1.629,1.629,0,0,0-.825.212",
    transform: "translate(-382.305 -477.873)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -5.193,
    y1: 1.897,
    x2: -5.179,
    y2: 1.897,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22214",
    "data-name": "Rectangle 22214",
    className: "cls-1",
    width: 5.801,
    height: 7.915
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59914",
    "data-name": "Path 59914",
    className: "cls-1",
    d: "M388.569,481.087c-.921.532-.921,2.256,0,3.852s2.415,2.457,3.336,1.926l1.5-.867a6.916,6.916,0,0,0-3.336-5.777Z",
    transform: "translate(-387.878 -480.22)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -6.4,
    y1: 2.235,
    x2: -6.383,
    y2: 2.235,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22217",
    "data-name": "Rectangle 22217",
    className: "cls-1",
    width: 4.35,
    height: 6.361
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59917",
    "data-name": "Path 59917",
    className: "cls-1",
    d: "M401.792,489.818a.712.712,0,0,0,.322.558c.178.1.322.019.322-.186a.712.712,0,0,0-.322-.558.292.292,0,0,0-.144-.044c-.106,0-.178.084-.178.23",
    transform: "translate(-401.792 -489.588)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -74.425,
    y1: 18.281,
    x2: -74.24,
    y2: 18.281,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#a28283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#917172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59919",
    "data-name": "Path 59919",
    className: "cls-1",
    d: "M401.792,516.718a.713.713,0,0,0,.322.558c.178.1.322.019.322-.186a.712.712,0,0,0-.322-.558.294.294,0,0,0-.144-.044c-.106,0-.178.084-.178.23",
    transform: "translate(-401.792 -516.488)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -74.423,
    y1: 14.298,
    x2: -74.238,
    y2: 14.298,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59921",
    "data-name": "Path 59921",
    className: "cls-1",
    d: "M413.439,509.993a.712.712,0,0,0,.322.558c.178.1.322.019.322-.186a.712.712,0,0,0-.322-.558.293.293,0,0,0-.144-.044c-.106,0-.178.084-.178.23",
    transform: "translate(-413.439 -509.763)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -76.569,
    y1: 15.293,
    x2: -76.384,
    y2: 15.293,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59923",
    "data-name": "Path 59923",
    className: "cls-1",
    d: "M390.144,496.543a.711.711,0,0,0,.322.558c.178.1.322.02.322-.186a.712.712,0,0,0-.322-.558.291.291,0,0,0-.144-.044c-.106,0-.178.084-.178.23",
    transform: "translate(-390.144 -496.313)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -72.252,
    y1: 17.285,
    x2: -72.067,
    y2: 17.285,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59925",
    "data-name": "Path 59925",
    className: "cls-1",
    d: "M410.122,498.3c-.126.073-.126.308,0,.526s.33.336.456.263.126-.308,0-.526a.5.5,0,0,0-.372-.285.166.166,0,0,0-.084.021",
    transform: "translate(-410.028 -498.283)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -70.493,
    y1: 16.938,
    x2: -70.321,
    y2: 16.938,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59927",
    "data-name": "Path 59927",
    className: "cls-1",
    d: "M393.649,507.814c-.126.073-.126.308,0,.526s.33.336.456.263.126-.308,0-.526a.5.5,0,0,0-.372-.284.164.164,0,0,0-.084.021",
    transform: "translate(-393.555 -507.793)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -67.645,
    y1: 15.536,
    x2: -67.473,
    y2: 15.536,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59929",
    "data-name": "Path 59929",
    className: "cls-1",
    d: "M410.122,517.325c-.126.073-.126.308,0,.526s.33.336.456.263.126-.308,0-.526a.5.5,0,0,0-.372-.285.166.166,0,0,0-.084.021",
    transform: "translate(-410.028 -517.304)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -70.492,
    y1: 14.132,
    x2: -70.319,
    y2: 14.132,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59931",
    "data-name": "Path 59931",
    className: "cls-1",
    d: "M393.649,488.793c-.126.073-.126.308,0,.526s.33.336.456.263.126-.308,0-.526a.5.5,0,0,0-.372-.284.166.166,0,0,0-.084.021",
    transform: "translate(-393.555 -488.772)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -67.643,
    y1: 18.338,
    x2: -67.47,
    y2: 18.338,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59933",
    "data-name": "Path 59933",
    className: "cls-1",
    d: "M398.129,498.029c-.35.2-.35.858,0,1.465s.918.934,1.268.732.35-.858,0-1.465a1.4,1.4,0,0,0-1.035-.792.46.46,0,0,0-.233.06",
    transform: "translate(-397.866 -497.969)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.491,
    cy: 1.119,
    r: 0.99,
    gradientTransform: "matrix(1.249, 0, 0, -1, 7.35, 13.671)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#8b5865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59934",
    "data-name": "Path 59934",
    className: "cls-1",
    d: "M369.761,397.863l7.431,4.29a13.705,13.705,0,0,1,6.2,10.74v8.161l2.674-1.543V411.7l-2.418-1.4a13.9,13.9,0,0,0-5.924-8.462l-7.431-4.29Z",
    transform: "translate(-369.761 -397.556)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -1.969,
    y1: 1.196,
    x2: -1.963,
    y2: 1.196,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c17a2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22237",
    "data-name": "Rectangle 22237",
    className: "cls-1",
    width: 0.532,
    height: 1.449
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22238",
    "data-name": "Rectangle 22238",
    className: "cls-1",
    width: 7.777,
    height: 4.333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22242",
    "data-name": "Rectangle 22242",
    className: "cls-1",
    width: 7.246,
    height: 3.792
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22243",
    "data-name": "Rectangle 22243",
    className: "cls-1",
    width: 3.956,
    height: 9.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22244",
    "data-name": "Rectangle 22244",
    className: "cls-1",
    width: 3.956,
    height: 6.378
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59954",
    "data-name": "Path 59954",
    className: "cls-1",
    d: "M403.279,329.316v4.15a3.093,3.093,0,0,0,1.4,2.424l2.557,1.476v-.376L405,335.7a3.094,3.094,0,0,1-1.4-2.424v-4.151a1.107,1.107,0,0,1,.262-.787c-.355.088-.587.433-.587.975",
    transform: "translate(-403.279 -328.341)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -7.447,
    y1: 4.279,
    x2: -7.428,
    y2: 4.279,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22247",
    "data-name": "Rectangle 22247",
    className: "cls-1",
    width: 0.653,
    height: 1.463
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22248",
    "data-name": "Rectangle 22248",
    className: "cls-1",
    width: 8.338,
    height: 13.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22249",
    "data-name": "Rectangle 22249",
    className: "cls-1",
    width: 6.776,
    height: 7.57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59959",
    "data-name": "Path 59959",
    className: "cls-1",
    d: "M441.3,395.254l4.129,2.384a2.7,2.7,0,0,1,1,1.15l.373.774a2.7,2.7,0,0,0,1,1.15l1.314.759c.232.134.421.068.488-.125a.525.525,0,0,1-.162-.063l-1.314-.759a2.7,2.7,0,0,1-1-1.15l-.373-.774a2.7,2.7,0,0,0-1-1.15l-4.129-2.384Z",
    transform: "translate(-441.297 -395.066)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -6.068,
    y1: 3.413,
    x2: -6.054,
    y2: 3.413,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#e1a839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#fad241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe166"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22252",
    "data-name": "Rectangle 22252",
    className: "cls-1",
    width: 0.65,
    height: 0.188
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22253",
    "data-name": "Rectangle 22253",
    className: "cls-1",
    width: 3.082,
    height: 18.797
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22255",
    "data-name": "Rectangle 22255",
    className: "cls-1",
    width: 2.521,
    height: 2.911
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59971",
    "data-name": "Path 59971",
    className: "cls-1",
    d: "M502.437,503.878l.919.53h1.2l4.3-2.485-1.521-.878Z",
    transform: "translate(-502.437 -501.045)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -10.09,
    y1: 2.892,
    x2: -10.07,
    y2: 2.892,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c78731"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59972",
    "data-name": "Path 59972",
    className: "cls-1",
    d: "M629.5,430.521l1.52.878,4.3-2.485v-.7l-.919-.53Z",
    transform: "translate(-629.499 -427.688)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -13.276,
    y1: 4.621,
    x2: -13.255,
    y2: 4.621,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-198"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22259",
    "data-name": "Rectangle 22259",
    className: "cls-1",
    width: 7.283,
    height: 4.557
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60002",
    "data-name": "Path 60002",
    className: "cls-1",
    d: "M477.655,262.09v1.128a.652.652,0,0,0,.384.536l2.846,1.643a2.05,2.05,0,0,0,1.855,0l5.287-3.053a.652.652,0,0,0,.384-.538V260.68Z",
    transform: "translate(-477.655 -260.68)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -6.5,
    y1: 10.281,
    x2: -6.486,
    y2: 10.281,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22262",
    "data-name": "Rectangle 22262",
    className: "cls-1",
    width: 0.787,
    height: 0.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22263",
    "data-name": "Rectangle 22263",
    className: "cls-1",
    width: 0.959,
    height: 0.217
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-203"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22264",
    "data-name": "Rectangle 22264",
    className: "cls-1",
    width: 0.787,
    height: 0.887
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22266",
    "data-name": "Rectangle 22266",
    className: "cls-1",
    width: 23.35,
    height: 23.133
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60018",
    "data-name": "Path 60018",
    className: "cls-1",
    d: "M537.457,282.3l1.887,9.482a2.156,2.156,0,0,1-.857,2.179l-19.041,10.994a.908.908,0,0,1-.736.1.867.867,0,0,0,1.061.084l19.041-10.994a2.157,2.157,0,0,0,.857-2.179l-1.954-9.819Z",
    transform: "translate(-518.709 -282.154)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -2.33,
    y1: 1.742,
    x2: -2.325,
    y2: 1.742,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d59838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b26827"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60032",
    "data-name": "Path 60032",
    className: "cls-1",
    d: "M489.782,459.549l2.118,1.223v-5.265l-2.118-1.223Z",
    transform: "translate(-489.782 -454.284)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -33.844,
    y1: 3.576,
    x2: -33.774,
    y2: 3.576,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8b33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad241"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22271",
    "data-name": "Rectangle 22271",
    className: "cls-1",
    width: 2.118,
    height: 4.87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-211"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22272",
    "data-name": "Rectangle 22272",
    className: "cls-1",
    width: 1.725,
    height: 2.851
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60038",
    "data-name": "Path 60038",
    className: "cls-1",
    d: "M439.074,414.745v2.479l.708.408a.483.483,0,0,0,.493.046l.325-.188a.487.487,0,0,0,.2-.444v-.882a1.528,1.528,0,0,0-.692-1.2l-.708-.409Z",
    transform: "translate(-439.074 -414.557)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -21.043,
    y1: 8.052,
    x2: -20.995,
    y2: 8.052,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#814e5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411928"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22275",
    "data-name": "Rectangle 22275",
    className: "cls-1",
    width: 1.632,
    height: 4.525
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22276",
    "data-name": "Rectangle 22276",
    className: "cls-1",
    width: 24.539,
    height: 15.097
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-216"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22277",
    "data-name": "Rectangle 22277",
    className: "cls-1",
    width: 24.1,
    height: 16.568
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60044",
    "data-name": "Path 60044",
    className: "cls-1",
    d: "M472.085,435.8h-.716v1.226a1.071,1.071,0,0,0,.029.249.853.853,0,0,0,.124.29.757.757,0,0,0,.228.216.765.765,0,0,0,.3.095.854.854,0,0,0,.318-.036,1.069,1.069,0,0,0,.235-.1l0,0,1.6-.921-.04-.069-.04-.069-.04-.069-.04-.069-.042-.073-.042-.073-.042-.073-.042-.073-.029-.05-.029-.05-1.6.921h0a.572.572,0,0,1-.065.03h0v0a.57.57,0,0,1-.006-.071V435.8Z",
    transform: "translate(-471.369 -435.799)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-219"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22281",
    "data-name": "Rectangle 22281",
    className: "cls-1",
    width: 2.833,
    height: 2.083
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60046",
    "data-name": "Path 60046",
    className: "cls-1",
    d: "M487.613,438.055c-.107.062-.107.262,0,.447s.28.285.387.223.107-.262,0-.447a.429.429,0,0,0-.316-.242.139.139,0,0,0-.071.018",
    transform: "translate(-487.532 -438.037)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -79.529,
    y1: 27.037,
    x2: -79.366,
    y2: 27.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73434f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60047",
    "data-name": "Path 60047",
    className: "cls-1",
    d: "M465.055,388.148l-1.882,1.086a.953.953,0,0,0-.431.747v5.225a.3.3,0,0,0,.127.28l.555.321,2.489-7.369-.555-.32a.223.223,0,0,0-.111-.028.39.39,0,0,0-.192.059",
    transform: "translate(-462.742 -388.089)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -7.879,
    y1: 4.91,
    x2: -7.862,
    y2: 4.91,
    xlinkHref: "#linear-gradient-45"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-224"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22285",
    "data-name": "Rectangle 22285",
    className: "cls-1",
    width: 1.523,
    height: 0.724
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60050",
    "data-name": "Path 60050",
    className: "cls-1",
    d: "M472.22,369.507l0,0a1.834,1.834,0,0,0-.848,1.469V372.2h.774v-1.224a1.073,1.073,0,0,1,.462-.8h0l1.6-.921-.04-.069-.04-.069-.04-.069-.04-.069-.042-.073-.042-.073-.042-.073-.042-.073-.029-.05-.029-.05-1.6.921",
    transform: "translate(-471.369 -368.586)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-226"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22288",
    "data-name": "Rectangle 22288",
    className: "cls-1",
    width: 2.833,
    height: 3.617
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60051",
    "data-name": "Path 60051",
    className: "cls-1",
    d: "M487.613,368.479c-.107.062-.107.262,0,.447s.28.285.387.223.107-.262,0-.447a.428.428,0,0,0-.316-.241.139.139,0,0,0-.071.018",
    transform: "translate(-487.532 -368.461)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -79.535,
    y1: 37.765,
    x2: -79.372,
    y2: 37.765,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60052",
    "data-name": "Path 60052",
    className: "cls-1",
    d: "M471.369,391.993c0,.123.173.223.387.223s.387-.1.387-.223-.173-.223-.387-.223-.387.1-.387.223",
    transform: "translate(-471.369 -391.77)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -89.19,
    y1: 72.417,
    x2: -89.001,
    y2: 72.417,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60058",
    "data-name": "Path 60058",
    className: "cls-1",
    d: "M645.192,381.574l-1.724,6.135.856-.494a3.329,3.329,0,0,0,1.466-2.284l.527-4.006Z",
    transform: "translate(-643.467 -380.924)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -15.853,
    y1: 4.682,
    x2: -15.828,
    y2: 4.682,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60063",
    "data-name": "Path 60063",
    className: "cls-1",
    d: "M523.3,457.755l.527,3.4c.118.761.739,1.011,1.466.591l.857-.495-1.725-4.144Z",
    transform: "translate(-523.3 -457.106)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -15.069,
    y1: 3.993,
    x2: -15.04,
    y2: 3.993,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60064",
    "data-name": "Path 60064",
    className: "cls-1",
    d: "M523.909,457.7l1.612,3.871,1.149-.326-1.725-4.144Z",
    transform: "translate(-523.909 -457.106)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -17.813,
    y1: 4.464,
    x2: -17.779,
    y2: 4.464,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c57c2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60081",
    "data-name": "Path 60081",
    className: "cls-1",
    d: "M645.192,383.843l-1.724,6.135.564-.663,1.611-5.732Z",
    transform: "translate(-643.467 -383.583)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -13.622,
    y1: 8.411,
    x2: -13.6,
    y2: 8.411,
    xlinkHref: "#linear-gradient-75"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-237"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22301",
    "data-name": "Rectangle 22301",
    className: "cls-1",
    width: 1.62,
    height: 0.891
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22302",
    "data-name": "Rectangle 22302",
    className: "cls-1",
    width: 1.372,
    height: 0.599
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-239"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22303",
    "data-name": "Rectangle 22303",
    className: "cls-1",
    width: 0.618,
    height: 0.464
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-240"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22304",
    "data-name": "Rectangle 22304",
    className: "cls-1",
    width: 2.428,
    height: 1.228
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60090",
    "data-name": "Path 60090",
    className: "cls-1",
    d: "M458.31,320.279v.451c0,.339.476.614,1.064.614s1.063-.275,1.063-.614v-.451c0-.339-.476-.614-1.063-.614s-1.064.275-1.064.614",
    transform: "translate(-458.31 -319.665)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -31.538,
    y1: 25.547,
    x2: -31.469,
    y2: 25.547,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#73434f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4e2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e2132"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60093",
    "data-name": "Path 60093",
    className: "cls-1",
    d: "M462.175,315c-.165.285-.165.593,0,.688l.189.109c.165.1.431-.059.6-.344s.165-.593,0-.688l-.189-.109a.216.216,0,0,0-.109-.028.66.66,0,0,0-.486.372",
    transform: "translate(-462.052 -314.63)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: -40.752,
    y1: 27.431,
    x2: -40.663,
    y2: 27.431,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecdcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#f2efe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#cab6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a87f80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-245"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22310",
    "data-name": "Rectangle 22310",
    className: "cls-1",
    width: 1.905,
    height: 2.495
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60095",
    "data-name": "Path 60095",
    className: "cls-1",
    d: "M460.863,310.573c0,.268-.377.486-.841.486s-.841-.217-.841-.486l-.111,1.945c0,.3.426.55.952.55s.952-.246.952-.55Z",
    transform: "translate(-459.069 -310.573)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: -35.275,
    y1: 17.731,
    x2: -35.198,
    y2: 17.731,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb95f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#dd7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd7300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-247"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22312",
    "data-name": "Rectangle 22312",
    className: "cls-1",
    width: 1.683,
    height: 0.971
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60096",
    "data-name": "Path 60096",
    className: "cls-1",
    d: "M460.669,307.255c.374,0,.677.175.677.391s-.3.391-.677.391-.677-.175-.677-.391.3-.391.677-.391c-.465,0-.841.217-.841.486s.377.486.841.486.841-.217.841-.486-.377-.486-.841-.486",
    transform: "translate(-459.828 -307.255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -39.999,
    y1: 46.034,
    x2: -39.912,
    y2: 46.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#ffaf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#ffa825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e27b06"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22313",
    "data-name": "Rectangle 22313",
    className: "cls-1",
    width: 1.354,
    height: 0.782
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22314",
    "data-name": "Rectangle 22314",
    className: "cls-1",
    width: 1.384,
    height: 0.706
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60100",
    "data-name": "Path 60100",
    className: "cls-1",
    d: "M600.344,238.275v.451c0,.339.476.614,1.064.614s1.063-.275,1.063-.614v-.451c0-.339-.476-.614-1.063-.614s-1.064.275-1.064.614",
    transform: "translate(-600.344 -237.661)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -41.312,
    y1: 32.691,
    x2: -41.243,
    y2: 32.691,
    xlinkHref: "#linear-gradient-77"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60103",
    "data-name": "Path 60103",
    className: "cls-1",
    d: "M604.21,233c-.165.285-.165.593,0,.688l.189.109c.165.1.432-.059.6-.344s.165-.593,0-.688l-.189-.109a.216.216,0,0,0-.109-.028.66.66,0,0,0-.486.372",
    transform: "translate(-604.086 -232.626)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -53.336,
    y1: 34.947,
    x2: -53.248,
    y2: 34.947,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60105",
    "data-name": "Path 60105",
    className: "cls-1",
    d: "M602.9,228.57c0,.268-.377.486-.841.486s-.841-.217-.841-.486l-.111,1.945c0,.3.426.55.952.55s.952-.246.952-.55Z",
    transform: "translate(-601.104 -228.57)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -46.189,
    y1: 22.544,
    x2: -46.112,
    y2: 22.544,
    xlinkHref: "#linear-gradient-79"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22323",
    "data-name": "Rectangle 22323",
    className: "cls-1",
    width: 1.682,
    height: 0.971
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60106",
    "data-name": "Path 60106",
    className: "cls-1",
    d: "M602.7,225.251c.374,0,.677.175.677.391s-.3.391-.677.391-.677-.175-.677-.391.3-.391.677-.391c-.465,0-.841.217-.841.486s.377.486.841.486.841-.217.841-.486-.377-.486-.841-.486",
    transform: "translate(-601.863 -225.251)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -52.359,
    y1: 58.39,
    x2: -52.272,
    y2: 58.39,
    xlinkHref: "#linear-gradient-80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dust_Control",
    "data-name": "Dust Control",
    transform: "translate(-1251 -299.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73771",
    "data-name": "Group 73771",
    transform: "translate(1296.539 299.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72802",
    "data-name": "Group 72802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59069",
    "data-name": "Group 59069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72801",
    "data-name": "Group 72801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57985",
    "data-name": "Path 57985",
    className: "cls-2",
    d: "M94.48,44.607v59.6a.579.579,0,0,1-.343.484,1.831,1.831,0,0,1-1.658,0,.586.586,0,0,1-.343-.471V44.62Z",
    transform: "translate(-76.307 -4.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57986",
    "data-name": "Path 57986",
    className: "cls-3",
    d: "M112.056,100.25,110.2,99.182V38.187l1.852,1.069Z",
    transform: "translate(-110.204 -3.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57987",
    "data-name": "Path 57987",
    className: "cls-4",
    d: "M110.064,99.526l-1.311.757V39.289l1.311-.757Z",
    transform: "translate(-106.9 -3.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57988",
    "data-name": "Path 57988",
    className: "cls-5",
    d: "M110.6,39.175l-1.852-1.069,1.311-.758,1.852,1.069Z",
    transform: "translate(-108.752 -3.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57989",
    "data-name": "Path 57989",
    className: "cls-3",
    d: "M103.7,95.389l-1.852-1.069V33.327L103.7,34.4Z",
    transform: "translate(-94.307 -3.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57990",
    "data-name": "Path 57990",
    className: "cls-4",
    d: "M101.711,94.665l-1.311.757V34.428l1.311-.757Z",
    transform: "translate(-91.003 -3.259)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57991",
    "data-name": "Path 57991",
    className: "cls-5",
    d: "M102.251,34.314,100.4,33.245l1.311-.758,1.852,1.069Z",
    transform: "translate(-92.855 -3.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57992",
    "data-name": "Path 57992",
    className: "cls-4",
    d: "M74.538,100.166,76.39,99.1V38.1l-1.852,1.069Z",
    transform: "translate(-42.323 -3.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57993",
    "data-name": "Path 57993",
    className: "cls-3",
    d: "M76.588,99.442l1.311.757V39.205l-1.311-.758Z",
    transform: "translate(-45.685 -3.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57994",
    "data-name": "Path 57994",
    className: "cls-5",
    d: "M75.849,39.09,77.7,38.022l-1.311-.758-1.852,1.069Z",
    transform: "translate(-43.635 -3.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57995",
    "data-name": "Path 57995",
    className: "cls-4",
    d: "M82.891,95.3l1.852-1.068V33.242l-1.852,1.069Z",
    transform: "translate(-58.22 -3.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57996",
    "data-name": "Path 57996",
    className: "cls-3",
    d: "M84.941,94.581l1.311.757V34.345l-1.311-.758Z",
    transform: "translate(-61.582 -3.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57997",
    "data-name": "Path 57997",
    className: "cls-5",
    d: "M84.2,34.23l1.852-1.069L84.741,32.4l-1.851,1.069Z",
    transform: "translate(-59.531 -3.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57998",
    "data-name": "Path 57998",
    className: "cls-3",
    d: "M100.4,47.361l0,2.557,8.871,5.156,0-2.557Z",
    transform: "translate(-98.567 -4.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57999",
    "data-name": "Path 57999",
    className: "cls-4",
    d: "M76.578,52.51l0,2.557,8.93-5.156,0-2.557Z",
    transform: "translate(-53.283 -4.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58000",
    "data-name": "Path 58000",
    className: "cls-6",
    d: "M86.465,53.069l0,2.557L99.05,55.62l0-2.557Z",
    transform: "translate(-75.758 -5.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58001",
    "data-name": "Path 58001",
    className: "cls-5",
    d: "M76.576,38.729l0,7.3,8.871,5.156,12.589-.006,8.93-5.156,0-7.285L98.094,33.58l-12.588-.006Z",
    transform: "translate(-74.742 -3.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58002",
    "data-name": "Path 58002",
    className: "cls-4",
    d: "M100.4,115.132l1.852-1.069V53.069L100.4,54.138Z",
    transform: "translate(-91.544 -5.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58003",
    "data-name": "Path 58003",
    className: "cls-3",
    d: "M102.45,114.408l1.311.757V54.171l-1.311-.758Z",
    transform: "translate(-94.906 -5.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58004",
    "data-name": "Path 58004",
    className: "cls-5",
    d: "M101.711,54.056l1.852-1.069-1.311-.758L100.4,53.3Z",
    transform: "translate(-92.855 -5.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58005",
    "data-name": "Path 58005",
    className: "cls-4",
    d: "M108.753,110.271,110.6,109.2V48.208l-1.852,1.069Z",
    transform: "translate(-107.441 -4.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58006",
    "data-name": "Path 58006",
    className: "cls-3",
    d: "M110.8,109.547l1.311.757V49.311l-1.311-.758Z",
    transform: "translate(-110.803 -4.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58007",
    "data-name": "Path 58007",
    className: "cls-5",
    d: "M110.064,49.2l1.852-1.069-1.311-.758-1.852,1.069Z",
    transform: "translate(-108.752 -4.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58008",
    "data-name": "Path 58008",
    className: "cls-3",
    d: "M86.263,115.142l-1.852-1.069V53.079l1.852,1.069Z",
    transform: "translate(-61.114 -5.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58009",
    "data-name": "Path 58009",
    className: "cls-4",
    d: "M84.271,114.418l-1.311.757V54.181l1.311-.757Z",
    transform: "translate(-57.81 -5.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58010",
    "data-name": "Path 58010",
    className: "cls-5",
    d: "M84.811,54.066,82.959,53l1.311-.758,1.852,1.069Z",
    transform: "translate(-59.662 -5.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58011",
    "data-name": "Path 58011",
    className: "cls-3",
    d: "M77.91,110.281l-1.852-1.068V48.218l1.852,1.069Z",
    transform: "translate(-45.217 -4.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58012",
    "data-name": "Path 58012",
    className: "cls-4",
    d: "M75.918,109.557l-1.311.757V49.32l1.311-.757Z",
    transform: "translate(-41.913 -4.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58013",
    "data-name": "Path 58013",
    className: "cls-5",
    d: "M76.458,49.206l-1.852-1.069,1.311-.758,1.852,1.069Z",
    transform: "translate(-43.765 -4.585)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59067",
    "data-name": "Group 59067",
    className: "cls-7",
    transform: "translate(17.053 29.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59066",
    "data-name": "Group 59066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59065",
    "data-name": "Group 59065",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58014",
    "data-name": "Path 58014",
    className: "cls-9",
    d: "M79.128,33.465h1.71c.009.005,1.859-1.063,1.859-1.063l1.311.758-1.852,1.069-.736-.425L88.4,37.858l1.844-1.065,1.311.758L89.7,38.618c.006,0,.008,7.289.008,7.289l-.056.033L91.491,47l-1.311.757L88.345,46.7,84.9,48.687H74.539Z",
    transform: "translate(-74.54 -32.403)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_58015",
    "data-name": "Path 58015",
    className: "cls-10",
    d: "M105.189,7.917l.009,31.267,1.634,3.577-.009-31.268Z",
    transform: "translate(-100.45 -0.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58016",
    "data-name": "Path 58016",
    className: "cls-11",
    d: "M79.661,11.474l.009,31.267,1.675-3.576L81.335,7.9Z",
    transform: "translate(-51.906 -0.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58017",
    "data-name": "Path 58017",
    className: "cls-12",
    d: "M100.2,11.876l.009,31.267,4.5,2.6-.01-31.267Z",
    transform: "translate(-93.831 -1.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58018",
    "data-name": "Path 58018",
    className: "cls-13",
    d: "M81.515,14.473l.009,31.267,4.532-2.617-.009-31.267Z",
    transform: "translate(-58.293 -1.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58019",
    "data-name": "Path 58019",
    className: "cls-14",
    d: "M93.374,14.754l.009,31.267,6.169.958-.01-31.267Z",
    transform: "translate(-82.499 -1.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58020",
    "data-name": "Path 58020",
    className: "cls-15",
    d: "M86.533,15.712l.009,31.267,6.18-.957-.01-31.268Z",
    transform: "translate(-69.489 -1.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58021",
    "data-name": "Path 58021",
    className: "cls-16",
    d: "M79.672,7.151l1.634,3.576,4.5,2.6,6.168.958,6.18-.958,4.532-2.617,1.674-3.576-1.634-3.577-4.5-2.6L92.058,0l-6.18.958L81.346,3.575Z",
    transform: "translate(-74.933 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58022",
    "data-name": "Path 58022",
    className: "cls-17",
    d: "M105.189,35.785l.009,2.641L106.832,42l-.009-2.641Z",
    transform: "translate(-100.45 -3.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58023",
    "data-name": "Path 58023",
    className: "cls-18",
    d: "M79.661,39.342l.009,2.641,1.675-3.577-.01-2.64Z",
    transform: "translate(-51.906 -3.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58024",
    "data-name": "Path 58024",
    className: "cls-19",
    d: "M100.2,39.744l.009,2.641,4.5,2.6-.01-2.64Z",
    transform: "translate(-93.831 -3.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58025",
    "data-name": "Path 58025",
    className: "cls-20",
    d: "M81.515,42.342l.009,2.64,4.532-2.617-.009-2.64Z",
    transform: "translate(-58.293 -3.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58026",
    "data-name": "Path 58026",
    className: "cls-21",
    d: "M93.374,42.622l.009,2.64,6.169.958-.01-2.64Z",
    transform: "translate(-82.499 -4.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58027",
    "data-name": "Path 58027",
    className: "cls-22",
    d: "M86.533,43.58l.009,2.641,6.18-.958-.01-2.641Z",
    transform: "translate(-69.489 -4.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58028",
    "data-name": "Path 58028",
    className: "cls-17",
    d: "M105.189,11.9l.009,2.641,1.634,3.576-.009-2.641Z",
    transform: "translate(-100.45 -1.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58029",
    "data-name": "Path 58029",
    className: "cls-18",
    d: "M79.661,15.452l.009,2.641,1.675-3.577-.01-2.64Z",
    transform: "translate(-51.906 -1.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58030",
    "data-name": "Path 58030",
    className: "cls-19",
    d: "M100.2,15.855l.009,2.641,4.5,2.6-.01-2.64Z",
    transform: "translate(-93.831 -1.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58031",
    "data-name": "Path 58031",
    className: "cls-20",
    d: "M81.515,18.452l.009,2.64,4.532-2.617-.009-2.64Z",
    transform: "translate(-58.293 -1.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58032",
    "data-name": "Path 58032",
    className: "cls-21",
    d: "M93.374,18.732l.009,2.64,6.169.958-.01-2.64Z",
    transform: "translate(-82.499 -1.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58033",
    "data-name": "Path 58033",
    className: "cls-22",
    d: "M86.533,19.69l.009,2.64,6.18-.957-.01-2.641Z",
    transform: "translate(-69.489 -1.813)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72815",
    "data-name": "Group 72815",
    transform: "translate(1251 338.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61371",
    "data-name": "Group 61371",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59710",
    "data-name": "Path 59710",
    className: "cls-24",
    d: "M0,137.714l1.072.619L26.29,123.774l-1.072-.619Z",
    transform: "translate(0 -105.129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59711",
    "data-name": "Path 59711",
    className: "cls-25",
    d: "M0,226.7l1.072.619v-4.077L0,222.624Z",
    transform: "translate(0 -190.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59712",
    "data-name": "Path 59712",
    className: "cls-26",
    d: "M32.543,127.384v4.077L7.326,146.021v-4.077Z",
    transform: "translate(-6.253 -108.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59713",
    "data-name": "Path 59713",
    className: "cls-27",
    d: "M67.5,216.976l3.951,2.281V216.89L67.5,214.609Z",
    transform: "translate(-57.618 -183.197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59714",
    "data-name": "Path 59714",
    className: "cls-28",
    d: "M15.714,223.69v7.277l3.951,2.281v-7.277Z",
    transform: "translate(-13.414 -190.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59715",
    "data-name": "Path 59715",
    className: "cls-29",
    d: "M20.548,204.625l-4.833,2.791,3.951,2.281,4.833-2.79Z",
    transform: "translate(-13.414 -174.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59716",
    "data-name": "Path 59716",
    className: "cls-30",
    d: "M42.711,223v7.277l4.833-2.79v-7.277Z",
    transform: "translate(-36.459 -187.979)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60768",
    "data-name": "Group 60768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60767",
    "data-name": "Group 60767",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60766",
    "data-name": "Group 60766",
    className: "cls-31",
    transform: "translate(3.399 29.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60765",
    "data-name": "Group 60765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60764",
    "data-name": "Group 60764",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59717",
    "data-name": "Path 59717",
    className: "cls-33",
    d: "M26.954,204.625l-3.735,2.156,3.951,2.281,3.735-2.156Z",
    transform: "translate(-23.219 -204.625)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59718",
    "data-name": "Path 59718",
    className: "cls-27",
    d: "M272.85,333.167l-3.109-1.795v2.88l3.109,1.795Z",
    transform: "translate(-230.26 -282.87)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60770",
    "data-name": "Group 60770",
    transform: "translate(7.927 39.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60769",
    "data-name": "Group 60769",
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22067",
    "data-name": "Rectangle 22067",
    className: "cls-35",
    width: 7.585,
    height: 7.307,
    transform: "translate(-2.196 1.268) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60772",
    "data-name": "Group 60772",
    transform: "translate(9.238 37.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60771",
    "data-name": "Group 60771",
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22068",
    "data-name": "Rectangle 22068",
    className: "cls-37",
    width: 25.542,
    height: 25.816,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -8.867, 4.793)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60774",
    "data-name": "Group 60774",
    transform: "translate(11.733 37.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60773",
    "data-name": "Group 60773",
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22069",
    "data-name": "Rectangle 22069",
    className: "cls-39",
    width: 22.036,
    height: 22.803,
    transform: "translate(-7.56 4.365) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60776",
    "data-name": "Group 60776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60775",
    "data-name": "Group 60775",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59722",
    "data-name": "Path 59722",
    className: "cls-40",
    d: "M73,285.942c-2.261-3.916-5.927-6.033-8.188-4.727s-2.261,5.538,0,9.454S70.738,296.7,73,295.4s2.261-5.538,0-9.454",
    transform: "translate(-53.877 -239.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59723",
    "data-name": "Path 59723",
    className: "cls-41",
    d: "M84.083,303.115c-1.416-2.453-3.713-3.779-5.129-2.961s-1.416,3.469,0,5.922,3.713,3.779,5.129,2.961,1.416-3.469,0-5.923",
    transform: "translate(-66.491 -256.015)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60778",
    "data-name": "Group 60778",
    transform: "translate(11.853 44.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60777",
    "data-name": "Group 60777",
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22071",
    "data-name": "Rectangle 22071",
    className: "cls-43",
    width: 10.387,
    height: 11.022,
    transform: "translate(-4.079 2.176) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60795",
    "data-name": "Group 60795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60794",
    "data-name": "Group 60794",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60781",
    "data-name": "Group 60781",
    className: "cls-44",
    transform: "translate(15.771 51.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60780",
    "data-name": "Group 60780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60779",
    "data-name": "Group 60779",
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59725",
    "data-name": "Path 59725",
    className: "cls-46",
    d: "M107.752,351.936a.783.783,0,0,0,.227.525,1.512,1.512,0,0,0,1.377.367,1.574,1.574,0,0,0,.283-.253,3.031,3.031,0,0,1-1.888-.638",
    transform: "translate(-107.752 -351.936)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60784",
    "data-name": "Group 60784",
    className: "cls-47",
    transform: "translate(11.855 44.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60783",
    "data-name": "Group 60783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60782",
    "data-name": "Group 60782",
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59726",
    "data-name": "Path 59726",
    className: "cls-46",
    d: "M83.15,309.068c-.053-.084-.106-.168-.156-.256-1.093-1.894-1.222-3.922-.387-4.866a1.593,1.593,0,0,0-.684.205c-.834.482-1.1,1.691-.816,3.085a5.841,5.841,0,0,0,2.043,1.832",
    transform: "translate(-80.996 -303.946)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59727",
    "data-name": "Path 59727",
    className: "cls-49",
    d: "M88.842,303.915c-.835.944-.707,2.972.387,4.866,1.031,1.786,2.595,2.888,3.805,2.8.835-.944.707-2.972-.387-4.866-1.031-1.786-2.595-2.888-3.805-2.8",
    transform: "translate(-75.375 -259.427)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60787",
    "data-name": "Group 60787",
    className: "cls-50",
    transform: "translate(18.018 49.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60786",
    "data-name": "Group 60786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60785",
    "data-name": "Group 60785",
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59728",
    "data-name": "Path 59728",
    className: "cls-33",
    d: "M123.18,337.587H123.1l.162.584a5.441,5.441,0,0,0-.084-.584",
    transform: "translate(-123.102 -337.587)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60790",
    "data-name": "Group 60790",
    className: "cls-50",
    transform: "translate(14.241 49.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60789",
    "data-name": "Group 60789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60788",
    "data-name": "Group 60788",
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59729",
    "data-name": "Path 59729",
    className: "cls-33",
    d: "M98.175,335.911l-.244-.879H97.3l.22.794a.825.825,0,0,0,.078.184c.137.238.36.366.5.287.1-.059.127-.213.08-.386",
    transform: "translate(-97.299 -335.032)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60793",
    "data-name": "Group 60793",
    className: "cls-50",
    transform: "translate(12.924 44.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60792",
    "data-name": "Group 60792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60791",
    "data-name": "Group 60791",
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59730",
    "data-name": "Path 59730",
    className: "cls-33",
    d: "M92.816,307.728a5.285,5.285,0,0,1,.443.335,7.491,7.491,0,0,0-.612-1.35c-1.031-1.786-2.595-2.888-3.805-2.8-.835.943-.707,2.972.387,4.866.05.088.1.172.156.256a2.16,2.16,0,0,1,.779-1.612l.982,3.518a3.027,3.027,0,0,0,1.888.636,2.3,2.3,0,0,0,.51-1.247Z",
    transform: "translate(-88.299 -303.911)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60797",
    "data-name": "Group 60797",
    transform: "translate(13.928 48.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60796",
    "data-name": "Group 60796",
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22078",
    "data-name": "Rectangle 22078",
    className: "cls-55",
    width: 1.445,
    height: 1.476,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.516, 0.278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60799",
    "data-name": "Group 60799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60798",
    "data-name": "Group 60798",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59732",
    "data-name": "Path 59732",
    className: "cls-40",
    d: "M95.756,332.712c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-81.228 -283.748)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60801",
    "data-name": "Group 60801",
    transform: "translate(13.28 46.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60800",
    "data-name": "Group 60800",
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22080",
    "data-name": "Rectangle 22080",
    className: "cls-57",
    width: 1.445,
    height: 1.476,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.515, 0.278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60803",
    "data-name": "Group 60803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60802",
    "data-name": "Group 60802",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59734",
    "data-name": "Path 59734",
    className: "cls-58",
    d: "M91.329,317.815c-.137-.238-.36-.366-.5-.287s-.137.336,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-77.449 -271.032)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60805",
    "data-name": "Group 60805",
    transform: "translate(15.492 50.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60804",
    "data-name": "Group 60804",
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22082",
    "data-name": "Rectangle 22082",
    className: "cls-60",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.515 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60807",
    "data-name": "Group 60807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60806",
    "data-name": "Group 60806",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59736",
    "data-name": "Path 59736",
    className: "cls-58",
    d: "M106.444,343.995c-.137-.238-.36-.366-.5-.287s-.137.336,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-90.351 -293.38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60809",
    "data-name": "Group 60809",
    transform: "translate(13.599 46.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60808",
    "data-name": "Group 60808",
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22084",
    "data-name": "Rectangle 22084",
    className: "cls-62",
    width: 5.871,
    height: 5.996,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.095, 1.129)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60811",
    "data-name": "Group 60811",
    transform: "translate(14.593 46.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60810",
    "data-name": "Group 60810",
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22085",
    "data-name": "Rectangle 22085",
    className: "cls-64",
    width: 2.836,
    height: 2.152,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60813",
    "data-name": "Group 60813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60812",
    "data-name": "Group 60812",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59739",
    "data-name": "Path 59739",
    className: "cls-40",
    d: "M95.348,320.566c-.558-.966-1.463-1.489-2.021-1.167s-.558,1.367,0,2.333,1.463,1.489,2.021,1.167.558-1.367,0-2.333",
    transform: "translate(-79.31 -272.569)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60815",
    "data-name": "Group 60815",
    transform: "translate(13.928 44.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60814",
    "data-name": "Group 60814",
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22087",
    "data-name": "Rectangle 22087",
    className: "cls-66",
    width: 1.445,
    height: 1.476,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.516, 0.278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60817",
    "data-name": "Group 60817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60816",
    "data-name": "Group 60816",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59741",
    "data-name": "Path 59741",
    className: "cls-58",
    d: "M95.756,308.029c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-81.228 -262.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59742",
    "data-name": "Path 59742",
    className: "cls-67",
    d: "M106.448,310.072l.208-.12a6.05,6.05,0,0,0-.756-.694.517.517,0,0,0,.051.527c.137.238.36.367.5.287",
    transform: "translate(-90.355 -263.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59743",
    "data-name": "Path 59743",
    className: "cls-58",
    d: "M106.448,310.072a.252.252,0,0,0,.1-.234,5.932,5.932,0,0,0-.651-.581.517.517,0,0,0,.051.527c.137.238.36.367.5.287",
    transform: "translate(-90.355 -263.993)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59744",
    "data-name": "Path 59744",
    className: "cls-58",
    d: "M116.751,321.212q-.094-.162-.193-.316a.588.588,0,0,0,.08.475.6.6,0,0,0,.357.3c-.076-.155-.156-.309-.245-.463",
    transform: "translate(-99.479 -273.927)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60819",
    "data-name": "Group 60819",
    transform: "translate(17.704 48.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60818",
    "data-name": "Group 60818",
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22089",
    "data-name": "Rectangle 22089",
    className: "cls-69",
    width: 0.926,
    height: 1.101,
    transform: "translate(-0.459 0.245) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60821",
    "data-name": "Group 60821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60820",
    "data-name": "Group 60820",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59746",
    "data-name": "Path 59746",
    className: "cls-40",
    d: "M121.267,334.989a.226.226,0,0,0-.2,0c-.137.079-.137.336,0,.574a.593.593,0,0,0,.366.306,5.731,5.731,0,0,0-.161-.876",
    transform: "translate(-103.254 -285.935)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60823",
    "data-name": "Group 60823",
    transform: "translate(17.056 50.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60822",
    "data-name": "Group 60822",
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22091",
    "data-name": "Rectangle 22091",
    className: "cls-71",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.516 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60825",
    "data-name": "Group 60825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60824",
    "data-name": "Group 60824",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59748",
    "data-name": "Path 59748",
    className: "cls-58",
    d: "M117.132,345.053c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-99.475 -294.283)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60827",
    "data-name": "Group 60827",
    transform: "translate(21.684 44.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60826",
    "data-name": "Group 60826",
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22093",
    "data-name": "Rectangle 22093",
    className: "cls-73",
    width: 25.542,
    height: 25.816,
    transform: "translate(-8.867 4.793) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60829",
    "data-name": "Group 60829",
    transform: "translate(24.179 44.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60828",
    "data-name": "Group 60828",
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22094",
    "data-name": "Rectangle 22094",
    className: "cls-75",
    width: 22.036,
    height: 22.803,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -7.56, 4.365)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60831",
    "data-name": "Group 60831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60830",
    "data-name": "Group 60830",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59751",
    "data-name": "Path 59751",
    className: "cls-40",
    d: "M158.033,335.037c-2.261-3.916-5.927-6.033-8.188-4.727s-2.261,5.538,0,9.454,5.927,6.033,8.188,4.727,2.261-5.538,0-9.454",
    transform: "translate(-126.465 -281.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59752",
    "data-name": "Path 59752",
    className: "cls-41",
    d: "M169.118,352.21c-1.416-2.453-3.713-3.779-5.129-2.961s-1.416,3.469,0,5.922,3.713,3.779,5.129,2.961,1.416-3.469,0-5.923",
    transform: "translate(-139.08 -297.924)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60833",
    "data-name": "Group 60833",
    transform: "translate(24.299 51.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60832",
    "data-name": "Group 60832",
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22096",
    "data-name": "Rectangle 22096",
    className: "cls-77",
    width: 10.387,
    height: 11.022,
    transform: "translate(-4.079 2.176) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60850",
    "data-name": "Group 60850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60849",
    "data-name": "Group 60849",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60836",
    "data-name": "Group 60836",
    className: "cls-44",
    transform: "translate(28.218 58.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60835",
    "data-name": "Group 60835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60834",
    "data-name": "Group 60834",
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59754",
    "data-name": "Path 59754",
    className: "cls-46",
    d: "M192.786,401.031a.783.783,0,0,0,.227.525,1.512,1.512,0,0,0,1.377.366,1.568,1.568,0,0,0,.283-.252,3.032,3.032,0,0,1-1.888-.639",
    transform: "translate(-192.786 -401.031)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60839",
    "data-name": "Group 60839",
    className: "cls-47",
    transform: "translate(24.301 51.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60838",
    "data-name": "Group 60838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60837",
    "data-name": "Group 60837",
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59755",
    "data-name": "Path 59755",
    className: "cls-46",
    d: "M168.184,358.163c-.053-.084-.106-.169-.156-.256-1.093-1.894-1.222-3.922-.387-4.866a1.591,1.591,0,0,0-.684.205c-.834.482-1.1,1.691-.816,3.085a5.842,5.842,0,0,0,2.043,1.832",
    transform: "translate(-166.03 -353.041)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59756",
    "data-name": "Path 59756",
    className: "cls-49",
    d: "M173.876,353.01c-.835.944-.707,2.972.387,4.866,1.031,1.786,2.595,2.888,3.805,2.8.835-.944.707-2.972-.387-4.866-1.031-1.786-2.595-2.888-3.805-2.8",
    transform: "translate(-147.963 -301.336)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60842",
    "data-name": "Group 60842",
    className: "cls-50",
    transform: "translate(30.465 56.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60841",
    "data-name": "Group 60841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60840",
    "data-name": "Group 60840",
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59757",
    "data-name": "Path 59757",
    className: "cls-33",
    d: "M208.214,386.682h-.078l.162.584a5.435,5.435,0,0,0-.084-.584",
    transform: "translate(-208.136 -386.682)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60845",
    "data-name": "Group 60845",
    className: "cls-50",
    transform: "translate(26.688 56.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60844",
    "data-name": "Group 60844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60843",
    "data-name": "Group 60843",
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59758",
    "data-name": "Path 59758",
    className: "cls-33",
    d: "M183.21,385l-.244-.879h-.632l.22.794a.826.826,0,0,0,.078.184c.137.238.36.366.5.287.1-.058.128-.213.08-.386",
    transform: "translate(-182.334 -384.126)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60848",
    "data-name": "Group 60848",
    className: "cls-50",
    transform: "translate(25.37 51.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60847",
    "data-name": "Group 60847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60846",
    "data-name": "Group 60846",
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59759",
    "data-name": "Path 59759",
    className: "cls-33",
    d: "M177.85,356.822a5.232,5.232,0,0,1,.443.335,7.484,7.484,0,0,0-.612-1.35c-1.031-1.786-2.595-2.888-3.805-2.8-.835.944-.707,2.972.387,4.866.05.088.1.172.156.256a2.16,2.16,0,0,1,.779-1.612l.982,3.517a3.026,3.026,0,0,0,1.888.636,2.3,2.3,0,0,0,.51-1.247Z",
    transform: "translate(-173.333 -353.005)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60852",
    "data-name": "Group 60852",
    transform: "translate(26.374 55.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60851",
    "data-name": "Group 60851",
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22103",
    "data-name": "Rectangle 22103",
    className: "cls-80",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.516 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60854",
    "data-name": "Group 60854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60853",
    "data-name": "Group 60853",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59761",
    "data-name": "Path 59761",
    className: "cls-40",
    d: "M180.791,381.807c-.137-.238-.36-.366-.5-.287s-.137.336,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-153.816 -325.658)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60856",
    "data-name": "Group 60856",
    transform: "translate(25.726 53.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60855",
    "data-name": "Group 60855",
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22105",
    "data-name": "Rectangle 22105",
    className: "cls-82",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.515 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60858",
    "data-name": "Group 60858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60857",
    "data-name": "Group 60857",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59763",
    "data-name": "Path 59763",
    className: "cls-58",
    d: "M176.364,366.909c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-150.037 -312.94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60860",
    "data-name": "Group 60860",
    transform: "translate(27.938 57.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60859",
    "data-name": "Group 60859",
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22107",
    "data-name": "Rectangle 22107",
    className: "cls-84",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.516 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60862",
    "data-name": "Group 60862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60861",
    "data-name": "Group 60861",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59765",
    "data-name": "Path 59765",
    className: "cls-58",
    d: "M191.479,393.089c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-162.94 -335.288)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60864",
    "data-name": "Group 60864",
    transform: "translate(26.045 53.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60863",
    "data-name": "Group 60863",
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22109",
    "data-name": "Rectangle 22109",
    className: "cls-86",
    width: 5.871,
    height: 5.996,
    transform: "translate(-2.095 1.129) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60866",
    "data-name": "Group 60866",
    transform: "translate(27.039 53.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60865",
    "data-name": "Group 60865",
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22110",
    "data-name": "Rectangle 22110",
    className: "cls-88",
    width: 2.836,
    height: 2.152,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60868",
    "data-name": "Group 60868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60867",
    "data-name": "Group 60867",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59768",
    "data-name": "Path 59768",
    className: "cls-40",
    d: "M180.383,369.66c-.558-.967-1.463-1.489-2.021-1.167s-.558,1.367,0,2.333,1.463,1.489,2.021,1.167.558-1.367,0-2.333",
    transform: "translate(-151.899 -314.477)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60870",
    "data-name": "Group 60870",
    transform: "translate(26.374 52.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60869",
    "data-name": "Group 60869",
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22112",
    "data-name": "Rectangle 22112",
    className: "cls-90",
    width: 1.445,
    height: 1.476,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.516, 0.278)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60872",
    "data-name": "Group 60872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60871",
    "data-name": "Group 60871",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59770",
    "data-name": "Path 59770",
    className: "cls-58",
    d: "M180.791,357.124c-.137-.238-.36-.366-.5-.287s-.137.337,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-153.816 -304.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59771",
    "data-name": "Path 59771",
    className: "cls-67",
    d: "M191.482,359.167l.208-.12a6.041,6.041,0,0,0-.756-.694.518.518,0,0,0,.051.527c.137.238.36.367.5.287",
    transform: "translate(-162.944 -305.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59772",
    "data-name": "Path 59772",
    className: "cls-58",
    d: "M191.482,359.167a.252.252,0,0,0,.1-.234,5.92,5.92,0,0,0-.651-.581.518.518,0,0,0,.051.527c.137.238.36.367.5.287",
    transform: "translate(-162.944 -305.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59773",
    "data-name": "Path 59773",
    className: "cls-58",
    d: "M201.785,370.306q-.093-.162-.193-.316a.588.588,0,0,0,.08.475.6.6,0,0,0,.357.3c-.076-.155-.156-.309-.245-.463",
    transform: "translate(-172.067 -315.835)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60874",
    "data-name": "Group 60874",
    transform: "translate(30.151 56.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60873",
    "data-name": "Group 60873",
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22114",
    "data-name": "Rectangle 22114",
    className: "cls-92",
    width: 0.926,
    height: 1.101,
    transform: "translate(-0.459 0.245) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60876",
    "data-name": "Group 60876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60875",
    "data-name": "Group 60875",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59775",
    "data-name": "Path 59775",
    className: "cls-40",
    d: "M206.3,384.084a.226.226,0,0,0-.205,0c-.137.079-.137.336,0,.574a.593.593,0,0,0,.366.306,5.752,5.752,0,0,0-.161-.875",
    transform: "translate(-175.842 -327.844)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60878",
    "data-name": "Group 60878",
    transform: "translate(29.503 57.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60877",
    "data-name": "Group 60877",
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22116",
    "data-name": "Rectangle 22116",
    className: "cls-94",
    width: 1.445,
    height: 1.476,
    transform: "translate(-0.515 0.278) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60880",
    "data-name": "Group 60880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60879",
    "data-name": "Group 60879",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59777",
    "data-name": "Path 59777",
    className: "cls-58",
    d: "M202.167,394.148c-.137-.238-.36-.366-.5-.287s-.137.336,0,.574.36.366.5.287.137-.336,0-.574",
    transform: "translate(-172.064 -336.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59778",
    "data-name": "Path 59778",
    className: "cls-25",
    d: "M74.107,262.321a4.885,4.885,0,0,0-1.821-2.086l-7.1-4.1a2.444,2.444,0,0,0-2.088-.327l-.8.313-.8-1.235a6.448,6.448,0,0,0-2.088-2.084l-7.1-4.1a1.5,1.5,0,0,0-1.821-.017l-1.929,1.777a1.787,1.787,0,0,0-.478,1.345v4.194l.888.513c0-4.528,3.179-6.363,7.1-4.1a14.359,14.359,0,0,1,4.864,5.037l2.718,1.57c1.271-.648,2.981-.507,4.864.58a15.694,15.694,0,0,1,7.1,12.3l.888.513v-4.194a4.493,4.493,0,0,0-.478-1.9Z",
    transform: "translate(-41.052 -212.038)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60882",
    "data-name": "Group 60882",
    transform: "translate(21.251 40.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60881",
    "data-name": "Group 60881",
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22118",
    "data-name": "Rectangle 22118",
    className: "cls-96",
    width: 27.232,
    height: 27.267,
    transform: "translate(-8.622 4.924) rotate(-29.73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60887",
    "data-name": "Group 60887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60886",
    "data-name": "Group 60886",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60885",
    "data-name": "Group 60885",
    className: "cls-97",
    transform: "translate(22.313 40.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60884",
    "data-name": "Group 60884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60883",
    "data-name": "Group 60883",
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59780",
    "data-name": "Path 59780",
    className: "cls-26",
    d: "M170.832,286.365,168.9,282.36a4.886,4.886,0,0,0-1.822-2.086l-7.1-4.1a2.444,2.444,0,0,0-2.087-.327l-.8.314-4.653,2.686.457-.116a2.924,2.924,0,0,1,1.6.608l7.1,4.1a11.714,11.714,0,0,1,2.3,1.81l3.3,3.214a4.017,4.017,0,0,1,1.06,1.561l1.568,3.289,1.483-.856v-4.194a4.493,4.493,0,0,0-.478-1.9",
    transform: "translate(-152.445 -275.735)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60889",
    "data-name": "Group 60889",
    transform: "translate(9.628 33.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60888",
    "data-name": "Group 60888",
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22121",
    "data-name": "Rectangle 22121",
    className: "cls-100",
    width: 20.53,
    height: 18.221,
    transform: "translate(-4.776 2.757) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60897",
    "data-name": "Group 60897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60896",
    "data-name": "Group 60896",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60892",
    "data-name": "Group 60892",
    className: "cls-97",
    transform: "translate(10.347 33.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60891",
    "data-name": "Group 60891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60890",
    "data-name": "Group 60890",
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59782",
    "data-name": "Path 59782",
    className: "cls-26",
    d: "M86.514,232.347a6.447,6.447,0,0,0-2.088-2.084l-7.1-4.1a1.614,1.614,0,0,0-1.641-.152h0L70.694,228.9c.334-.084.465.034,1.156.433l7.1,4.1a16.41,16.41,0,0,1,2.346,1.7l1.368,1.145,4.653-2.686Z",
    transform: "translate(-70.694 -225.853)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59783",
    "data-name": "Path 59783",
    className: "cls-29",
    d: "M267.785,390.6l-6.824,3.94,11.269,6.507,6.824-3.94Z",
    transform: "translate(-222.765 -333.425)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60895",
    "data-name": "Group 60895",
    className: "cls-31",
    transform: "translate(38.196 57.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60894",
    "data-name": "Group 60894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60893",
    "data-name": "Group 60893",
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59784",
    "data-name": "Path 59784",
    className: "cls-33",
    d: "M279.054,397.1,267.785,390.6l-6.824,3.94h4.308l.37.214-.672.388c-.095.057.012.2.3.361a2.95,2.95,0,0,0,1.187.387.289.289,0,0,0,.142-.027l.484-.279.954.551-.672.388c-.095.056.012.2.3.361a2.95,2.95,0,0,0,1.188.387.289.289,0,0,0,.142-.027l.484-.279.954.551-.672.388c-.095.057.012.2.3.361a2.95,2.95,0,0,0,1.188.387.289.289,0,0,0,.142-.026l.484-.279.954.551-.672.388c-.094.056.012.2.3.361a2.95,2.95,0,0,0,1.188.387.289.289,0,0,0,.142-.027l.484-.279.129.075Z",
    transform: "translate(-260.961 -390.596)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59785",
    "data-name": "Path 59785",
    className: "cls-103",
    d: "M260.961,350.3v6.474l6.824-3.94v-6.474Z",
    transform: "translate(-222.765 -295.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60899",
    "data-name": "Group 60899",
    transform: "translate(39.918 54.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60898",
    "data-name": "Group 60898",
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22125",
    "data-name": "Rectangle 22125",
    className: "cls-105",
    width: 7.788,
    height: 7.173,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.073, 1.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60904",
    "data-name": "Group 60904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60903",
    "data-name": "Group 60903",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60902",
    "data-name": "Group 60902",
    className: "cls-106",
    transform: "translate(40.423 54.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60901",
    "data-name": "Group 60901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60900",
    "data-name": "Group 60900",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59787",
    "data-name": "Path 59787",
    className: "cls-67",
    d: "M281.658,374.784c-.262-.454-.687-.7-.949-.548l-4.535,2.618c.262-.151.738.065,1.064.482s.377.878.115,1.029h0l4.3-2.485c.262-.151.262-.642,0-1.1",
    transform: "translate(-276.174 -374.191)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59788",
    "data-name": "Path 59788",
    className: "cls-40",
    d: "M273.868,393.889c-.262-.454-.687-.7-.949-.548s-.262.642,0,1.1.687.7.949.548.262-.642,0-1.1",
    transform: "translate(-232.805 -335.73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60906",
    "data-name": "Group 60906",
    transform: "translate(40.142 57.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60905",
    "data-name": "Group 60905",
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22128",
    "data-name": "Rectangle 22128",
    className: "cls-109",
    width: 1.462,
    height: 1.552,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.574, 0.306)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60911",
    "data-name": "Group 60911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60910",
    "data-name": "Group 60910",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60909",
    "data-name": "Group 60909",
    className: "cls-110",
    transform: "translate(40.142 57.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60908",
    "data-name": "Group 60908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60907",
    "data-name": "Group 60907",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59790",
    "data-name": "Path 59790",
    className: "cls-67",
    d: "M274.386,395.3c-.143.083-.169.317-.077.566.283.4.774.426.837.3a.857.857,0,0,0-.128-.5c-.174-.3-.457-.466-.632-.365",
    transform: "translate(-274.255 -395.274)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60913",
    "data-name": "Group 60913",
    transform: "translate(42.31 56.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60912",
    "data-name": "Group 60912",
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22131",
    "data-name": "Rectangle 22131",
    className: "cls-113",
    width: 7.788,
    height: 7.173,
    transform: "translate(-2.073 1.159) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60918",
    "data-name": "Group 60918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60917",
    "data-name": "Group 60917",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60916",
    "data-name": "Group 60916",
    className: "cls-106",
    transform: "translate(42.815 56.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60915",
    "data-name": "Group 60915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60914",
    "data-name": "Group 60914",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59792",
    "data-name": "Path 59792",
    className: "cls-67",
    d: "M298,384.221c-.262-.454-.687-.7-.949-.548l-4.535,2.618c.262-.151.738.064,1.064.482s.377.878.115,1.029h0l4.3-2.485c.262-.151.262-.642,0-1.1",
    transform: "translate(-292.52 -383.629)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59793",
    "data-name": "Path 59793",
    className: "cls-40",
    d: "M290.214,403.325c-.262-.454-.687-.7-.949-.548s-.262.642,0,1.1.687.7.949.548.262-.642,0-1.1",
    transform: "translate(-246.758 -343.786)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60920",
    "data-name": "Group 60920",
    transform: "translate(42.535 59.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60919",
    "data-name": "Group 60919",
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22134",
    "data-name": "Rectangle 22134",
    className: "cls-115",
    width: 1.462,
    height: 1.552,
    transform: "translate(-0.574 0.306) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60925",
    "data-name": "Group 60925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60924",
    "data-name": "Group 60924",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60923",
    "data-name": "Group 60923",
    className: "cls-110",
    transform: "translate(42.535 59.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60922",
    "data-name": "Group 60922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60921",
    "data-name": "Group 60921",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59795",
    "data-name": "Path 59795",
    className: "cls-67",
    d: "M290.732,404.742c-.143.083-.169.317-.077.566.283.4.774.426.836.3a.855.855,0,0,0-.127-.5c-.175-.3-.458-.466-.632-.365",
    transform: "translate(-290.601 -404.712)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60927",
    "data-name": "Group 60927",
    transform: "translate(44.703 57.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60926",
    "data-name": "Group 60926",
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22137",
    "data-name": "Rectangle 22137",
    className: "cls-117",
    width: 7.788,
    height: 7.173,
    transform: "translate(-2.073 1.159) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60932",
    "data-name": "Group 60932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60931",
    "data-name": "Group 60931",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60930",
    "data-name": "Group 60930",
    className: "cls-106",
    transform: "translate(45.208 57.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60929",
    "data-name": "Group 60929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60928",
    "data-name": "Group 60928",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59797",
    "data-name": "Path 59797",
    className: "cls-67",
    d: "M314.351,393.659c-.262-.454-.687-.7-.949-.548l-4.535,2.618c.262-.151.738.065,1.064.482s.377.878.115,1.029h0l4.3-2.485c.262-.151.262-.642,0-1.1",
    transform: "translate(-308.867 -393.066)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59798",
    "data-name": "Path 59798",
    className: "cls-40",
    d: "M306.561,412.764c-.262-.454-.687-.7-.949-.548s-.262.642,0,1.1.687.7.949.548.262-.642,0-1.1",
    transform: "translate(-260.713 -351.843)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60934",
    "data-name": "Group 60934",
    transform: "translate(44.927 60.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60933",
    "data-name": "Group 60933",
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22140",
    "data-name": "Rectangle 22140",
    className: "cls-119",
    width: 1.462,
    height: 1.551,
    transform: "translate(-0.574 0.306) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60939",
    "data-name": "Group 60939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60938",
    "data-name": "Group 60938",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60937",
    "data-name": "Group 60937",
    className: "cls-110",
    transform: "translate(44.927 60.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60936",
    "data-name": "Group 60936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60935",
    "data-name": "Group 60935",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59800",
    "data-name": "Path 59800",
    className: "cls-67",
    d: "M307.079,414.18c-.143.083-.169.317-.077.566.283.4.774.426.836.3a.857.857,0,0,0-.127-.5c-.175-.3-.458-.466-.632-.365",
    transform: "translate(-306.948 -414.15)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60941",
    "data-name": "Group 60941",
    transform: "translate(47.096 58.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60940",
    "data-name": "Group 60940",
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22143",
    "data-name": "Rectangle 22143",
    className: "cls-121",
    width: 7.788,
    height: 7.173,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.073, 1.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60946",
    "data-name": "Group 60946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60945",
    "data-name": "Group 60945",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60944",
    "data-name": "Group 60944",
    className: "cls-106",
    transform: "translate(47.601 58.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60943",
    "data-name": "Group 60943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60942",
    "data-name": "Group 60942",
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59802",
    "data-name": "Path 59802",
    className: "cls-67",
    d: "M330.7,403.1c-.262-.454-.687-.7-.949-.548l-4.535,2.618c.262-.151.738.065,1.064.482s.377.878.115,1.029h0l4.3-2.485c.262-.151.262-.642,0-1.1",
    transform: "translate(-325.213 -402.504)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59803",
    "data-name": "Path 59803",
    className: "cls-40",
    d: "M322.908,422.2c-.262-.454-.687-.7-.949-.548s-.262.642,0,1.1.687.7.949.548.262-.642,0-1.1",
    transform: "translate(-274.666 -359.899)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60948",
    "data-name": "Group 60948",
    transform: "translate(47.32 61.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60947",
    "data-name": "Group 60947",
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22146",
    "data-name": "Rectangle 22146",
    className: "cls-123",
    width: 1.462,
    height: 1.552,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.574, 0.306)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60956",
    "data-name": "Group 60956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60955",
    "data-name": "Group 60955",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60951",
    "data-name": "Group 60951",
    className: "cls-110",
    transform: "translate(47.32 61.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60950",
    "data-name": "Group 60950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60949",
    "data-name": "Group 60949",
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59805",
    "data-name": "Path 59805",
    className: "cls-67",
    d: "M323.426,423.617c-.143.083-.169.317-.077.566.283.4.774.426.836.3a.857.857,0,0,0-.127-.5c-.175-.3-.458-.466-.632-.365",
    transform: "translate(-323.295 -423.587)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59806",
    "data-name": "Path 59806",
    className: "cls-28",
    d: "M256.057,364.787v8.132l12.7,7.335v-8.132Zm11.987,14.224L256.775,372.5V366.03l11.269,6.506Z",
    transform: "translate(-218.579 -311.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59807",
    "data-name": "Path 59807",
    className: "cls-29",
    d: "M262.88,337.87l-6.824,3.94,12.705,7.335,6.824-3.94Z",
    transform: "translate(-218.578 -288.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59808",
    "data-name": "Path 59808",
    className: "cls-30",
    d: "M342.859,391.925v8.132l6.824-3.94v-8.132Z",
    transform: "translate(-292.676 -331.197)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60954",
    "data-name": "Group 60954",
    className: "cls-31",
    transform: "translate(40.07 49.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60953",
    "data-name": "Group 60953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60952",
    "data-name": "Group 60952",
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59809",
    "data-name": "Path 59809",
    className: "cls-33",
    d: "M277.993,337.87l-4.233,2.444,12.705,7.335L290.7,345.2Z",
    transform: "translate(-273.76 -337.87)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60961",
    "data-name": "Group 60961",
    transform: "translate(12.646 0.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60960",
    "data-name": "Group 60960",
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60959",
    "data-name": "Group 60959",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60958",
    "data-name": "Group 60958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60957",
    "data-name": "Group 60957",
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22150",
    "data-name": "Rectangle 22150",
    width: 2.951,
    height: 6.112,
    transform: "translate(-0.07 -0.035)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60966",
    "data-name": "Group 60966",
    transform: "translate(8.036 3.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60965",
    "data-name": "Group 60965",
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60964",
    "data-name": "Group 60964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60963",
    "data-name": "Group 60963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60962",
    "data-name": "Group 60962",
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22152",
    "data-name": "Rectangle 22152",
    width: 2.881,
    height: 6.112,
    transform: "translate(-0.027 -0.026)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60968",
    "data-name": "Group 60968",
    transform: "translate(0.608 1.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60967",
    "data-name": "Group 60967",
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22154",
    "data-name": "Rectangle 22154",
    className: "cls-129",
    width: 84.22,
    height: 91.286,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -23.637, 40.94)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60970",
    "data-name": "Group 60970",
    transform: "translate(0.608 15.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60969",
    "data-name": "Group 60969",
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22155",
    "data-name": "Rectangle 22155",
    className: "cls-129",
    width: 43.461,
    height: 44.852,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -13.175, 22.819)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61005",
    "data-name": "Group 61005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61004",
    "data-name": "Group 61004",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59814",
    "data-name": "Path 59814",
    className: "cls-131",
    d: "M251.507,269.149a3.038,3.038,0,0,0-2.595,3.309,5.736,5.736,0,0,0,2.595,4.494c1.433.827,2.595.157,2.595-1.5s-.738-3.788-2.595-6.305",
    transform: "translate(-212.479 -229.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59815",
    "data-name": "Path 59815",
    className: "cls-132",
    d: "M251.507,270.2a12.942,12.942,0,0,1,1.356,2.489,6.423,6.423,0,0,1,.5,2.335c0,1.18-.832,1.661-1.854,1.07a4.1,4.1,0,0,1-1.854-3.211,2.934,2.934,0,0,1,.5-1.759,2.571,2.571,0,0,1,1.356-.923m0-1.054a3.038,3.038,0,0,0-2.595,3.309,5.736,5.736,0,0,0,2.595,4.494c1.433.827,2.595.157,2.595-1.5s-.738-3.788-2.595-6.305",
    transform: "translate(-212.479 -229.754)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72816",
    "data-name": "Group 72816",
    transform: "translate(0.608 22.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59819",
    "data-name": "Path 59819",
    className: "cls-132",
    d: "M4.157,159.6v.874l20.692,11.946v-.874Z",
    transform: "translate(-4.157 -159.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78924",
    "data-name": "Path 78924",
    className: "cls-132",
    d: "M4.157,159.6v.874l20.692,11.946v-.874Z",
    transform: "translate(8.766 -152.144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72817",
    "data-name": "Group 72817",
    transform: "translate(0.608 20.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59819-2",
    "data-name": "Path 59819",
    className: "cls-132",
    d: "M4.157,159.6v.874l20.692,11.946v-.874Z",
    transform: "translate(-4.157 -159.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78924-2",
    "data-name": "Path 78924",
    className: "cls-132",
    d: "M4.157,159.6v.874l20.692,11.946v-.874Z",
    transform: "translate(8.766 -152.144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60973",
    "data-name": "Group 60973",
    className: "cls-133",
    transform: "translate(20.3 2.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60972",
    "data-name": "Group 60972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60971",
    "data-name": "Group 60971",
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59821",
    "data-name": "Path 59821",
    className: "cls-33",
    d: "M188.694,46.438q.549-.177,1.091-.33l-50-28.87q-.542.153-1.091.33Z",
    transform: "translate(-138.69 -17.238)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60976",
    "data-name": "Group 60976",
    className: "cls-133",
    transform: "translate(18.959 2.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60975",
    "data-name": "Group 60975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60974",
    "data-name": "Group 60974",
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59822",
    "data-name": "Path 59822",
    className: "cls-33",
    d: "M179.532,49.257q.56-.208,1.115-.391l-50-28.87q-.554.183-1.115.391l50,28.87Z",
    transform: "translate(-129.528 -19.996)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59823",
    "data-name": "Path 59823",
    className: "cls-136",
    d: "M143.162,9.53v.787l.433-.25V9.28Z",
    transform: "translate(-122.208 -7.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59824",
    "data-name": "Path 59824",
    className: "cls-136",
    d: "M184.7,33.515V34.3l.433-.25v-.787Z",
    transform: "translate(-157.67 -28.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59825",
    "data-name": "Path 59825",
    className: "cls-136",
    d: "M226.247,57.5v.787l.433-.25v-.787Z",
    transform: "translate(-193.132 -48.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59826",
    "data-name": "Path 59826",
    className: "cls-136",
    d: "M267.79,81.484v.787l.433-.25v-.787Z",
    transform: "translate(-228.594 -69.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59827",
    "data-name": "Path 59827",
    className: "cls-136",
    d: "M309.332,105.468v.787l.433-.25v-.787Z",
    transform: "translate(-264.056 -89.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59828",
    "data-name": "Path 59828",
    className: "cls-136",
    d: "M350.875,129.453v.787l.433-.25V129.2Z",
    transform: "translate(-299.518 -110.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59829",
    "data-name": "Path 59829",
    className: "cls-136",
    d: "M392.417,153.437v.787l.433-.25v-.787Z",
    transform: "translate(-334.98 -130.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59830",
    "data-name": "Path 59830",
    className: "cls-136",
    d: "M433.96,177.422v.787l.433-.25v-.787Z",
    transform: "translate(-370.442 -151.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59831",
    "data-name": "Path 59831",
    className: "cls-136",
    d: "M475.5,197.491v1.36l.433-.25v-1.36Z",
    transform: "translate(-405.904 -168.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59832",
    "data-name": "Path 59832",
    className: "cls-41",
    d: "M133.87,1.706v1.36l1.36.785V3.065l4.72,2.725v.787l1.36.785V6.575l4.72,2.725v.787l1.36.785v-.787l4.72,2.725V13.6l1.36.785V13.6l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-1.36Z",
    transform: "translate(-114.275 -1.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59833",
    "data-name": "Path 59833",
    className: "cls-137",
    d: "M183.874,29.119l-50-28.87L134.3,0l50,28.87Z",
    transform: "translate(-114.276 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59834",
    "data-name": "Path 59834",
    className: "cls-136",
    d: "M59.586,17.6v2.087l10.237-5.91V11.692Z",
    transform: "translate(-50.864 -9.98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59835",
    "data-name": "Path 59835",
    className: "cls-41",
    d: "M129.527,11.692v2.087l48.108,27.775V39.467Z",
    transform: "translate(-110.569 -9.981)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60979",
    "data-name": "Group 60979",
    className: "cls-138",
    transform: "translate(18.959 1.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60978",
    "data-name": "Group 60978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60977",
    "data-name": "Group 60977",
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59836",
    "data-name": "Path 59836",
    className: "cls-33",
    d: "M129.527,11.692v2.087l.7.4Z",
    transform: "translate(-129.527 -11.692)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60982",
    "data-name": "Group 60982",
    className: "cls-138",
    transform: "translate(31.169 8.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60981",
    "data-name": "Group 60981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60980",
    "data-name": "Group 60980",
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59837",
    "data-name": "Path 59837",
    className: "cls-33",
    d: "M212.948,59.855v2.087l.7.4Z",
    transform: "translate(-212.948 -59.855)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60985",
    "data-name": "Group 60985",
    className: "cls-138",
    transform: "translate(43.379 15.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60984",
    "data-name": "Group 60984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60983",
    "data-name": "Group 60983",
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59838",
    "data-name": "Path 59838",
    className: "cls-33",
    d: "M296.368,108.017V110.1l.7.4Z",
    transform: "translate(-296.368 -108.017)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60988",
    "data-name": "Group 60988",
    className: "cls-138",
    transform: "translate(55.589 22.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60987",
    "data-name": "Group 60987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60986",
    "data-name": "Group 60986",
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59839",
    "data-name": "Path 59839",
    className: "cls-33",
    d: "M379.789,156.18v2.087l.7.4Z",
    transform: "translate(-379.789 -156.18)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59840",
    "data-name": "Path 59840",
    className: "cls-140",
    d: "M107.694,59.637,59.586,31.862l10.237-5.91,48.108,27.775Z",
    transform: "translate(-50.864 -22.153)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60991",
    "data-name": "Group 60991",
    className: "cls-133",
    transform: "translate(8.721 3.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60990",
    "data-name": "Group 60990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60989",
    "data-name": "Group 60989",
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59841",
    "data-name": "Path 59841",
    className: "cls-33",
    d: "M69.348,27.273l-.211-.122,1.382-.8-.7-.4-10.237,5.91.7.4,2.98-1.72h1.314a.326.326,0,0,0,.163-.609l-.211-.122,3.343-1.93h1.314a.326.326,0,0,0,.163-.609",
    transform: "translate(-59.586 -25.951)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60994",
    "data-name": "Group 60994",
    className: "cls-133",
    transform: "translate(20.931 10.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60993",
    "data-name": "Group 60993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60992",
    "data-name": "Group 60992",
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59842",
    "data-name": "Path 59842",
    className: "cls-33",
    d: "M143.7,80.426l-.7-.4,10.237-5.91.7.4Z",
    transform: "translate(-143.006 -74.114)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60997",
    "data-name": "Group 60997",
    className: "cls-133",
    transform: "translate(33.142 17.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60996",
    "data-name": "Group 60996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60995",
    "data-name": "Group 60995",
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59843",
    "data-name": "Path 59843",
    className: "cls-33",
    d: "M227.122,128.589l-.7-.4,10.237-5.91.7.4Z",
    transform: "translate(-226.427 -122.277)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61000",
    "data-name": "Group 61000",
    className: "cls-133",
    transform: "translate(45.352 24.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60999",
    "data-name": "Group 60999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60998",
    "data-name": "Group 60998",
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59844",
    "data-name": "Path 59844",
    className: "cls-33",
    d: "M310.543,176.751l-.7-.4,10.237-5.911.7.4Z",
    transform: "translate(-309.847 -170.439)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61003",
    "data-name": "Group 61003",
    className: "cls-133",
    transform: "translate(15.712 7.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61002",
    "data-name": "Group 61002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61001",
    "data-name": "Group 61001",
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59845",
    "data-name": "Path 59845",
    className: "cls-33",
    d: "M112.173,51.557h-.46c-2.411,0-4.366,1.129-4.366,2.521S109.3,56.6,111.713,56.6h.46c2.411,0,4.366-1.129,4.366-2.521s-1.955-2.521-4.366-2.521",
    transform: "translate(-107.347 -51.557)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61007",
    "data-name": "Group 61007",
    transform: "translate(15.908 7.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61006",
    "data-name": "Group 61006",
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22168",
    "data-name": "Rectangle 22168",
    className: "cls-144",
    width: 7.343,
    height: 4.239,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61009",
    "data-name": "Group 61009",
    transform: "translate(15.213 6.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61008",
    "data-name": "Group 61008",
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22169",
    "data-name": "Rectangle 22169",
    className: "cls-146",
    width: 8.732,
    height: 5.732,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61014",
    "data-name": "Group 61014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61013",
    "data-name": "Group 61013",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59848",
    "data-name": "Path 59848",
    className: "cls-24",
    d: "M108.3,41.724c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521,4.366-1.129,4.366-2.521-1.955-2.521-4.366-2.521",
    transform: "translate(-88.723 -35.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59849",
    "data-name": "Path 59849",
    className: "cls-136",
    d: "M143.006,65.765v2.087l10.237-5.91V59.854Z",
    transform: "translate(-122.075 -51.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59850",
    "data-name": "Path 59850",
    className: "cls-147",
    d: "M138,62.877l.732.423,10.237-5.91-.732-.423Z",
    transform: "translate(-117.805 -48.628)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61012",
    "data-name": "Group 61012",
    className: "cls-133",
    transform: "translate(27.922 14.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61011",
    "data-name": "Group 61011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61010",
    "data-name": "Group 61010",
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59851",
    "data-name": "Path 59851",
    className: "cls-33",
    d: "M195.593,99.719h-.46c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521h.46c2.411,0,4.366-1.129,4.366-2.521s-1.955-2.521-4.366-2.521",
    transform: "translate(-190.767 -99.719)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61016",
    "data-name": "Group 61016",
    transform: "translate(28.118 14.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61015",
    "data-name": "Group 61015",
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22172",
    "data-name": "Rectangle 22172",
    className: "cls-150",
    width: 7.343,
    height: 4.239,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61018",
    "data-name": "Group 61018",
    transform: "translate(27.423 13.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61017",
    "data-name": "Group 61017",
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22173",
    "data-name": "Rectangle 22173",
    className: "cls-152",
    width: 8.732,
    height: 5.732,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61023",
    "data-name": "Group 61023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61022",
    "data-name": "Group 61022",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59854",
    "data-name": "Path 59854",
    className: "cls-24",
    d: "M191.722,89.887c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521,4.366-1.129,4.366-2.521-1.955-2.521-4.366-2.521",
    transform: "translate(-159.933 -76.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59855",
    "data-name": "Path 59855",
    className: "cls-136",
    d: "M226.427,113.927v2.087l10.237-5.91v-2.087Z",
    transform: "translate(-193.285 -92.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59856",
    "data-name": "Path 59856",
    className: "cls-147",
    d: "M221.425,111.04l.732.423,10.237-5.91-.732-.423Z",
    transform: "translate(-189.015 -89.742)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61021",
    "data-name": "Group 61021",
    className: "cls-133",
    transform: "translate(40.132 21.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61020",
    "data-name": "Group 61020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61019",
    "data-name": "Group 61019",
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59857",
    "data-name": "Path 59857",
    className: "cls-33",
    d: "M279.014,147.882h-.46c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521h.46c2.411,0,4.366-1.129,4.366-2.521s-1.955-2.521-4.366-2.521",
    transform: "translate(-274.188 -147.882)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61025",
    "data-name": "Group 61025",
    transform: "translate(40.328 22.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61024",
    "data-name": "Group 61024",
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22176",
    "data-name": "Rectangle 22176",
    className: "cls-154",
    width: 7.343,
    height: 4.239,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61027",
    "data-name": "Group 61027",
    transform: "translate(39.633 20.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61026",
    "data-name": "Group 61026",
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22177",
    "data-name": "Rectangle 22177",
    className: "cls-156",
    width: 8.732,
    height: 5.732,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61032",
    "data-name": "Group 61032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61031",
    "data-name": "Group 61031",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59860",
    "data-name": "Path 59860",
    className: "cls-24",
    d: "M275.143,138.05c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521,4.366-1.129,4.366-2.521-1.955-2.521-4.366-2.521",
    transform: "translate(-231.144 -117.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59861",
    "data-name": "Path 59861",
    className: "cls-136",
    d: "M309.847,162.09v2.087l10.237-5.91V156.18Z",
    transform: "translate(-264.495 -133.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59862",
    "data-name": "Path 59862",
    className: "cls-147",
    d: "M304.845,159.2l.732.423,10.237-5.911-.732-.423Z",
    transform: "translate(-260.226 -130.855)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61030",
    "data-name": "Group 61030",
    className: "cls-133",
    transform: "translate(52.342 28.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61029",
    "data-name": "Group 61029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61028",
    "data-name": "Group 61028",
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59863",
    "data-name": "Path 59863",
    className: "cls-33",
    d: "M362.434,196.045h-.46c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521h.46c2.411,0,4.366-1.129,4.366-2.521s-1.955-2.521-4.366-2.521",
    transform: "translate(-357.608 -196.045)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61034",
    "data-name": "Group 61034",
    transform: "translate(52.538 29.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61033",
    "data-name": "Group 61033",
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22180",
    "data-name": "Rectangle 22180",
    className: "cls-158",
    width: 7.343,
    height: 4.239,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61036",
    "data-name": "Group 61036",
    transform: "translate(51.843 27.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61035",
    "data-name": "Group 61035",
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22181",
    "data-name": "Rectangle 22181",
    className: "cls-160",
    width: 8.732,
    height: 5.732
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61044",
    "data-name": "Group 61044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61043",
    "data-name": "Group 61043",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59866",
    "data-name": "Path 59866",
    className: "cls-24",
    d: "M358.563,186.212c-2.411,0-4.366,1.129-4.366,2.521s1.955,2.521,4.366,2.521,4.366-1.129,4.366-2.521-1.955-2.521-4.366-2.521",
    transform: "translate(-302.354 -158.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59867",
    "data-name": "Path 59867",
    className: "cls-147",
    d: "M108.77,33.084l-50-28.87L46.633,11.219l50,28.87h0Zm-12.133,5.91L48.529,11.219l10.237-5.91,48.108,27.775Z",
    transform: "translate(-39.807 -3.597)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61039",
    "data-name": "Group 61039",
    className: "cls-133",
    transform: "translate(10.594 5.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61038",
    "data-name": "Group 61038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61037",
    "data-name": "Group 61037",
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59868",
    "data-name": "Path 59868",
    className: "cls-33",
    d: "M72.379,34.751l.95.546.727-.42-.948-.547Z",
    transform: "translate(-72.379 -34.33)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61042",
    "data-name": "Group 61042",
    className: "cls-133",
    transform: "translate(15.203 2.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61041",
    "data-name": "Group 61041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61040",
    "data-name": "Group 61040",
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59869",
    "data-name": "Path 59869",
    className: "cls-33",
    d: "M103.87,16.57l.95.546.727-.42-.948-.547Z",
    transform: "translate(-103.87 -16.149)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61046",
    "data-name": "Group 61046",
    transform: "translate(16.302 5.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61045",
    "data-name": "Group 61045",
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22185",
    "data-name": "Rectangle 22185",
    className: "cls-163",
    width: 0.774,
    height: 0.447,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61051",
    "data-name": "Group 61051",
    transform: "translate(14.243 1.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61050",
    "data-name": "Group 61050",
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61049",
    "data-name": "Group 61049",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61048",
    "data-name": "Group 61048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61047",
    "data-name": "Group 61047",
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22186",
    "data-name": "Rectangle 22186",
    width: 2.951,
    height: 4.496,
    transform: "translate(-0.051 -0.041)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61056",
    "data-name": "Group 61056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61055",
    "data-name": "Group 61055",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61054",
    "data-name": "Group 61054",
    className: "cls-44",
    transform: "translate(16.302 4.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61053",
    "data-name": "Group 61053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61052",
    "data-name": "Group 61052",
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59872",
    "data-name": "Path 59872",
    className: "cls-167",
    d: "M111.766,31.283a.583.583,0,0,0,.244-.05,1.766,1.766,0,0,1-.631-1.3V31.06c0,.123.173.223.387.223",
    transform: "translate(-111.379 -29.936)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61058",
    "data-name": "Group 61058",
    transform: "translate(11.693 7.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61057",
    "data-name": "Group 61057",
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22190",
    "data-name": "Rectangle 22190",
    className: "cls-169",
    width: 0.774,
    height: 0.447,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61063",
    "data-name": "Group 61063",
    transform: "translate(9.634 3.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61062",
    "data-name": "Group 61062",
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61061",
    "data-name": "Group 61061",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61060",
    "data-name": "Group 61060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61059",
    "data-name": "Group 61059",
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22191",
    "data-name": "Rectangle 22191",
    width: 2.881,
    height: 4.496,
    transform: "translate(-0.009 -0.033)",
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61074",
    "data-name": "Group 61074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61073",
    "data-name": "Group 61073",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61066",
    "data-name": "Group 61066",
    className: "cls-44",
    transform: "translate(11.693 7.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61065",
    "data-name": "Group 61065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61064",
    "data-name": "Group 61064",
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59875",
    "data-name": "Path 59875",
    className: "cls-167",
    d: "M80.276,49.464a.583.583,0,0,0,.244-.05,1.766,1.766,0,0,1-.631-1.3v1.124c0,.123.173.223.387.223",
    transform: "translate(-79.889 -48.117)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59876",
    "data-name": "Path 59876",
    className: "cls-41",
    d: "M96.636,83.643v-2.7l-50-28.87v2.7Z",
    transform: "translate(-39.807 -44.451)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61069",
    "data-name": "Group 61069",
    className: "cls-138",
    transform: "translate(8.001 10.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61068",
    "data-name": "Group 61068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61067",
    "data-name": "Group 61067",
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59877",
    "data-name": "Path 59877",
    className: "cls-33",
    d: "M103.492,97.7V96.73L54.663,68.538v.969Z",
    transform: "translate(-54.663 -68.538)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61072",
    "data-name": "Group 61072",
    className: "cls-172",
    transform: "translate(6.986 11.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61071",
    "data-name": "Group 61071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61070",
    "data-name": "Group 61070",
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59878",
    "data-name": "Path 59878",
    className: "cls-33",
    d: "M91.649,100.96l.447-.111h0l4.565,2.635-.291.2.454.262q.372-.3.746-.6h0L48.741,75.161c-.221.052-.427.106-.612.161l-.4.279,1.36.785.447-.111L54.1,78.911l-.291.2,1.36.785.447-.111h0l4.565,2.635-.291.2,1.36.785.447-.111h0l4.565,2.635-.291.2,1.36.785.447-.111h0l4.565,2.635-.291.2,1.36.785.447-.111h0l4.565,2.635-.291.2,1.36.785.447-.111h0L84.5,96.463l-.291.2,1.36.785.447-.111h0l4.565,2.635-.291.2Z",
    transform: "translate(-47.726 -75.161)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59879",
    "data-name": "Path 59879",
    className: "cls-174",
    d: "M345.79,226.5v8.373c0,1.152.636,1.812,1.584,1.625a35.224,35.224,0,0,0,10.7-4.205,56.4,56.4,0,0,0,10.7-8.15,5.174,5.174,0,0,0,1.584-3.454v-8.373c0-1.152-.636-1.812-1.584-1.625a35.229,35.229,0,0,0-10.7,4.205,56.4,56.4,0,0,0-10.7,8.15,5.173,5.173,0,0,0-1.584,3.454",
    transform: "translate(-295.178 -179.825)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59880",
    "data-name": "Path 59880",
    className: "cls-136",
    d: "M394.332,207.039a39.891,39.891,0,0,1,6.067-2.883v-2.7l-12.133,7v2.7a51.979,51.979,0,0,1,6.066-4.122",
    transform: "translate(-331.436 -171.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59881",
    "data-name": "Path 59881",
    className: "cls-46",
    d: "M48.628,64.11V64.9l.433-.25V63.86Z",
    transform: "translate(-41.51 -54.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59882",
    "data-name": "Path 59882",
    className: "cls-46",
    d: "M90.17,88.095v.787l.433-.25v-.787Z",
    transform: "translate(-76.972 -74.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59883",
    "data-name": "Path 59883",
    className: "cls-46",
    d: "M131.712,112.079v.787l.433-.25v-.787Z",
    transform: "translate(-112.434 -95.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59884",
    "data-name": "Path 59884",
    className: "cls-46",
    d: "M173.255,136.064v.787l.433-.25v-.787Z",
    transform: "translate(-147.896 -115.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59885",
    "data-name": "Path 59885",
    className: "cls-46",
    d: "M214.8,160.048v.787l.433-.25V159.8Z",
    transform: "translate(-183.358 -136.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59886",
    "data-name": "Path 59886",
    className: "cls-46",
    d: "M256.34,184.033v.787l.433-.25v-.787Z",
    transform: "translate(-218.82 -156.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59887",
    "data-name": "Path 59887",
    className: "cls-46",
    d: "M297.883,208.017v.787l.433-.25v-.787Z",
    transform: "translate(-254.282 -177.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59888",
    "data-name": "Path 59888",
    className: "cls-46",
    d: "M339.425,232v.787l.433-.25v-.787Z",
    transform: "translate(-289.744 -197.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59889",
    "data-name": "Path 59889",
    className: "cls-136",
    d: "M380.967,252.071v1.36l.433-.25v-1.36Z",
    transform: "translate(-325.206 -214.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59890",
    "data-name": "Path 59890",
    className: "cls-41",
    d: "M39.335,56.286v1.36l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725V75.2l1.36.785V75.2l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-.787l4.72,2.725v.787l1.36.785v-1.36Z",
    transform: "translate(-33.577 -48.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59891",
    "data-name": "Path 59891",
    className: "cls-137",
    d: "M89.338,83.7l-50-28.87.433-.25,50,28.87Z",
    transform: "translate(-33.577 -46.591)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61076",
    "data-name": "Group 61076",
    transform: "translate(2.003 29.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61075",
    "data-name": "Group 61075",
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22197",
    "data-name": "Rectangle 22197",
    className: "cls-176",
    width: 33.529,
    height: 38.181,
    transform: "translate(-8.684 14.919) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61078",
    "data-name": "Group 61078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61077",
    "data-name": "Group 61077",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59893",
    "data-name": "Path 59893",
    className: "cls-136",
    d: "M225.77,321.586c.283-.49.742-.755,1.025-.592s.283.693,0,1.184-.742.755-1.025.592-.283-.694,0-1.184",
    transform: "translate(-192.543 -273.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59894",
    "data-name": "Path 59894",
    className: "cls-27",
    d: "M383.281,434.134l-3.109-1.795v2.88l3.109,1.795Z",
    transform: "translate(-324.528 -369.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59895",
    "data-name": "Path 59895",
    className: "cls-26",
    d: "M649.05,328.933l-.387-.67,1.6-.921a1.075,1.075,0,0,0,.463-.8v-1.223h.774v1.223a1.827,1.827,0,0,1-.85,1.472Z",
    transform: "translate(-553.72 -277.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61080",
    "data-name": "Group 61080",
    transform: "translate(95.74 40.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61079",
    "data-name": "Group 61079",
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22199",
    "data-name": "Rectangle 22199",
    className: "cls-178",
    width: 8.272,
    height: 6.59,
    transform: "matrix(0.498, -0.867, 0.867, 0.498, -3.331, 5.807)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61085",
    "data-name": "Group 61085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61084",
    "data-name": "Group 61084",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61083",
    "data-name": "Group 61083",
    className: "cls-31",
    transform: "translate(97.389 41.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61082",
    "data-name": "Group 61082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61081",
    "data-name": "Group 61081",
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59897",
    "data-name": "Path 59897",
    className: "cls-180",
    d: "M666.316,281.287h-.942v.447h.168Z",
    transform: "translate(-665.374 -281.287)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59898",
    "data-name": "Path 59898",
    className: "cls-26",
    d: "M660.209,279.854l-1.882,1.086a.952.952,0,0,0-.431.747v5.225c0,.275.193.386.431.249l1.882-1.086a.953.953,0,0,0,.431-.747V280.1c0-.275-.193-.386-.431-.249",
    transform: "translate(-561.601 -238.842)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61090",
    "data-name": "Group 61090",
    transform: "translate(94.943 39.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61089",
    "data-name": "Group 61089",
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61088",
    "data-name": "Group 61088",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61087",
    "data-name": "Group 61087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61086",
    "data-name": "Group 61086",
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22202",
    "data-name": "Rectangle 22202",
    width: 2.881,
    height: 2.178,
    transform: "translate(-0.027 -0.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAfCAIAAAD1IXMRAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKaADAAQAAAABAAAAHwAAAADNietDAAADaUlEQVRIDcWWu24TQRSGvRev46egoEIyokgkUlPQUNIECVG4AEGBC1oqFCQKKKgiKBECSmgRDwBCFkKKRAXPEe/Fy3fmzO6OZ218S8Jobe/Ozpxvzv+fmSQoy7Lzn1p8itzPbz78/nnM5cW8fufg4pUBl9cfnEreULm80N4j7PsvDt3ObdkelUxoUy5pZRSFUShNkR5+czbaHj16XOcBqphO87zI8zwIJCyFFIYB4CiKYhYRRTqY7FX/TdhQ1VqNBSQDmIOeZrNsFhHHId+9pJskCRrolOdfPnKzdq25IkMFmAm5yAvbsqwIgg6CE5288zzsduOgE3Q6QdKNNXtWT+pr5O1SiQsKnoLrFXBDb9kRwZEBFIaDTPjE0U6vhwDIoMavlLcnMkGhpugrDY81bxGAV6oq3zDEhtL28Mg4NIiCgIBcS9ge1VgrQGQmv4zU+UiT1UiyrUYfYxGAMXLlRZSI60vYrsjEJQdyra3lRvFEdNNt0cUABkjSccSkeCr7jmHz/XapDGImUIrIVDHLlyaLIJIUVWlKqQ1tesgby/t98bu/01O2r7knMlSiV5XM0gVcUQsOEXFVathvg6u7x9/Gda+6ztyybIh2w+kgzgou8DwiFKg0y05O0kmaTVJaxmcy4VukF3PhttrB6O6nP+PB/u7MG6kE86H+q7Kwq3BFVntMHRlPEVaKGcElYxIX5DwquQK+vL83Q20e/IXGZOkejShcYUwlq6mGyivU2IhqUja7jpWIS6bFZKx3UorNZlVrIUsnEltqNU2n6De53hrdc3v+ed/sw5A/rsbaYpJlExqOWlO5yXFawLQFVKxdHVwZbdcWc7xdGFz69f0HENn6JCoGm2IuOJl9k3TeMmtt9NZP6QaUWnv48tlw7xoqs4OlrAQth5Q7zo1y+O7V4oJyBy64r9K3e+zG8HaawmZTpeTMpLlg3T8bgOdGs+ybD4ZqrVnTHJ0ReS1rWylTYkhpC17fNmfLk7dHrQnSARWRn75/Pfftqp1S3eYAdPDNCYeSYNyDkOHbWlstTTeW0dPZY9Vb+cXO+nFja+sIS2+avBlK6iCPv463VXgBlopzi26GzRQ5KEYLpm7Rjdr6j5S4XrWm1qqeM/mVdK3RC/w+E6wJaqtbdlnTzilvC2z0lo7zY9dVVi/gL5vR/QVQu02GAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61092",
    "data-name": "Group 61092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61091",
    "data-name": "Group 61091",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22204",
    "data-name": "Rectangle 22204",
    width: 3.074,
    height: 2.342,
    transform: "translate(94.846 39.195)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAFaADAAQAAAABAAAAEAAAAADjM79EAAAA8ElEQVQ4EbWSTQrCMBCFjQgKIoiiIiKmRXCvG+sh9KxuvYNXkN4kvldimiYmNQUHHvPDzMdMG6GU6qXaLT9Je+b+epZ2LlKgLswCDRDngD9YY9JqERhnt1AG5VAFjW7aAptrEIFG2PYQ3DQCHFsQbid1zngC+edHYMIaNpvp2oqwj5nzIzD2riFu4sIkap6Ja3aUXrUuTBES9A04qtuaUeibDkMw/IgZEbgs+MCr853Tdw5QIucb3MAbi0HtTZeY8E4FbG9IPwZ99mGwhCu0zvBU0QWIucaTuiCXEE9dwHc286RSCbFvWp2fCmzr/wv0DRbYP6ARMq06AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59900",
    "data-name": "Path 59900",
    className: "cls-26",
    d: "M663.118,281.288c-.214,0-.387.1-.387.223s.173.223.387.223.387-.1.387-.223-.173-.223-.387-.223",
    transform: "translate(-565.729 -240.116)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61094",
    "data-name": "Group 61094",
    transform: "translate(97.002 40.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61093",
    "data-name": "Group 61093",
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22206",
    "data-name": "Rectangle 22206",
    className: "cls-184",
    width: 0.701,
    height: 1.483,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61096",
    "data-name": "Group 61096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61095",
    "data-name": "Group 61095",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59902",
    "data-name": "Path 59902",
    className: "cls-26",
    d: "M416.7,227.185l-2.418-12.154L396.572,204.8l-23.179,13.382v11.989L393.8,241.958l22.9-13.222Zm-2.369-1.51-1.314-.758a2.694,2.694,0,0,1-1-1.15l-.373-.774a2.7,2.7,0,0,0-1-1.15l-4.129-2.384v-7.382l5.56,3.21a2.569,2.569,0,0,1,1.109,1.631l1.652,8.3c.084.424-.161.649-.5.455",
    transform: "translate(-318.74 -174.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61098",
    "data-name": "Group 61098",
    transform: "translate(52.031 64.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61097",
    "data-name": "Group 61097",
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22208",
    "data-name": "Rectangle 22208",
    className: "cls-186",
    width: 7.03,
    height: 7.215,
    transform: "translate(-2.367 1.366) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61100",
    "data-name": "Group 61100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61099",
    "data-name": "Group 61099",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59904",
    "data-name": "Path 59904",
    className: "cls-25",
    d: "M351.085,425.1l3.313,1.913v.749c-2.44-.112-4.136,1.756-4.136,5.062l-.9-.517v-5.666Z",
    transform: "translate(-298.231 -362.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59905",
    "data-name": "Path 59905",
    className: "cls-24",
    d: "M361.1,420.836l1.267-.732v1.463Z",
    transform: "translate(-308.249 -358.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59906",
    "data-name": "Path 59906",
    className: "cls-26",
    d: "M383.737,438.92l.7-.344-.7-.406Z",
    transform: "translate(-327.57 -374.037)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61102",
    "data-name": "Group 61102",
    transform: "translate(53.342 64.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61101",
    "data-name": "Group 61101",
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22210",
    "data-name": "Rectangle 22210",
    className: "cls-188",
    width: 23.985,
    height: 24.467,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -8.53, 4.598)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61104",
    "data-name": "Group 61104",
    transform: "translate(55.836 64.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61103",
    "data-name": "Group 61103",
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22211",
    "data-name": "Rectangle 22211",
    className: "cls-190",
    width: 20.479,
    height: 21.454,
    transform: "translate(-7.223 4.17) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61106",
    "data-name": "Group 61106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61105",
    "data-name": "Group 61105",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59909",
    "data-name": "Path 59909",
    className: "cls-191",
    d: "M374.321,459.913c-2.261-3.916-5.927-6.033-8.188-4.727s-2.261,5.538,0,9.454,5.927,6.033,8.188,4.727,2.261-5.538,0-9.454",
    transform: "translate(-311.095 -388.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59910",
    "data-name": "Path 59910",
    className: "cls-41",
    d: "M385.406,477.086c-1.416-2.453-3.713-3.779-5.129-2.961s-1.416,3.469,0,5.922,3.713,3.779,5.129,2.961,1.416-3.469,0-5.922",
    transform: "translate(-323.71 -404.522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61108",
    "data-name": "Group 61108",
    transform: "translate(55.957 69.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61107",
    "data-name": "Group 61107",
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22213",
    "data-name": "Rectangle 22213",
    className: "cls-193",
    width: 10.387,
    height: 11.022,
    transform: "translate(-4.079 2.176) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61113",
    "data-name": "Group 61113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61112",
    "data-name": "Group 61112",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61111",
    "data-name": "Group 61111",
    className: "cls-194",
    transform: "translate(55.957 69.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61110",
    "data-name": "Group 61110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61109",
    "data-name": "Group 61109",
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59912",
    "data-name": "Path 59912",
    className: "cls-46",
    d: "M384.307,482.783c-1.093-1.893-1.222-3.92-.387-4.864h0a1.592,1.592,0,0,0-.684.205c-.834.482-1.1,1.691-.816,3.085a6.2,6.2,0,0,0,1.661,1.613,6.5,6.5,0,0,0,.325.645,4.254,4.254,0,0,0,3.047,2.367,1.82,1.82,0,0,0,.452-.056,1.582,1.582,0,0,0,.2-.2c-1.21.088-2.771-1.013-3.8-2.8",
    transform: "translate(-382.307 -477.917)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59913",
    "data-name": "Path 59913",
    className: "cls-136",
    d: "M390.164,477.886c-.835.944-.707,2.972.387,4.866,1.031,1.786,2.595,2.888,3.805,2.8.835-.944.707-2.972-.387-4.866-1.031-1.786-2.595-2.888-3.805-2.8",
    transform: "translate(-332.593 -407.935)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61115",
    "data-name": "Group 61115",
    transform: "translate(56.773 70.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61114",
    "data-name": "Group 61114",
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22216",
    "data-name": "Rectangle 22216",
    className: "cls-197",
    width: 8.615,
    height: 9.117,
    transform: "translate(-3.338 1.794) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61120",
    "data-name": "Group 61120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61119",
    "data-name": "Group 61119",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61118",
    "data-name": "Group 61118",
    className: "cls-194",
    transform: "translate(57.955 70.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61117",
    "data-name": "Group 61117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61116",
    "data-name": "Group 61116",
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59915",
    "data-name": "Path 59915",
    className: "cls-46",
    d: "M399.379,482.68a6.312,6.312,0,0,0-2.41-2.46l-1.01.584c.921-.532,2.415.33,3.336,1.926s.921,3.32,0,3.852L400.3,486a6.311,6.311,0,0,0-.925-3.317",
    transform: "translate(-395.958 -480.22)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59916",
    "data-name": "Path 59916",
    className: "cls-41",
    d: "M391.906,487.154c-.921-1.6-2.414-2.458-3.336-1.926s-.921,2.256,0,3.852,2.414,2.458,3.336,1.926.921-2.256,0-3.852",
    transform: "translate(-331.106 -414.073)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61122",
    "data-name": "Group 61122",
    transform: "translate(58.809 71.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61121",
    "data-name": "Group 61121",
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22219",
    "data-name": "Rectangle 22219",
    className: "cls-200",
    width: 0.789,
    height: 0.989,
    transform: "translate(-0.152 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61124",
    "data-name": "Group 61124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61123",
    "data-name": "Group 61123",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59918",
    "data-name": "Path 59918",
    className: "cls-201",
    d: "M403.551,489.71a.046.046,0,1,0-.076.044.712.712,0,0,0,.322.558.355.355,0,0,0,.068.031.363.363,0,0,0,.008-.074.712.712,0,0,0-.322-.558",
    transform: "translate(-344.419 -418.006)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61126",
    "data-name": "Group 61126",
    transform: "translate(58.809 75.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61125",
    "data-name": "Group 61125",
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22221",
    "data-name": "Rectangle 22221",
    className: "cls-203",
    width: 0.789,
    height: 0.989,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.152, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61128",
    "data-name": "Group 61128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61127",
    "data-name": "Group 61127",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59920",
    "data-name": "Path 59920",
    className: "cls-201",
    d: "M403.551,516.61a.35.35,0,0,0-.068-.031.367.367,0,0,0-.007.075.712.712,0,0,0,.322.558.356.356,0,0,0,.068.031.36.36,0,0,0,.008-.074.712.712,0,0,0-.322-.558",
    transform: "translate(-344.419 -440.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61130",
    "data-name": "Group 61130",
    transform: "translate(60.514 74.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61129",
    "data-name": "Group 61129",
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22223",
    "data-name": "Rectangle 22223",
    className: "cls-205",
    width: 0.789,
    height: 0.989,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.152, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61132",
    "data-name": "Group 61132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61131",
    "data-name": "Group 61131",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59922",
    "data-name": "Path 59922",
    className: "cls-201",
    d: "M415.2,509.885a.373.373,0,0,0-.068-.031.357.357,0,0,0-.008.075.712.712,0,0,0,.322.558.046.046,0,1,0,.076-.044.712.712,0,0,0-.322-.558",
    transform: "translate(-354.362 -435.228)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61134",
    "data-name": "Group 61134",
    transform: "translate(57.104 72.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61133",
    "data-name": "Group 61133",
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22225",
    "data-name": "Rectangle 22225",
    className: "cls-207",
    width: 0.789,
    height: 0.989,
    transform: "translate(-0.152 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61136",
    "data-name": "Group 61136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61135",
    "data-name": "Group 61135",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59924",
    "data-name": "Path 59924",
    className: "cls-201",
    d: "M391.9,496.435a.371.371,0,0,0-.068-.031.361.361,0,0,0-.008.074.712.712,0,0,0,.322.558.36.36,0,0,0,.068.031.351.351,0,0,0,.008-.075.712.712,0,0,0-.322-.558",
    transform: "translate(-334.475 -423.746)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61138",
    "data-name": "Group 61138",
    transform: "translate(60.015 72.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61137",
    "data-name": "Group 61137",
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22227",
    "data-name": "Rectangle 22227",
    className: "cls-209",
    width: 0.85,
    height: 0.993,
    transform: "translate(-0.183 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61140",
    "data-name": "Group 61140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61139",
    "data-name": "Group 61139",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59926",
    "data-name": "Path 59926",
    className: "cls-201",
    d: "M411.721,498.377a.666.666,0,1,0,.3.271.588.588,0,0,0-.3-.271",
    transform: "translate(-351.452 -425.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61142",
    "data-name": "Group 61142",
    transform: "translate(57.604 74.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61141",
    "data-name": "Group 61141",
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22229",
    "data-name": "Rectangle 22229",
    className: "cls-211",
    width: 0.85,
    height: 0.993,
    transform: "translate(-0.183 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61144",
    "data-name": "Group 61144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61143",
    "data-name": "Group 61143",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59928",
    "data-name": "Path 59928",
    className: "cls-201",
    d: "M395.249,507.887a.666.666,0,1,0,.3.271.588.588,0,0,0-.3-.271",
    transform: "translate(-337.391 -433.549)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61146",
    "data-name": "Group 61146",
    transform: "translate(60.015 75.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61145",
    "data-name": "Group 61145",
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22231",
    "data-name": "Rectangle 22231",
    className: "cls-213",
    width: 0.85,
    height: 0.993,
    transform: "translate(-0.183 0.027) rotate(-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61148",
    "data-name": "Group 61148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61147",
    "data-name": "Group 61147",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59930",
    "data-name": "Path 59930",
    className: "cls-201",
    d: "M411.721,517.4a.666.666,0,1,0,.3.271.588.588,0,0,0-.3-.271",
    transform: "translate(-351.452 -441.668)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61150",
    "data-name": "Group 61150",
    transform: "translate(57.604 71.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61149",
    "data-name": "Group 61149",
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22233",
    "data-name": "Rectangle 22233",
    className: "cls-215",
    width: 0.85,
    height: 0.993,
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -0.183, 0.027)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61152",
    "data-name": "Group 61152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61151",
    "data-name": "Group 61151",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59932",
    "data-name": "Path 59932",
    className: "cls-201",
    d: "M395.249,488.866a.666.666,0,1,0,.3.271.588.588,0,0,0-.3-.271",
    transform: "translate(-337.391 -417.312)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61154",
    "data-name": "Group 61154",
    transform: "translate(58.235 72.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61153",
    "data-name": "Group 61153",
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22235",
    "data-name": "Rectangle 22235",
    className: "cls-217",
    width: 1.969,
    height: 2.459,
    transform: "translate(-0.088)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61156",
    "data-name": "Group 61156",
    transform: "translate(54.121 58.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61155",
    "data-name": "Group 61155",
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22236",
    "data-name": "Rectangle 22236",
    className: "cls-219",
    width: 25.222,
    height: 28.346,
    transform: "matrix(0.89, -0.456, 0.456, 0.89, -9.532, 4.88)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61182",
    "data-name": "Group 61182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61181",
    "data-name": "Group 61181",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59935",
    "data-name": "Path 59935",
    className: "cls-220",
    d: "M466.525,548.193v1.142l5.256,3.035v-1.142Z",
    transform: "translate(-398.241 -467.955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61159",
    "data-name": "Group 61159",
    className: "cls-50",
    transform: "translate(68.284 80.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61158",
    "data-name": "Group 61158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61157",
    "data-name": "Group 61157",
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59936",
    "data-name": "Path 59936",
    className: "cls-222",
    d: "M466.525,548.193v1.142l.532.307V548.5Z",
    transform: "translate(-466.525 -548.193)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59937",
    "data-name": "Path 59937",
    className: "cls-223",
    d: "M466.525,539.7l2.521-1.456,5.256,3.035-2.521,1.455Z",
    transform: "translate(-398.241 -459.467)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61162",
    "data-name": "Group 61162",
    className: "cls-31",
    transform: "translate(68.284 78.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61161",
    "data-name": "Group 61161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61160",
    "data-name": "Group 61160",
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59938",
    "data-name": "Path 59938",
    className: "cls-222",
    d: "M467.056,540.012h.543l4.453,2.571,2.249-1.3-5.256-3.035-2.521,1.455Z",
    transform: "translate(-466.525 -538.25)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59939",
    "data-name": "Path 59939",
    className: "cls-220",
    d: "M466.525,523.928v1.142l5.256,3.035v-1.142Z",
    transform: "translate(-398.241 -447.242)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61165",
    "data-name": "Group 61165",
    className: "cls-50",
    transform: "translate(68.284 76.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61164",
    "data-name": "Group 61164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61163",
    "data-name": "Group 61163",
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59940",
    "data-name": "Path 59940",
    className: "cls-222",
    d: "M466.525,523.928v1.142l.532.307v-1.142Z",
    transform: "translate(-466.525 -523.928)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59941",
    "data-name": "Path 59941",
    className: "cls-223",
    d: "M466.525,515.44l2.521-1.455,5.256,3.035-2.521,1.455Z",
    transform: "translate(-398.241 -438.754)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61168",
    "data-name": "Group 61168",
    className: "cls-31",
    transform: "translate(68.284 75.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61167",
    "data-name": "Group 61167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61166",
    "data-name": "Group 61166",
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59942",
    "data-name": "Path 59942",
    className: "cls-222",
    d: "M467.056,515.747h.543l4.453,2.571,2.249-1.3-5.256-3.035-2.521,1.456Z",
    transform: "translate(-466.525 -513.985)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59943",
    "data-name": "Path 59943",
    className: "cls-220",
    d: "M466.525,499.664v1.142l5.256,3.035V502.7Z",
    transform: "translate(-398.241 -426.529)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61171",
    "data-name": "Group 61171",
    className: "cls-50",
    transform: "translate(68.284 73.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61170",
    "data-name": "Group 61170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61169",
    "data-name": "Group 61169",
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59944",
    "data-name": "Path 59944",
    className: "cls-222",
    d: "M466.525,499.664v1.142l.532.307v-1.142Z",
    transform: "translate(-466.525 -499.664)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59945",
    "data-name": "Path 59945",
    className: "cls-223",
    d: "M466.525,491.175l2.521-1.456,5.256,3.035-2.521,1.455Z",
    transform: "translate(-398.241 -418.041)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61174",
    "data-name": "Group 61174",
    className: "cls-31",
    transform: "translate(68.284 71.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61173",
    "data-name": "Group 61173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61172",
    "data-name": "Group 61172",
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59946",
    "data-name": "Path 59946",
    className: "cls-222",
    d: "M473.77,494.852l-5.256-3.035-1.989,1.149.532.307h1.356l4.047,2.336Z",
    transform: "translate(-466.525 -491.817)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59947",
    "data-name": "Path 59947",
    className: "cls-226",
    d: "M532.169,353.136l-10.431.524v1.833a.652.652,0,0,0,.384.536l3.45,1.992a2.051,2.051,0,0,0,1.855,0l4.357-2.516a.652.652,0,0,0,.384-.538Z",
    transform: "translate(-445.372 -301.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59948",
    "data-name": "Path 59948",
    className: "cls-227",
    d: "M531.785,336.567l-3.45-1.992a2.05,2.05,0,0,0-1.855,0l-4.358,2.516a.565.565,0,0,0,0,1.071l3.45,1.992a2.051,2.051,0,0,0,1.855,0l4.357-2.516a.565.565,0,0,0,0-1.071",
    transform: "translate(-445.372 -285.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59949",
    "data-name": "Path 59949",
    className: "cls-226",
    d: "M459.114,395.315l-10.431.524v1.833a.652.652,0,0,0,.384.536l3.45,1.992a2.05,2.05,0,0,0,1.855,0l4.357-2.516a.652.652,0,0,0,.384-.537Z",
    transform: "translate(-383.01 -337.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59950",
    "data-name": "Path 59950",
    className: "cls-227",
    d: "M458.73,378.746l-3.45-1.992a2.051,2.051,0,0,0-1.855,0l-4.357,2.516a.565.565,0,0,0,0,1.071l3.45,1.992a2.05,2.05,0,0,0,1.855,0l4.357-2.516a.565.565,0,0,0,0-1.071",
    transform: "translate(-383.01 -321.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59951",
    "data-name": "Path 59951",
    className: "cls-226",
    d: "M451.183,328.834c0-.592-.415-.831-.927-.536l-4.358,2.516a2.051,2.051,0,0,0-.928,1.607v5.031c0,.592.415.831.928.535l4.358-2.516a2.051,2.051,0,0,0,.928-1.607Z",
    transform: "translate(-379.842 -280.138)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61177",
    "data-name": "Group 61177",
    className: "cls-50",
    transform: "translate(59.352 47.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61176",
    "data-name": "Group 61176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61175",
    "data-name": "Group 61175",
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59952",
    "data-name": "Path 59952",
    className: "cls-229",
    d: "M409.457,335.945l-2.557-1.476a3.094,3.094,0,0,1-1.4-2.424v-4.15c0-.893.627-1.254,1.4-.808l2.557,1.476Z",
    transform: "translate(-405.501 -326.895)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61180",
    "data-name": "Group 61180",
    className: "cls-230",
    transform: "translate(59.352 47.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61179",
    "data-name": "Group 61179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61178",
    "data-name": "Group 61178",
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59953",
    "data-name": "Path 59953",
    className: "cls-222",
    d: "M405.5,327.893v4.15a2.772,2.772,0,0,0,.328,1.228c0-.021,0-.043,0-.064v-4.15c0-.892.627-1.254,1.4-.808l2.231,1.288v-.976l-2.557-1.476c-.773-.446-1.4-.085-1.4.808",
    transform: "translate(-405.501 -326.894)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61184",
    "data-name": "Group 61184",
    transform: "translate(59.027 48.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61183",
    "data-name": "Group 61183",
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22246",
    "data-name": "Rectangle 22246",
    className: "cls-233",
    width: 7.677,
    height: 9.833,
    transform: "translate(-3.697 1.924) rotate(-27.499)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61195",
    "data-name": "Group 61195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61194",
    "data-name": "Group 61194",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61187",
    "data-name": "Group 61187",
    className: "cls-47",
    transform: "translate(59.027 52.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61186",
    "data-name": "Group 61186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61185",
    "data-name": "Group 61185",
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59955",
    "data-name": "Path 59955",
    className: "cls-235",
    d: "M403.932,361.936a2.772,2.772,0,0,1-.328-1.228v-.235h-.325v.422a2.362,2.362,0,0,0,.653,1.04Z",
    transform: "translate(-403.279 -360.473)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61190",
    "data-name": "Group 61190",
    className: "cls-50",
    transform: "translate(64.917 50.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61189",
    "data-name": "Group 61189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61188",
    "data-name": "Group 61188",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59956",
    "data-name": "Path 59956",
    className: "cls-229",
    d: "M451.342,358.228l-1.314-.758a2.694,2.694,0,0,1-1-1.15l-.373-.775a2.7,2.7,0,0,0-1-1.15l-4.129-2.384v-7.382l5.56,3.21a2.569,2.569,0,0,1,1.109,1.631l1.652,8.3c.084.424-.161.649-.5.455",
    transform: "translate(-443.518 -344.629)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61193",
    "data-name": "Group 61193",
    className: "cls-230",
    transform: "translate(64.917 50.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61192",
    "data-name": "Group 61192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61191",
    "data-name": "Group 61191",
    className: "cls-237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59957",
    "data-name": "Path 59957",
    className: "cls-222",
    d: "M443.844,345.792,449.4,349a2.423,2.423,0,0,1,.891,1.006l-.107-.539a2.569,2.569,0,0,0-1.109-1.631l-5.56-3.21v7.382l.325.188Z",
    transform: "translate(-443.519 -344.629)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59958",
    "data-name": "Path 59958",
    className: "cls-235",
    d: "M441.3,345.912v7.382l.325-.188V346.1Z",
    transform: "translate(-376.705 -295.282)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61197",
    "data-name": "Group 61197",
    transform: "translate(64.592 57.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61196",
    "data-name": "Group 61196",
    className: "cls-238"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22251",
    "data-name": "Rectangle 22251",
    className: "cls-239",
    width: 10.467,
    height: 9.818,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -2.831, 1.634)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61211",
    "data-name": "Group 61211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61210",
    "data-name": "Group 61210",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61200",
    "data-name": "Group 61200",
    className: "cls-240",
    transform: "translate(64.592 57.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61199",
    "data-name": "Group 61199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61198",
    "data-name": "Group 61198",
    className: "cls-241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59960",
    "data-name": "Path 59960",
    className: "cls-242",
    d: "M441.622,395.066l-.325.188h.651Z",
    transform: "translate(-441.297 -395.066)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59961",
    "data-name": "Path 59961",
    className: "cls-243",
    d: "M391.1,306.459l-17.713-10.227v14.83l7.431,4.29a13.9,13.9,0,0,1,5.924,8.462l6.451,3.724V316.979Zm-9.382,3.5-2.557-1.476a3.093,3.093,0,0,1-1.4-2.424v-4.15c0-.893.626-1.254,1.4-.808l2.557,1.476Zm9.432,7.145-1.314-.758a2.7,2.7,0,0,1-1-1.15l-.373-.774a2.7,2.7,0,0,0-1-1.15l-4.129-2.384V303.5l5.56,3.21A2.569,2.569,0,0,1,390,308.345l1.652,8.3c.085.424-.161.649-.5.455",
    transform: "translate(-318.74 -252.874)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61203",
    "data-name": "Group 61203",
    className: "cls-244",
    transform: "translate(71.377 54.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61202",
    "data-name": "Group 61202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61201",
    "data-name": "Group 61201",
    className: "cls-245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59962",
    "data-name": "Path 59962",
    className: "cls-242",
    d: "M490.739,380.5l-.407-2.045-2.164-7.742-.511-.067,1.609,5.757-.121-.07c-.032-.018-.083.006-.083.132v3.052l.13.653a.444.444,0,0,1-.13.489v.613a14.519,14.519,0,0,0,.431,2.7l.434,1.907v1.268q-.088-.276-.191-.64l-1.569-5.613-.511-.067,1.623,5.807c.471,1.684.676,1.851.835,1.851a.424.424,0,0,0,.058-.005c.054-.007.228-.052.228-.319v-.2l.337,1.48Z",
    transform: "translate(-487.657 -370.645)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59963",
    "data-name": "Path 59963",
    className: "cls-246",
    d: "M599.657,303.825l4.129,2.384a2.693,2.693,0,0,1,1,1.15l.373.774a2.694,2.694,0,0,0,1,1.15l1.314.759c.232.134.421.068.488-.125a.525.525,0,0,1-.163-.063l-1.314-.759a2.694,2.694,0,0,1-1-1.15l-.373-.774a2.7,2.7,0,0,0-1-1.15l-4.129-2.384Z",
    transform: "translate(-511.887 -259.194)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61206",
    "data-name": "Group 61206",
    className: "cls-50",
    transform: "translate(87.77 37.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61205",
    "data-name": "Group 61205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61204",
    "data-name": "Group 61204",
    className: "cls-236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59964",
    "data-name": "Path 59964",
    className: "cls-247",
    d: "M607.481,268.082l-1.314-.758a2.694,2.694,0,0,1-1-1.15l-.373-.774a2.7,2.7,0,0,0-1-1.15l-4.129-2.384v-7.382l5.56,3.21a2.568,2.568,0,0,1,1.109,1.631l1.652,8.3c.084.424-.161.649-.5.455",
    transform: "translate(-599.657 -254.483)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59965",
    "data-name": "Path 59965",
    className: "cls-248",
    d: "M391.106,294.645l-17.713-10.227.537-2.026,14.886,8.594Z",
    transform: "translate(-318.74 -241.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59966",
    "data-name": "Path 59966",
    className: "cls-243",
    d: "M381.873,416.982a11.257,11.257,0,0,0-5.093-8.821l-7.018-4.052v-4.457l7.431,4.29a13.705,13.705,0,0,1,6.2,10.74v8.161l-1.52-.878Z",
    transform: "translate(-315.641 -341.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59967",
    "data-name": "Path 59967",
    className: "cls-223",
    d: "M648.317,419.2l-2.521-1.456v2.911Z",
    transform: "translate(-551.273 -356.599)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61209",
    "data-name": "Group 61209",
    className: "cls-31",
    transform: "translate(94.524 61.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61208",
    "data-name": "Group 61208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61207",
    "data-name": "Group 61207",
    className: "cls-249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59968",
    "data-name": "Path 59968",
    className: "cls-222",
    d: "M648.317,419.2l-2.521-1.456v2.911Z",
    transform: "translate(-645.796 -417.743)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59969",
    "data-name": "Path 59969",
    className: "cls-250",
    d: "M478.763,265.583l2.29,3.658,23.5-13.57-3.363-3.038Z",
    transform: "translate(-408.687 -215.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59970",
    "data-name": "Path 59970",
    className: "cls-243",
    d: "M503.356,520.928l-.918-.53v8.245l.918.53Z",
    transform: "translate(-428.897 -444.228)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61213",
    "data-name": "Group 61213",
    transform: "translate(73.541 73.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61212",
    "data-name": "Group 61212",
    className: "cls-251"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22257",
    "data-name": "Rectangle 22257",
    className: "cls-252",
    width: 7.247,
    height: 6.129,
    transform: "translate(-1.457 0.843) rotate(-30.039)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61215",
    "data-name": "Group 61215",
    transform: "translate(92.138 62.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61214",
    "data-name": "Group 61214",
    className: "cls-253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22258",
    "data-name": "Rectangle 22258",
    className: "cls-254",
    width: 6.9,
    height: 6.128,
    transform: "matrix(0.866, -0.501, 0.501, 0.866, -1.608, 0.93)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61220",
    "data-name": "Group 61220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61219",
    "data-name": "Group 61219",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59973",
    "data-name": "Path 59973",
    className: "cls-255",
    d: "M503.115,517.724l-.678.391.918.53h1.2l.076-.044Z",
    transform: "translate(-428.897 -441.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59974",
    "data-name": "Path 59974",
    className: "cls-255",
    d: "M377.059,206.864l22.431-12.95,14.886,8.595-22.431,12.95Z",
    transform: "translate(-321.87 -165.531)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61218",
    "data-name": "Group 61218",
    className: "cls-240",
    transform: "translate(74.139 38.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61217",
    "data-name": "Group 61217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61216",
    "data-name": "Group 61216",
    className: "cls-256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59975",
    "data-name": "Path 59975",
    className: "cls-242",
    d: "M513.427,263.5l-.366-.212-6.532,4.557h.682a1.9,1.9,0,0,0,.929-.222l5.287-3.052a.565.565,0,0,0,0-1.071",
    transform: "translate(-506.528 -263.289)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_59976",
    "data-name": "Path 59976",
    className: "cls-248",
    d: "M450.387,248.011l5.237,3.024h.583l-5.237-3.024Z",
    transform: "translate(-384.465 -211.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59977",
    "data-name": "Path 59977",
    className: "cls-257",
    d: "M446.99,248.012l-.582.673,5.237,3.023.583-.673Z",
    transform: "translate(-381.068 -211.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59978",
    "data-name": "Path 59978",
    className: "cls-258",
    d: "M446.407,248.684v-.673h.583Z",
    transform: "translate(-381.067 -211.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59979",
    "data-name": "Path 59979",
    className: "cls-248",
    d: "M474.739,233.952l5.237,3.023h.583l-5.237-3.023Z",
    transform: "translate(-405.252 -199.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59980",
    "data-name": "Path 59980",
    className: "cls-257",
    d: "M471.341,233.952l-.583.673L476,237.648l.583-.673Z",
    transform: "translate(-401.855 -199.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59981",
    "data-name": "Path 59981",
    className: "cls-258",
    d: "M470.759,234.624v-.673h.583Z",
    transform: "translate(-401.855 -199.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59982",
    "data-name": "Path 59982",
    className: "cls-248",
    d: "M401.684,276.13l11.768,6.794h.582l-11.768-6.794Z",
    transform: "translate(-342.89 -235.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59983",
    "data-name": "Path 59983",
    className: "cls-248",
    d: "M478.1,323.222h1.165l-.583-.673Z",
    transform: "translate(-408.124 -275.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59984",
    "data-name": "Path 59984",
    className: "cls-259",
    d: "M482.666,322.549v.673l-.583-.673Z",
    transform: "translate(-411.522 -275.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59985",
    "data-name": "Path 59985",
    className: "cls-257",
    d: "M398.286,276.131l-.583.673,11.768,6.794.583-.673Z",
    transform: "translate(-339.493 -235.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59986",
    "data-name": "Path 59986",
    className: "cls-258",
    d: "M397.7,276.8v-.673h.582Z",
    transform: "translate(-339.492 -235.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59987",
    "data-name": "Path 59987",
    className: "cls-248",
    d: "M426.035,262.071l11.768,6.794h.583l-11.768-6.794Z",
    transform: "translate(-363.678 -223.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59988",
    "data-name": "Path 59988",
    className: "cls-248",
    d: "M502.454,309.162h1.165l-.583-.673Z",
    transform: "translate(-428.911 -263.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59989",
    "data-name": "Path 59989",
    className: "cls-259",
    d: "M507.017,308.49v.673l-.583-.673Z",
    transform: "translate(-432.309 -263.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59990",
    "data-name": "Path 59990",
    className: "cls-257",
    d: "M422.638,262.071l-.582.673,11.768,6.794.582-.673Z",
    transform: "translate(-360.28 -223.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59991",
    "data-name": "Path 59991",
    className: "cls-258",
    d: "M422.055,262.743v-.673h.583Z",
    transform: "translate(-360.28 -223.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59992",
    "data-name": "Path 59992",
    className: "cls-248",
    d: "M499.091,219.893l11.768,6.794h.583l-11.768-6.794Z",
    transform: "translate(-426.04 -187.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59993",
    "data-name": "Path 59993",
    className: "cls-248",
    d: "M575.51,266.984h1.165l-.583-.673Z",
    transform: "translate(-491.274 -227.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59994",
    "data-name": "Path 59994",
    className: "cls-259",
    d: "M580.073,266.311v.673l-.583-.673Z",
    transform: "translate(-494.671 -227.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59995",
    "data-name": "Path 59995",
    className: "cls-257",
    d: "M495.693,219.893l-.583.673,11.768,6.794.583-.673Z",
    transform: "translate(-422.642 -187.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59996",
    "data-name": "Path 59996",
    className: "cls-258",
    d: "M495.111,220.565v-.673h.583Z",
    transform: "translate(-422.642 -187.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59997",
    "data-name": "Path 59997",
    className: "cls-248",
    d: "M523.442,205.833l11.768,6.794h.583l-11.768-6.794Z",
    transform: "translate(-446.827 -175.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59998",
    "data-name": "Path 59998",
    className: "cls-248",
    d: "M599.862,252.924h1.165l-.582-.673Z",
    transform: "translate(-512.061 -215.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59999",
    "data-name": "Path 59999",
    className: "cls-259",
    d: "M604.424,252.252v.673l-.583-.673Z",
    transform: "translate(-515.459 -215.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60000",
    "data-name": "Path 60000",
    className: "cls-257",
    d: "M520.045,205.833l-.582.673L531.23,213.3l.583-.673Z",
    transform: "translate(-443.43 -175.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60001",
    "data-name": "Path 60001",
    className: "cls-258",
    d: "M519.462,206.506v-.673h.582Z",
    transform: "translate(-443.43 -175.705)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61222",
    "data-name": "Group 61222",
    transform: "translate(69.913 38.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61221",
    "data-name": "Group 61221",
    className: "cls-260"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22261",
    "data-name": "Rectangle 22261",
    className: "cls-261",
    width: 10.757,
    height: 5.013,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61239",
    "data-name": "Group 61239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61238",
    "data-name": "Group 61238",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60003",
    "data-name": "Path 60003",
    className: "cls-24",
    d: "M488.027,246.145l-2.846-1.643a2.05,2.05,0,0,0-1.855,0l-5.287,3.052a.565.565,0,0,0,0,1.071l2.846,1.643a2.051,2.051,0,0,0,1.855,0l5.287-3.052a.565.565,0,0,0,0-1.071",
    transform: "translate(-407.742 -208.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60004",
    "data-name": "Path 60004",
    className: "cls-248",
    d: "M518.284,287.212l1.83,1.057h.583l-1.83-1.057Z",
    transform: "translate(-442.424 -245.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60005",
    "data-name": "Path 60005",
    className: "cls-248",
    d: "M526.806,295.1h1.165l-.583-.673Z",
    transform: "translate(-449.699 -251.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60006",
    "data-name": "Path 60006",
    className: "cls-259",
    d: "M531.369,294.43v.673l-.583-.673Z",
    transform: "translate(-453.096 -251.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60007",
    "data-name": "Path 60007",
    className: "cls-257",
    d: "M514.886,287.212l-.582.673,1.83,1.057.583-.673Z",
    transform: "translate(-439.026 -245.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60008",
    "data-name": "Path 60008",
    className: "cls-248",
    d: "M542.635,273.152l1.83,1.057h.583l-1.83-1.056Z",
    transform: "translate(-463.211 -233.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60009",
    "data-name": "Path 60009",
    className: "cls-248",
    d: "M551.158,281.043h1.165l-.583-.673Z",
    transform: "translate(-470.486 -239.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60010",
    "data-name": "Path 60010",
    className: "cls-259",
    d: "M555.721,280.371v.673l-.583-.673Z",
    transform: "translate(-473.884 -239.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60011",
    "data-name": "Path 60011",
    className: "cls-257",
    d: "M539.238,273.152l-.583.673,1.83,1.057.583-.673Z",
    transform: "translate(-459.814 -233.172)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61225",
    "data-name": "Group 61225",
    className: "cls-240",
    transform: "translate(78.842 39.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61224",
    "data-name": "Group 61224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61223",
    "data-name": "Group 61223",
    className: "cls-262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60012",
    "data-name": "Path 60012",
    className: "cls-242",
    d: "M539.031,274.042l.411-.772-.2-.118-.583.673Z",
    transform: "translate(-538.655 -273.152)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61228",
    "data-name": "Group 61228",
    className: "cls-240",
    transform: "translate(79.424 39.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61227",
    "data-name": "Group 61227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61226",
    "data-name": "Group 61226",
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60013",
    "data-name": "Path 60013",
    className: "cls-242",
    d: "M543.594,273.369l-.754-.1-.2-.118h.583Z",
    transform: "translate(-542.635 -273.152)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61231",
    "data-name": "Group 61231",
    className: "cls-240",
    transform: "translate(75.277 42.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61230",
    "data-name": "Group 61230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61229",
    "data-name": "Group 61229",
    className: "cls-264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60014",
    "data-name": "Path 60014",
    className: "cls-242",
    d: "M514.675,288.1l.416-.769-.2-.118-.583.673Z",
    transform: "translate(-514.304 -287.212)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61234",
    "data-name": "Group 61234",
    className: "cls-240",
    transform: "translate(75.86 42.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61233",
    "data-name": "Group 61233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61232",
    "data-name": "Group 61232",
    className: "cls-263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60015",
    "data-name": "Path 60015",
    className: "cls-242",
    d: "M519.243,287.429l-.754-.1-.2-.118h.583Z",
    transform: "translate(-518.284 -287.212)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_60016",
    "data-name": "Path 60016",
    className: "cls-227",
    d: "M529.965,339.509l-2.039-.986-2.882,1.664c-1.637-.706-4.088.709-5.725,3.306l-13.243,7.646.386,1.94,1.2,2.678,22.3-12.875Z",
    transform: "translate(-432.002 -288.974)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61237",
    "data-name": "Group 61237",
    className: "cls-50",
    transform: "translate(73.246 41.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61236",
    "data-name": "Group 61236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61235",
    "data-name": "Group 61235",
    className: "cls-265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60017",
    "data-name": "Path 60017",
    className: "cls-247",
    d: "M522.876,292.869l-19.041,10.994c-.639.369-1.293-.008-1.459-.842l-1.954-9.819,21.357-12.331,1.954,9.819a2.157,2.157,0,0,1-.857,2.179",
    transform: "translate(-500.422 -280.871)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61241",
    "data-name": "Group 61241",
    transform: "translate(75.922 41.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61240",
    "data-name": "Group 61240",
    className: "cls-266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22268",
    "data-name": "Rectangle 22268",
    className: "cls-267",
    width: 30.56,
    height: 29.752,
    transform: "translate(-9.868 17.718) rotate(-60.884)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61243",
    "data-name": "Group 61243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61242",
    "data-name": "Group 61242",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60019",
    "data-name": "Path 60019",
    className: "cls-246",
    d: "M517.914,273.39l-23.5,13.57,2.093,10.519,1.2,2.678,22.3-12.875v-3.374Zm.155,13.281-19.041,10.994c-.64.369-1.292-.008-1.459-.842L495.615,287l21.357-12.331,1.954,9.819a2.156,2.156,0,0,1-.857,2.179",
    transform: "translate(-422.044 -233.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60020",
    "data-name": "Path 60020",
    className: "cls-268",
    d: "M555.2,405.154l.247.142,3.479-2.008-.247-.142Z",
    transform: "translate(-473.934 -344.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60021",
    "data-name": "Path 60021",
    className: "cls-269",
    d: "M555.443,417.009l-.247-.142.294.258.247.142Z",
    transform: "translate(-473.934 -355.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60022",
    "data-name": "Path 60022",
    className: "cls-26",
    d: "M560.361,404.118l-3.479,2.008.294.258,3.261-1.883Z",
    transform: "translate(-475.373 -344.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60023",
    "data-name": "Path 60023",
    className: "cls-268",
    d: "M529.04,409.811l.247.142,5.712-3.3-.247-.142Z",
    transform: "translate(-451.606 -347.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60024",
    "data-name": "Path 60024",
    className: "cls-26",
    d: "M536.437,407.486l-5.712,3.3.076.384,5.712-3.3Z",
    transform: "translate(-453.044 -347.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60025",
    "data-name": "Path 60025",
    className: "cls-270",
    d: "M529.286,429.188l-.247-.142.076.384.247.142Z",
    transform: "translate(-451.605 -366.247)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60026",
    "data-name": "Path 60026",
    className: "cls-268",
    d: "M614.185,371.1l.247.142,3.479-2.008-.247-.142Z",
    transform: "translate(-524.288 -315.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60027",
    "data-name": "Path 60027",
    className: "cls-269",
    d: "M614.431,382.952l-.247-.142.294.258.246.142Z",
    transform: "translate(-524.288 -326.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60028",
    "data-name": "Path 60028",
    className: "cls-26",
    d: "M619.349,370.061l-3.479,2.009.294.258,3.261-1.883Z",
    transform: "translate(-525.727 -315.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60029",
    "data-name": "Path 60029",
    className: "cls-268",
    d: "M588.028,375.754l.247.142,5.712-3.3-.247-.142Z",
    transform: "translate(-501.96 -317.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60030",
    "data-name": "Path 60030",
    className: "cls-26",
    d: "M595.425,373.429l-5.712,3.3.076.384,5.712-3.3Z",
    transform: "translate(-503.398 -318.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60031",
    "data-name": "Path 60031",
    className: "cls-270",
    d: "M588.274,395.13l-.247-.142.076.384.247.142Z",
    transform: "translate(-501.96 -337.175)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61245",
    "data-name": "Group 61245",
    transform: "translate(71.688 66.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61244",
    "data-name": "Group 61244",
    className: "cls-271"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22270",
    "data-name": "Rectangle 22270",
    className: "cls-272",
    width: 2.118,
    height: 6.488
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61253",
    "data-name": "Group 61253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61252",
    "data-name": "Group 61252",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61248",
    "data-name": "Group 61248",
    className: "cls-244",
    transform: "translate(71.688 66.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61247",
    "data-name": "Group 61247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61246",
    "data-name": "Group 61246",
    className: "cls-273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60033",
    "data-name": "Path 60033",
    className: "cls-242",
    d: "M489.781,454.284l.366.321,1.165,3.2a8.614,8.614,0,0,0,.587,1.351v-1.183c-.048-.122-.1-.253-.151-.4l-.839-2.3.677.593.314,1.065v-1.423Z",
    transform: "translate(-489.781 -454.284)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_60034",
    "data-name": "Path 60034",
    className: "cls-255",
    d: "M489.781,490.254l2.118.732v.49Z",
    transform: "translate(-418.093 -418.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60035",
    "data-name": "Path 60035",
    className: "cls-274",
    d: "M513.066,509.2l-1.234-.713,1.234-.281Z",
    transform: "translate(-436.916 -433.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60036",
    "data-name": "Path 60036",
    className: "cls-26",
    d: "M539.79,431.19v.994l-19.525,11.273v-.994Z",
    transform: "translate(-444.115 -368.078)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61251",
    "data-name": "Group 61251",
    className: "cls-244",
    transform: "translate(64.591 61.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61250",
    "data-name": "Group 61250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61249",
    "data-name": "Group 61249",
    className: "cls-275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60037",
    "data-name": "Path 60037",
    className: "cls-242",
    d: "M442.967,424.539l-.316-1.132-1.354,1.184.325,1.164.707.409c.382.22.692.042.692-.4v-.882a1.192,1.192,0,0,0-.054-.343",
    transform: "translate(-441.297 -423.407)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61255",
    "data-name": "Group 61255",
    transform: "translate(64.266 60.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61254",
    "data-name": "Group 61254",
    className: "cls-276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22274",
    "data-name": "Rectangle 22274",
    className: "cls-277",
    width: 3.023,
    height: 3.632,
    transform: "translate(-1.325 0.704) rotate(-28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61269",
    "data-name": "Group 61269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61268",
    "data-name": "Group 61268",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60039",
    "data-name": "Path 60039",
    className: "cls-191",
    d: "M440.473,417.445v.882c0,.441-.31.62-.692.4l-.708-.409v-2.479l.708.409a1.528,1.528,0,0,1,.692,1.2",
    transform: "translate(-374.808 -354.974)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61258",
    "data-name": "Group 61258",
    className: "cls-31",
    transform: "translate(95.857 38.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61257",
    "data-name": "Group 61257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61256",
    "data-name": "Group 61256",
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60040",
    "data-name": "Path 60040",
    className: "cls-26",
    d: "M655.708,265.182l.826.477-.6-3-1.035-1.527Z",
    transform: "translate(-654.903 -261.134)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61261",
    "data-name": "Group 61261",
    className: "cls-47",
    transform: "translate(72.353 38.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61260",
    "data-name": "Group 61260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61259",
    "data-name": "Group 61259",
    className: "cls-279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60041",
    "data-name": "Path 60041",
    className: "cls-280",
    d: "M494.322,274.7l1.035,1.527,23.5-13.57-1.035-1.527Z",
    transform: "translate(-494.322 -261.134)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61264",
    "data-name": "Group 61264",
    className: "cls-47",
    transform: "translate(73.388 39.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61263",
    "data-name": "Group 61263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61262",
    "data-name": "Group 61262",
    className: "cls-281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60042",
    "data-name": "Path 60042",
    className: "cls-26",
    d: "M524.9,271.564l-23.5,13.57.6,3,23.5-13.57Z",
    transform: "translate(-501.394 -271.564)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61267",
    "data-name": "Group 61267",
    className: "cls-47",
    transform: "translate(72.353 51.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61266",
    "data-name": "Group 61266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61265",
    "data-name": "Group 61265",
    className: "cls-278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60043",
    "data-name": "Path 60043",
    className: "cls-282",
    d: "M495.127,357.894l.826.477-.6-3-1.035-1.527Z",
    transform: "translate(-494.321 -353.846)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61274",
    "data-name": "Group 61274",
    transform: "translate(68.993 63.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61273",
    "data-name": "Group 61273",
    className: "cls-283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61272",
    "data-name": "Group 61272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61271",
    "data-name": "Group 61271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61270",
    "data-name": "Group 61270",
    className: "cls-284"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22280",
    "data-name": "Rectangle 22280",
    width: 2.881,
    height: 2.108,
    transform: "translate(-0.001 -0.019)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAeCAIAAAA+faC0AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKaADAAQAAAABAAAAHgAAAADw6cLzAAADN0lEQVRIDa2Wv24TQRCHfYftSx6DdIggBIlEHgDRIAFlQIgGCcoUUKaEB4iQQEGkACESIRoKCuiREglLINLCa+Dz3h++2Uk2x9w59hmvzufd2935bn4zs3Z04+zlTqX1e93FxaTf7y8kPb6iKLp2b52rsmRu3Xhultobsuyy7HDR9N7eYIsdlg2UK446UdTCymxLLZsAi+uzGWu5q4EtFuYK//Jm7/HVW9zNu1m2Tovu88D/+nH44tGmUj+/3jXsrhkzRPb/dxwqSO4YLMuyKIosyz/tvL1+/24gWjbuClvuIvxsCQc1KCzUPHcug/3h+c7SxfPnVi8pfqzm3vvwitN2cDSEFnehpqNRysc5rjR175+9Cras317tUp0Oi6bpGJFzETlzLgfvmwxx/fvXg5/73y6srWKzxvY1RnkzN73gJFQILe6KwJlQuee5RNo/KBhgdm/rpbKt5srTCp9GduKKyArW0A7TUTpycqUOrREcyRFcwbAPDwa7W9t0LJtH0qYosIbQOjccChiUXorHb1OxuA7Eai65PUlrE9qCnMpy9czLK6HFSz5FMdYJXLds73V0yqlaC63GUkLriRJgJ2gJ7bi2fGXl9sbDRnbzllC1ZBMtL0qnZVsUPprCy3xmMdtsotOBur7xYEyeH23iZJGm6WZERkoPFVH5qLtZRj87RWQMP3m3rVSFROZ/S6/bTfjHkvQWF5KFJKmmOq9yckiJk1o8JxU8zlee4ysimwVWcxLHC+Z/SY/9Zo9SNajeV3Fa4urr2BitDhH56a5kdb1ZNuRczgBRchRnvZ4sAEwbjURdOSWQ1wtNdPVN63Z5Ug1t44IuKyj2MCcQ4kkeZRllLj0vNd8e7H8VvOBMhV31jgltfQFP4uW1FTMBQ84hlw1T92eYHl9DHuqvAlOngAntx9+Dak4Z+2FIXMubSxYfxzF/luOYVItZQCO60rwQYbPpTBTZrBc2R4wecmbuDPA48qpLvbLSLAjDtlTdKGx6ddeD3YmdxvqZuIsFR2x+Uzfv2PqbuH9mqlo+YjNohZ9NZOPMCVvxBL5acmY1w7lQ1ew/7EAi+w73B+El4Gkp1s/FsGWGzl87a+2SWPYE5wAAAABJRU5ErkJggg=="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61276",
    "data-name": "Group 61276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61275",
    "data-name": "Group 61275",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60045",
    "data-name": "Path 60045",
    className: "cls-26",
    d: "M472.772,437.641a.659.659,0,0,0-.6-.55l-.021.008a.347.347,0,0,1-.007-.076V435.8h-.774v1.223a.839.839,0,0,0,.386.76.719.719,0,0,0,.363.1.983.983,0,0,0,.488-.141Z",
    transform: "translate(-402.375 -372.013)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61278",
    "data-name": "Group 61278",
    transform: "translate(71.359 64.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61277",
    "data-name": "Group 61277",
    className: "cls-285"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22283",
    "data-name": "Rectangle 22283",
    className: "cls-286",
    width: 0.895,
    height: 0.95,
    transform: "translate(-0.351 0.187) rotate(-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61280",
    "data-name": "Group 61280",
    transform: "translate(67.73 56.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61279",
    "data-name": "Group 61279",
    className: "cls-287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22284",
    "data-name": "Rectangle 22284",
    className: "cls-288",
    width: 8.272,
    height: 6.591,
    transform: "translate(-3.331 5.807) rotate(-60.162)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61285",
    "data-name": "Group 61285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61284",
    "data-name": "Group 61284",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61283",
    "data-name": "Group 61283",
    className: "cls-31",
    transform: "translate(69.38 57.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61282",
    "data-name": "Group 61282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61281",
    "data-name": "Group 61281",
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60048",
    "data-name": "Path 60048",
    className: "cls-180",
    d: "M475.432,389.906a.3.3,0,0,0-.3.031l-.3.174a.33.33,0,0,1-.165.044h-.651v.447h.168l.774-.447.276-.16a.3.3,0,0,1,.3-.03Z",
    transform: "translate(-474.012 -389.878)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_60049",
    "data-name": "Path 60049",
    className: "cls-26",
    d: "M468.847,390.337l-1.882,1.086a.952.952,0,0,0-.431.747V397.4c0,.275.193.386.431.249l1.882-1.086a.953.953,0,0,0,.431-.747v-5.225c0-.275-.193-.386-.431-.249",
    transform: "translate(-398.249 -333.154)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61290",
    "data-name": "Group 61290",
    transform: "translate(68.993 53.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61289",
    "data-name": "Group 61289",
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61288",
    "data-name": "Group 61288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61287",
    "data-name": "Group 61287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61286",
    "data-name": "Group 61286",
    className: "cls-291"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_22287",
    "data-name": "Rectangle 22287",
    width: 2.881,
    height: 3.653,
    transform: "translate(-0.001 -0.017)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAA0CAIAAACYSobkAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAKaADAAQAAAABAAAANAAAAAB7mPVWAAAD6UlEQVRYCb2XMWsUQRiG99RfYiEWKoiCYqvYWGgZQSwstEwRS7HSzsZCxAiCFppSwUrERhDBCJFYqr/D3O3u+bzftzs7N26Su8vu7iXL7N5mnnnf752ZTTbt//i1tb128SrnBDXiOuvt+P3j54dXG5yd8Ojj2xjVI/vp2r1ARWFeFJdvrly5dSPge2GjlZ/AKIoiz4vxJJ/k+YvNT+F+x2yEIjf0XpYlvAmScz7FZJIfO33q/ssn/sCR8NwBG0lpMRkqiuHlRcmvXRVbX75tf908ef4suG7YsclQkYvDDnO5MmDCSIpyOt14vO7sg3oeU5Gi0tZaVeXcFWsYJdgsG5m9K6u3r6/eWZ6dmIwypxq+QZp6YUeOrUv77s/3ZdgJ1ecPDOXYIh3OMrmcjhJsLX3hescme2mJMeaK7WBrlAWfEkor+MS5M3i+ADum0qnPH5BKFVgLs9fbItUuFyrFXiBriclQ0TQeK7iiUmmNgCsdqG3zWEZ7xNSyY3/dydJI75XJAovKYcoJlLaGVnBCnYsdwCotazKLlAUKeTREldWcylE1fbzb5hyb3Ny11q668TmsjoAhihoFysCcfP7MTiDreg+qD6KdHYPRBHVnPKbIoa4+CF8r5jd5f90z4EL7D7ECz4nJWlG9tElndtla2rYH/1vPAxifqadTwwxmBFb49kDta3IygtRzJrE/QXHHY1YqRYttgEEwFMB822ryg9fPfNYmgD0uZ9gh1UQIiXygqqGU5WU25WPsmWTNb3IyjoaN2/zwtadadZXiCeppaAYZ2B/wlRKTH75ZT3qc/7LZS+5euhbAf3fItXwem9dudegU8KKlDX8bNyrdocwUVZnOS9luxY6fpg14aZOTrip2cNuTBVSCc4Wrdlp/CHiJTCXIcHmIVqi0NgktVNoqMIDZHGe6WzBcsd1wFMKDWO0Q5Mtyx5nDrV50Fvnf7naW5264bRUSy69rDskGTLjY7XfrZbn7hy8cPe5sEqal0yY1s4qpFnqE/fzz+3DZVUOec1ik9G5rh7bLuNKI9se6PdfsLGMT1sKlt+uWSndL9d4OVTMboWAFRnQK6jZiofdGN2CCFr7whsc7udnVZcVWsCnyNCPjiA+961ZvR7Wu2duYMOa9aCjuDVp1XOnmqleJrTIitu2RvYuNRtGweck1m4ejB7aQZnuP4Yo0q1mxRR7xHqFb/YdMFI5at/1bUVMHsr1m8z5mRJQPFvjAnrry8ELotvR6DuyMhVykgfwWqmH7UjYgumaTcFGHm18zuoXVK8OAR+S5213PswHG0LAdPdgEQ1vDrt7QBrQ9Yld5G8DsCiF24vNgyv8B2n9iUl6jaQAAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61292",
    "data-name": "Group 61292",
    transform: "translate(71.359 53.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61291",
    "data-name": "Group 61291",
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22289",
    "data-name": "Rectangle 22289",
    className: "cls-293",
    width: 0.895,
    height: 0.95,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -0.351, 0.187)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61294",
    "data-name": "Group 61294",
    transform: "translate(68.993 57.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61293",
    "data-name": "Group 61293",
    className: "cls-294"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22290",
    "data-name": "Rectangle 22290",
    className: "cls-295",
    width: 0.774,
    height: 0.447,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61296",
    "data-name": "Group 61296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61295",
    "data-name": "Group 61295",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60053",
    "data-name": "Path 60053",
    className: "cls-26",
    d: "M541.19,459.457l11.519-6.651.967-3.441-.637-.368-13.691,7.9,1.025.591Z",
    transform: "translate(-460.405 -383.278)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60054",
    "data-name": "Path 60054",
    className: "cls-296",
    d: "M631.986,450.006l-.9-.52-.133.473.513.3-.834,2.968.387.224Z",
    transform: "translate(-538.328 -383.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60055",
    "data-name": "Path 60055",
    className: "cls-296",
    d: "M544.5,493.426l.372.365.9.52-1.039-1.02Z",
    transform: "translate(-464.806 -421.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60056",
    "data-name": "Path 60056",
    className: "cls-235",
    d: "M539.24,368.308l-22.3,12.875v7.883l4.268-2.464,1.039,1.02,11.686-6.746,1.039-2.22,4.269-2.464Z",
    transform: "translate(-441.277 -314.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22291",
    "data-name": "Rectangle 22291",
    className: "cls-297",
    width: 1.204,
    height: 8.245,
    transform: "translate(74.459 76.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60057",
    "data-name": "Path 60057",
    className: "cls-235",
    d: "M534.935,438.544l-.967,3.441-11.756,6.787-.967-2.324-4.3,2.485v8.245l22.3-12.875v-8.245Z",
    transform: "translate(-441.277 -372.234)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61298",
    "data-name": "Group 61298",
    transform: "translate(94.183 55.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61297",
    "data-name": "Group 61297",
    className: "cls-298"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22293",
    "data-name": "Rectangle 22293",
    className: "cls-299",
    width: 5.847,
    height: 7.303,
    transform: "translate(-2.928 1.678) rotate(-29.827)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61300",
    "data-name": "Group 61300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61299",
    "data-name": "Group 61299",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60059",
    "data-name": "Path 60059",
    className: "cls-300",
    d: "M519.95,538.869l-.283-.68-4.247,2.452h-.26v.994Z",
    transform: "translate(-439.757 -459.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60060",
    "data-name": "Path 60060",
    className: "cls-301",
    d: "M514.446,542.836l-4.79,2.766h-.469l-.475.274h1.2l4.9-2.828Z",
    transform: "translate(-434.253 -463.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60061",
    "data-name": "Path 60061",
    className: "cls-296",
    d: "M546.179,537.3l-.225.13.283.68.368.212Z",
    transform: "translate(-466.044 -458.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60062",
    "data-name": "Path 60062",
    className: "cls-235",
    d: "M508.712,554.939h.475v.994l-.475.274Z",
    transform: "translate(-434.253 -473.714)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22294",
    "data-name": "Rectangle 22294",
    className: "cls-302",
    width: 0.469,
    height: 0.994,
    transform: "translate(74.934 81.225)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61302",
    "data-name": "Group 61302",
    transform: "translate(76.594 66.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61301",
    "data-name": "Group 61301",
    className: "cls-303"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22296",
    "data-name": "Rectangle 22296",
    className: "cls-304",
    width: 5.011,
    height: 5.805,
    transform: "translate(-2.202 1.286) rotate(-30.28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61304",
    "data-name": "Group 61304",
    transform: "translate(76.683 66.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61303",
    "data-name": "Group 61303",
    className: "cls-305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22297",
    "data-name": "Rectangle 22297",
    className: "cls-306",
    width: 4.263,
    height: 5.186,
    transform: "translate(-1.582 0.657) rotate(-22.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61306",
    "data-name": "Group 61306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61305",
    "data-name": "Group 61305",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60065",
    "data-name": "Path 60065",
    className: "cls-301",
    d: "M646.429,449.755l-.475.274v.453l-3.3,1.907-.143.507,3.921-2.263Z",
    transform: "translate(-548.466 -383.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60066",
    "data-name": "Path 60066",
    className: "cls-307",
    d: "M666.049,442.778v-1.243l.475-.274V442.5Z",
    transform: "translate(-568.561 -376.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60067",
    "data-name": "Path 60067",
    className: "cls-300",
    d: "M646.786,444.831v-1.7l-2.734,1.578-.569,2.025Z",
    transform: "translate(-549.298 -378.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60068",
    "data-name": "Path 60068",
    className: "cls-301",
    d: "M640.731,469.646l-.475.274v.453l-4.28,2.471-.143.507,4.9-2.828Z",
    transform: "translate(-542.768 -400.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60069",
    "data-name": "Path 60069",
    className: "cls-307",
    d: "M666.049,467.642v-.391l.475-.274v.39Z",
    transform: "translate(-568.561 -398.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60070",
    "data-name": "Path 60070",
    className: "cls-300",
    d: "M641.088,469.695v-.844l-4,2.308-.283,1.007Z",
    transform: "translate(-543.599 -400.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60071",
    "data-name": "Path 60071",
    className: "cls-300",
    d: "M518.973,518.823l-.569-1.368-2.984,1.722h-.261v1.847Z",
    transform: "translate(-439.757 -441.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60072",
    "data-name": "Path 60072",
    className: "cls-301",
    d: "M513.469,526.8l-3.813,2.2h-.469l-.475.274h1.2l3.921-2.264Z",
    transform: "translate(-434.253 -449.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60073",
    "data-name": "Path 60073",
    className: "cls-296",
    d: "M537.549,516.566l-.225.13.569,1.368.368.212Z",
    transform: "translate(-458.677 -440.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60074",
    "data-name": "Path 60074",
    className: "cls-235",
    d: "M508.712,529.223h.475v1.847l-.475.274Z",
    transform: "translate(-434.253 -451.762)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22298",
    "data-name": "Rectangle 22298",
    className: "cls-302",
    width: 0.469,
    height: 1.847,
    transform: "translate(74.934 77.461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60075",
    "data-name": "Path 60075",
    className: "cls-26",
    d: "M557.437,497.808l9.23-5.329.712-2.532L556.725,496.1Z",
    transform: "translate(-475.238 -418.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60076",
    "data-name": "Path 60076",
    className: "cls-297",
    d: "M508.712,437.971v10.561h1.2v-7.883Z",
    transform: "translate(-434.253 -373.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60077",
    "data-name": "Path 60077",
    className: "cls-26",
    d: "M554.938,404.049l-11.132,6.427-1.935-4.649,15-8.661Z",
    transform: "translate(-462.559 -339.034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60078",
    "data-name": "Path 60078",
    className: "cls-301",
    d: "M564.961,442.666l-10.894,6.29.15.361,11.132-6.427Z",
    transform: "translate(-472.969 -377.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60079",
    "data-name": "Path 60079",
    className: "cls-296",
    d: "M630.82,397.166l-.537.31-1.785,6.35.387.223Z",
    transform: "translate(-536.506 -339.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60080",
    "data-name": "Path 60080",
    className: "cls-26",
    d: "M523.39,461.191l-.089.051.527,3.4a1.011,1.011,0,0,0,.281.591,1.155,1.155,0,0,0,.893-.169Z",
    transform: "translate(-446.707 -393.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61308",
    "data-name": "Group 61308",
    transform: "translate(94.183 56.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61307",
    "data-name": "Group 61307",
    className: "cls-308"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22300",
    "data-name": "Rectangle 22300",
    className: "cls-309",
    width: 6.746,
    height: 3.837,
    transform: "matrix(0.273, -0.962, 0.962, 0.273, -1.678, 5.92)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61322",
    "data-name": "Group 61322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61321",
    "data-name": "Group 61321",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60082",
    "data-name": "Path 60082",
    className: "cls-26",
    d: "M647.321,388.193a3.329,3.329,0,0,0,1.466-2.283l.479-3.641-.333.193Z",
    transform: "translate(-552.574 -326.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60083",
    "data-name": "Path 60083",
    className: "cls-301",
    d: "M563.452,475.02l-11.519,6.651.15.361,11.756-6.788Z",
    transform: "translate(-471.148 -405.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60084",
    "data-name": "Path 60084",
    className: "cls-301",
    d: "M569.555,505.718l-8.993,5.192.15.361,9.23-5.329Z",
    transform: "translate(-478.514 -431.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60085",
    "data-name": "Path 60085",
    className: "cls-296",
    d: "M623.1,489.946l-.537.31-.562,2,.387.224Z",
    transform: "translate(-530.961 -418.234)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61311",
    "data-name": "Group 61311",
    className: "cls-310",
    transform: "translate(68.975 47.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61310",
    "data-name": "Group 61310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61309",
    "data-name": "Group 61309",
    className: "cls-311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60086",
    "data-name": "Path 60086",
    className: "cls-242",
    d: "M472.25,324.881l-.672-.388a.469.469,0,0,1,.2.359c0,.228-.215.426-.534.532l.781-.026c.45-.015.813-.222.839-.477Z",
    transform: "translate(-471.247 -324.493)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61314",
    "data-name": "Group 61314",
    className: "cls-310",
    transform: "translate(69.008 47.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61313",
    "data-name": "Group 61313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61312",
    "data-name": "Group 61312",
    className: "cls-312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60087",
    "data-name": "Path 60087",
    className: "cls-242",
    d: "M472.195,323.056l-.724.037.971.56.4-.464a1.306,1.306,0,0,0-.649-.133",
    transform: "translate(-471.471 -323.054)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61317",
    "data-name": "Group 61317",
    className: "cls-310",
    transform: "translate(69.979 47.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61316",
    "data-name": "Group 61316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61315",
    "data-name": "Group 61315",
    className: "cls-313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60088",
    "data-name": "Path 60088",
    className: "cls-242",
    d: "M478.5,323.977l-.4.464h.617a.625.625,0,0,0-.216-.464",
    transform: "translate(-478.102 -323.977)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61320",
    "data-name": "Group 61320",
    className: "cls-240",
    transform: "translate(67.082 47.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61319",
    "data-name": "Group 61319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61318",
    "data-name": "Group 61318",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60089",
    "data-name": "Path 60089",
    className: "cls-242",
    d: "M460.541,323.008l-.252-.145a1.634,1.634,0,0,0-.615-.114h-.3c-.587,0-1.064.275-1.064.614s.476.614,1.064.614h.3c.587,0,1.063-.275,1.063-.614a.467.467,0,0,0-.2-.355",
    transform: "translate(-458.31 -322.749)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61324",
    "data-name": "Group 61324",
    transform: "translate(67.082 46.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61323",
    "data-name": "Group 61323",
    className: "cls-315"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22306",
    "data-name": "Rectangle 22306",
    className: "cls-316",
    width: 2.127,
    height: 1.679,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61326",
    "data-name": "Group 61326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61325",
    "data-name": "Group 61325",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60091",
    "data-name": "Path 60091",
    className: "cls-24",
    d: "M459.374,319.665c-.587,0-1.064.275-1.064.614s.476.614,1.064.614,1.063-.275,1.063-.614-.476-.614-1.063-.614",
    transform: "translate(-391.228 -272.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60092",
    "data-name": "Path 60092",
    className: "cls-317",
    d: "M460.021,320.1c-.526,0-.952.246-.952.55s.426.55.952.55.952-.246.952-.55-.426-.55-.952-.55",
    transform: "translate(-391.876 -273.25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61328",
    "data-name": "Group 61328",
    transform: "translate(67.629 46.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61327",
    "data-name": "Group 61327",
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22308",
    "data-name": "Rectangle 22308",
    className: "cls-319",
    width: 1.652,
    height: 1.597,
    transform: "translate(-0.589 0.948) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61349",
    "data-name": "Group 61349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61348",
    "data-name": "Group 61348",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60094",
    "data-name": "Path 60094",
    className: "cls-320",
    d: "M463.465,315.746c.165-.285.431-.439.6-.344s.164.4,0,.688-.432.439-.6.344-.164-.4,0-.688",
    transform: "translate(-395.524 -269.214)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61333",
    "data-name": "Group 61333",
    className: "cls-321",
    transform: "translate(67.193 45.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61332",
    "data-name": "Group 61332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61331",
    "data-name": "Group 61331",
    className: "cls-322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61330",
    "data-name": "Group 61330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61329",
    "data-name": "Group 61329",
    className: "cls-323"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22309",
    "data-name": "Rectangle 22309",
    className: "cls-324",
    width: 1.905,
    height: 2.495,
    transform: "translate(0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61338",
    "data-name": "Group 61338",
    className: "cls-321",
    transform: "translate(67.304 44.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61337",
    "data-name": "Group 61337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61336",
    "data-name": "Group 61336",
    className: "cls-325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61335",
    "data-name": "Group 61335",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61334",
    "data-name": "Group 61334",
    className: "cls-326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22311",
    "data-name": "Rectangle 22311",
    className: "cls-327",
    width: 1.683,
    height: 0.971,
    transform: "translate(0 0)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61341",
    "data-name": "Group 61341",
    className: "cls-321",
    transform: "translate(67.468 44.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61340",
    "data-name": "Group 61340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61339",
    "data-name": "Group 61339",
    className: "cls-328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60097",
    "data-name": "Path 60097",
    className: "cls-329",
    d: "M461.627,307.255c-.374,0-.677.175-.677.391s.3.391.677.391.677-.175.677-.391-.3-.391-.677-.391",
    transform: "translate(-460.95 -307.255)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61344",
    "data-name": "Group 61344",
    className: "cls-310",
    transform: "translate(89.765 35.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61343",
    "data-name": "Group 61343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61342",
    "data-name": "Group 61342",
    className: "cls-330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60098",
    "data-name": "Path 60098",
    className: "cls-242",
    d: "M614.666,244.268l-.895-.516a.376.376,0,0,1,.045.174c0,.228-.215.426-.535.532l.781-.026a1.254,1.254,0,0,0,.6-.164",
    transform: "translate(-613.281 -243.751)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61347",
    "data-name": "Group 61347",
    className: "cls-240",
    transform: "translate(87.871 35.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61346",
    "data-name": "Group 61346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61345",
    "data-name": "Group 61345",
    className: "cls-314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60099",
    "data-name": "Path 60099",
    className: "cls-242",
    d: "M601.408,241.974h.3c.587,0,1.063-.275,1.063-.614a.381.381,0,0,0-.044-.174l-.719-.415a1.8,1.8,0,0,0-.3-.025h-.3c-.587,0-1.063.275-1.063.614s.476.614,1.063.614",
    transform: "translate(-600.345 -240.746)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61351",
    "data-name": "Group 61351",
    transform: "translate(87.871 34.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61350",
    "data-name": "Group 61350",
    className: "cls-331"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22317",
    "data-name": "Rectangle 22317",
    className: "cls-332",
    width: 2.127,
    height: 1.68,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61353",
    "data-name": "Group 61353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61352",
    "data-name": "Group 61352",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60101",
    "data-name": "Path 60101",
    className: "cls-24",
    d: "M601.408,237.661c-.587,0-1.063.275-1.063.614s.476.614,1.063.614,1.063-.275,1.063-.614-.476-.614-1.063-.614",
    transform: "translate(-512.474 -202.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60102",
    "data-name": "Path 60102",
    className: "cls-317",
    d: "M602.056,238.1c-.526,0-.952.246-.952.55s.426.55.952.55.952-.246.952-.55-.426-.55-.952-.55",
    transform: "translate(-513.122 -203.249)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61355",
    "data-name": "Group 61355",
    transform: "translate(88.419 34.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61354",
    "data-name": "Group 61354",
    className: "cls-333"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22319",
    "data-name": "Rectangle 22319",
    className: "cls-334",
    width: 1.652,
    height: 1.597,
    transform: "translate(-0.589 0.948) rotate(-60)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61370",
    "data-name": "Group 61370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61369",
    "data-name": "Group 61369",
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60104",
    "data-name": "Path 60104",
    className: "cls-320",
    d: "M605.5,233.744c.165-.285.431-.439.6-.344s.164.4,0,.688-.432.439-.6.344-.164-.4,0-.688",
    transform: "translate(-516.769 -199.213)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61360",
    "data-name": "Group 61360",
    className: "cls-321",
    transform: "translate(87.982 33.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61359",
    "data-name": "Group 61359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61358",
    "data-name": "Group 61358",
    className: "cls-322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61357",
    "data-name": "Group 61357",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61356",
    "data-name": "Group 61356",
    className: "cls-335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22320",
    "data-name": "Rectangle 22320",
    className: "cls-336",
    width: 1.905,
    height: 2.495
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61365",
    "data-name": "Group 61365",
    className: "cls-321",
    transform: "translate(88.093 32.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61364",
    "data-name": "Group 61364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61363",
    "data-name": "Group 61363",
    className: "cls-337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61362",
    "data-name": "Group 61362",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61361",
    "data-name": "Group 61361",
    className: "cls-338"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22322",
    "data-name": "Rectangle 22322",
    className: "cls-339",
    width: 1.682,
    height: 0.971
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61368",
    "data-name": "Group 61368",
    className: "cls-321",
    transform: "translate(88.258 32.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61367",
    "data-name": "Group 61367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61366",
    "data-name": "Group 61366",
    className: "cls-328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60107",
    "data-name": "Path 60107",
    className: "cls-329",
    d: "M603.662,225.251c-.374,0-.677.175-.677.391s.3.391.677.391.677-.175.677-.391-.3-.391-.677-.391",
    transform: "translate(-602.985 -225.251)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustControl);
export default __webpack_public_path__ + "static/media/DustControl.cf0accc62cb3fba5a3eb7eebde6c35d6.svg";
export { ForwardRef as ReactComponent };